<template>
  <div class="subtle-page">
    <div class="loading-box" v-if="showLoading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 60px" spin />
      </a-spin>
    </div>
    <div class="left-category sortable-stock no-select" ref="sortableStockRef">
      <div
        v-for="(item, index) in showDrawData"
        :key="item.title"
        :data-id="item.title"
      >
        <div
          @click="foldCategory(item)"
          class="category-title overflow-text color-0 flex flex-main--justify flex-cross--center"
          :id="`paiban_surplus_foldCategory_box_${index}`"
        >
          <div class="flex flex-cross--center">
            <a-icon
              class="mb2 mr5"
              :type="item.show ? 'folder-open' : 'folder'"
              style="font-size: 16px"
            />
            <a-tooltip>
              <template slot="title">
                {{ showPartTitle(item) }}
              </template>
              <span class="inline-block ellipsis" style="width: 120px">{{
                showPartTitle(item)
              }}</span>
            </a-tooltip>
          </div>
          <!-- 拖动 -->
          <div v-if="showDrawData.length > 1">
            <a-icon
              type="edit"
              :title="$translateLang('编辑序号')"
              class="mr15"
              v-bp="`layout_sub:assign_category_order`"
              @click.stop="
                handleOpenAdjustBigPlankOrderModal(
                  drawData,
                  item,
                  index,
                  'category'
                )
              "
            />
            <a-icon
              v-bp:mousedown="`layout_sub:drag_category_order`"
              type="menu"
              :title="$translateLang('拖动排序')"
            />
          </div>
        </div>
        <div
          v-show="item.show"
          class="mb10 sortable-plank"
          :data-stock="item.title"
        >
          <div
            :class="[
              'big-part-info  overflow-text flex flex-main--justify flex-cross--center',
              bigPart.show ? 'active-bigpart' : '',
              isBatchPosition ? 'big-part-disable' : '',
            ]"
            v-for="(bigPart, partIndex) in item.data"
            :data-id="bigPart.stockKey + ':' + bigPart._sortNum"
            :key="bigPart.stockKey"
            @mousedown="
              changeBigPart(
                bigPart,
                clacplankIndex(index) + partIndex + 1,
                index,
                true
              )
            "
            :id="`paiban_surplus_drawData_${index}_bigpart_${partIndex}`"
            :title="`${(
              (bigPart.usedRate > 1 ? 1 : bigPart.usedRate) * 100
            ).toFixed(2)}%`"
          >
            <div style="width: 120px" class="ellipsis">
              <span
                >[{{ clacplankIndex(index) + partIndex + 1 }}]
                {{ $t('arrangedPage.rate') }}</span
              >
              <span v-if="bigPart.usedRate"
                >{{
                  ((bigPart.usedRate > 1 ? 1 : bigPart.usedRate) * 100).toFixed(
                    2
                  )
                }}%</span
              >
            </div>
            <div v-if="item.data.length > 1">
              <a-icon
                type="edit"
                style="color: #000"
                :title="$translateLang('编辑序号')"
                class="mr15"
                v-bp="`layout_sub:assign_big_plank_order`"
                @click.stop="
                  handleOpenAdjustBigPlankOrderModal(
                    item.data,
                    bigpart,
                    partIndex,
                    'plank'
                  )
                "
              />
              <a-icon
                v-bp:mousedown="`layout_sub:drag_big_plank_order`"
                type="menu"
                style="color: #000"
                :title="$translateLang('拖动排序')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center-canvas" :style="`max-width: ${canvasWidth}`">
      <div class="top-operation">
        <div class="top-left-operation">
          <a-button @click="goBackPaiban" id="paiban_surplus_goBack_btn">{{
            $t('common.return')
          }}</a-button>
          <a-button
            @click="changeLastBigpart(true)"
            v-show="!isBatchPosition"
            id="paiban_surplus_changeLastBigpart_btn"
          >
            <span class="iconfont icon-left"></span>
          </a-button>
          <a-button
            @click="changeNextBigpart(true)"
            v-show="!isBatchPosition"
            id="paiban_surplus_changeNextBigpart_btn"
          >
            <span class="iconfont icon-right"></span>
          </a-button>
        </div>
        <div class="flex flex-wrap--wrap">
          <new-content :isNewContent="false">
            <a-button
              class="mr10"
              :class="{
                'locked-btn': bigpart.isLocked,
                'is-end': isCuttingSurplus,
              }"
              :disabled="bigpart.isLocked"
              id="paiban_surplus_isCuttingSurplus_btn"
              @click="cutSurplus"
              >{{
                isCuttingSurplus
                  ? translateLang('arrangedPage.subtlePage.cancelCut')
                  : translateLang('arrangedPage.subtlePage.cut')
              }}</a-button
            >
          </new-content>
          <a-button
            class="mr10"
            @click="debounceSaveSurplus"
            id="paiban_surplus_saveSurplus_btn"
            >{{ $t('arrangedPage.saveSurplus') }}</a-button
          >
          <a-button
            v-if="!ncSetting.isPreLayout"
            class="mr10"
            @click="downloadNC"
            id="paiban_surplus_downloadNC_btn"
            :loading="isNCBtnLoading"
            >{{ $t('arrangedPage.downloadNC') }}</a-button
          >
          <a-tooltip v-else :title="$t('preLayoutSetting.backTip')">
            <a-button
              class="mr10"
              id="paiban_surplus_downloadNC_btn"
              :loading="isNCBtnLoading"
              :disabled="true"
              >{{ $t('arrangedPage.downloadNC') }}</a-button
            >
          </a-tooltip>
          <a-button
            v-if="!ncSetting.isPreLayout"
            class="mr10"
            @click="printTag"
            id="paiban_surplus_printTag_btn"
            >{{ $t('main.sideBar.printTag') }}</a-button
          >
          <a-tooltip v-else :title="$t('preLayoutSetting.backTip')">
            <a-button
              class="mr10"
              id="paiban_surplus_printTag_btn"
              :disabled="true"
              >{{ $t('main.sideBar.printTag') }}</a-button
            >
          </a-tooltip>
          <a-button
            class="mr10"
            @click="handlePositionChange"
            :disabled="isCuttingSurplus || bigpart.isLocked"
            id="paiban_surplus_handleBatchPosition_btn"
            >{{ $t('cuttingDock.cuttingParams.setBatchPosition') }}</a-button
          >
          <a-button
            class="top-right-operation"
            @click="saveSubtleChange"
            id="paiban_surplus_saveSurplusPaiban_btn"
            >{{ $t('materialPage.save.title') }}</a-button
          >
        </div>
      </div>
      <div
        class="flex batch-position flex-main--justify flex-cross--center"
        v-if="isBatchPosition"
      >
        <div class="ml8">
          {{
            $t('cuttingDock.cuttingParams.activeBatchPosition', {
              activePartCount: activePartCount + '',
            })
          }}
        </div>
        <div>
          <span>{{ $t('cuttingDock.cuttingParams.setBatchPositionAs') }}</span>
          <a-select
            v-model="defaultPositionPoint"
            id="paiban_surplus_positionPoints_select"
            class="ml8 mr8"
            showArrow
          >
            <a-select-option
              v-for="(item, index) in positionPointsObj"
              :key="item.value"
              :value="item.value"
              :id="`paiban_surplus_positionPoints_option_${index}`"
            >
              {{ $t(item.label) }}
            </a-select-option>
          </a-select>
          <a-button
            class="top-right-operation"
            @click="handleBatchPositionCancel"
            id="paiban_surplus_savePositionPoint_btn"
            >{{ $t('common.cancel') }}</a-button
          >
          <a-button
            class="top-right-operation"
            @click="handleBatchPositionChange"
            id="paiban_surplus_savePositionPoint_btn"
            :disabled="!activePartCount"
            >{{ $t('common.confirm') }}</a-button
          >
        </div>
      </div>
      <div class="surplus-menu absolute l20" v-if="isCuttingSurplus">
        <div class="menu-box align-center border-c-c">
          <div class="menu-title pv2 fs12 color-o-9">
            {{ $t('arrangedPage.subtlePage.cutOperate') }}
          </div>
          <div
            class="pv10 flex flex-cross--center flex-main--center w100"
            :class="surplusCuttingType == 'line' ? 'active' : ''"
            @click="handleSurplusCuttingTypeChange('line')"
          >
            <i class="iconfont icon-xian"></i>
            <!-- 手动描边 -->
            {{ $t('arrangedPage.subtlePage.line') }}

            <a-tooltip
              :title="
                $translateLang('如果手动裁剪有误可以ctrl+z返回上一裁剪点位')
              "
            >
              <img
                src="@/assets/icon/questionMark.png"
                alt=""
                style="width: 17px; height: 17px"
                class="ml3"
              />
            </a-tooltip>
          </div>
          <div
            class="pv10"
            :class="surplusCuttingType == 'rect' ? 'active' : ''"
            @click="handleSurplusCuttingTypeChange('rect')"
          >
            <i
              class="iconfont icon-LableRectangle"
              style="margin-left: -8px"
            ></i>
            {{ $t('common.rect') }}
          </div>
          <!-- 暂时屏蔽 后续会继续开发 -->
          <!-- <div
            class="pv10"
            :class="surplusCuttingType == 'L' ? 'active' : ''"
            @click="handleSurplusCuttingTypeChange('L')"
          >
            L形
          </div> -->
        </div>
        <div v-show="surplusCuttingType == 'line'" class="mt5">
          {{ $t('arrangedPage.subtlePage.cutPoint')
          }}<a-checkbox
            v-model="isAdsorb"
            @click="isAdsorb = !isAdsorb"
            class="surplus-adsorb"
          ></a-checkbox>
        </div>
      </div>
      <div class="canvas-box">
        <canvas
          width="1287"
          height="744"
          ref="subtleCanvas"
          @mousedown="clickCanvas"
          @mouseup="clickUpCanvas"
          @mousemove="movePlank"
          @mousewheel="wheelScale"
          @contextmenu.prevent
        ></canvas>
        <div
          id="line_box"
          :style="{ top: lineRecode.top, left: lineRecode.left }"
          v-show="lineRecode.show"
        >
          <el-input
            size="mini"
            v-model="lineRecode.current"
            @change="dealCurrentLineLength"
            id="paiban_surplus_dealCurrentLine_input"
          ></el-input>
          <span
            >({{ $t('arrangedPage.maxLong') }}{{ lineRecode.maxLine }})</span
          >
        </div>
      </div>

      <div class="user-info">
        <span>{{ userInfo.id }}</span>
      </div>
    </div>
    <div class="right-operation">
      <div class="tag-btn-box">
        <div class="tag" v-if="activePlank == null">
          <div class="no-active">
            <span>{{ $t('arrangedPage.showDetail.tip1') }}</span>
            <span>{{ $t('arrangedPage.showDetail.tip2') }}</span>
          </div>
        </div>
        <div v-else class="plank-info active-plank-box">
          <div class="left-info">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{
                  activePlank._isBujian
                    ? activePlank._bujianOrderNo
                      ? activePlank._bujianOrderNo
                      : activePlank.orderNo
                    : activePlank.orderNo
                }}</span>
              </template>
              <span class="info-eliplise" ref="activePlankAddr"
                >{{ $t('common.orderNo') }}：{{
                  activePlank._isBujian
                    ? activePlank._bujianOrderNo
                      ? activePlank._bujianOrderNo
                      : activePlank.orderNo
                    : activePlank.orderNo
                }}</span
              >
            </a-tooltip>
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{
                  activePlank._isBujian
                    ? activePlank._bujianAddress
                      ? activePlank._bujianAddress
                      : activePlank.address
                    : activePlank.address
                }}</span>
              </template>
              <span class="info-eliplise" ref="activePlankAddr"
                >{{ $t('taskPage.search.orderName') }}：{{
                  activePlank._isBujian
                    ? activePlank._bujianAddress
                      ? activePlank._bujianAddress
                      : activePlank.address
                    : activePlank.address
                }}</span
              >
            </a-tooltip>
            <a-tooltip placement="top">
              <template slot="title">
                <span>
                  {{ $t('common.plankName') }}：
                  {{ activePlank.partName }}
                </span>
              </template>
              <span>
                {{ $t('common.plankName') }}：
                {{ activePlank.partName }}
              </span>
            </a-tooltip>

            <div class="plank-matCode-container">
              <a-tooltip placement="top">
                <template slot="title">
                  <span
                    >{{ $t('common.plankColor') }}：{{ activePlank.thick
                    }}{{
                      dealHighlightMatCode(
                        activePlank._oriMatCode || activePlank.matCode
                      )
                    }}（{{
                      activePlank._oriTexture ||
                      activePlank.oriTexture ||
                      activePlank.texture
                    }}）
                  </span>
                </template>
                <span
                  class="info-eliplise"
                  style="max-with: 210px; width: 210px"
                  ref="activePlankAddr"
                  >{{ $t('common.plankColor') }}：{{ activePlank.thick
                  }}{{
                    dealHighlightMatCode(
                      activePlank._oriMatCode || activePlank.matCode
                    )
                  }}（{{
                    activePlank._oriTexture ||
                    activePlank.oriTexture ||
                    activePlank.texture
                  }}）</span
                >
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span
                    >{{ $t('common.plankNo') }}：{{ activePlank.plankID }}</span
                  >
                </template>
                <span
                  class="info-eliplise"
                  style="
                    max-width: 100px;
                    position: absolute;
                    right: -20px;
                    top: 100px;
                  "
                  >{{ $t('common.plankNo') }}：{{ activePlank.plankID }}
                </span>
              </a-tooltip>
            </div>
            <a-tooltip>
              <template slot="title">
                <span>{{ newEdgeInfo }}</span>
              </template>
              <span class="info-eliplise" ref="activePlankAddr"
                >{{ $t('common.edge.info') }}：{{ newEdgeInfo }}</span
              >
            </a-tooltip>

            <a-tooltip placement="top">
              <template slot="title">
                <span
                  >{{
                    activePlank.srcTexDir !== 'reverse'
                      ? showPartSize('realRect', 'width') -
                        computedRealRectFopEdge().width
                      : showPartSize('realRect', 'height') -
                        computedRealRectFopEdge().height
                  }}*{{
                    activePlank.srcTexDir !== 'reverse'
                      ? showPartSize('realRect', 'height') -
                        computedRealRectFopEdge().height
                      : showPartSize('realRect', 'width') -
                        computedRealRectFopEdge().width
                  }}</span
                >
              </template>
              <span
                >{{ $t('common.cuttingSize') }}：{{
                  activePlank.srcTexDir !== 'reverse'
                    ? showPartSize('realRect', 'width') -
                      computedRealRectFopEdge().width
                    : showPartSize('realRect', 'height') -
                      computedRealRectFopEdge().height
                }}*{{
                  activePlank.srcTexDir !== 'reverse'
                    ? showPartSize('realRect', 'height') -
                      computedRealRectFopEdge().height
                    : showPartSize('realRect', 'width') -
                      computedRealRectFopEdge().width
                }}</span
              >
            </a-tooltip>
            <a-tooltip placement="top">
              <template slot="title">
                <span
                  >{{
                    activePlank.srcTexDir !== 'reverse'
                      ? showPartSize('oRect', 'width')
                      : showPartSize('oRect', 'height')
                  }}*{{
                    activePlank.srcTexDir !== 'reverse'
                      ? showPartSize('oRect', 'height')
                      : showPartSize('oRect', 'width')
                  }}</span
                >
              </template>
              <span
                >{{ $t('common.finishedSize') }}：{{
                  activePlank.srcTexDir !== 'reverse'
                    ? showPartSize('oRect', 'width')
                    : showPartSize('oRect', 'height')
                }}*{{
                  activePlank.srcTexDir !== 'reverse'
                    ? showPartSize('oRect', 'height')
                    : showPartSize('oRect', 'width')
                }}</span
              >
            </a-tooltip>
            <span>{{ $t('common.plankNum') }}：{{ showPlankNum }}</span>
            <a-tooltip placement="top">
              <template slot="title">
                <span
                  >{{ $t('common.plankRemark') }}：{{
                    activePlank.plank_remarks
                  }}</span
                >
              </template>
              <span class="info-eliplise" style="max-width: 190px">
                <span
                  >{{ $t('common.plankRemark') }}：{{
                    activePlank.plank_remarks
                  }}</span
                >
              </span>
            </a-tooltip>
            <a-tooltip
              v-if="activePlank.textureGrainInfo?.groupName"
              placement="top"
            >
              <template slot="title">
                <span
                  >{{ $translateLang('对纹组') }}：{{
                    activePlank.textureGrainInfo.groupName
                  }}</span
                >
              </template>
              <span class="info-eliplise" style="max-width: 190px">
                {{ $translateLang('对纹组') }}：{{
                  activePlank.textureGrainInfo.groupName
                }}
              </span>
            </a-tooltip>
          </div>
          <div class="right-qrcode" id="subtle-qrcode" ref="qrcode"></div>
        </div>
        <!-- 排版堆叠方式,锯切不显示 -->
        <div
          class="stacking-method-box"
          v-if="
            preferencesSetting.paibanWay.replace('_roll', '') === 'paiban_v2'
          "
        >
          <span class="title">{{ $translateLang('排版堆叠方式') }}</span>
          <new-content>
            <a-radio-group
              v-model="stackingMethod"
              name="radioGroup"
              @change="paibanAgain()"
              :disabled="bigpart.isLocked"
            >
              <a-radio value="long" id="paiban_setting_long_radio">
                {{ $translateLang('靠长边排版') }}
              </a-radio>
              <a-radio value="short" id="paiban_setting_short_radio">
                {{ $translateLang('靠短边排版') }}
              </a-radio>
            </a-radio-group>
          </new-content>
        </div>
        <div class="btn">
          <span class="title">{{ $t('arrangedPage.plankOpration') }}</span>
          <div class="operation-btn">
            <a-button @click="changeCutOrder" :disabled="bigpart.isLocked">{{
              $t('arrangedPage.editCutOrder')
            }}</a-button>
            <a-tooltip
              :title="
                paibanWayLimit
                  ? $translateLang('大板被锁定，无法重新排版')
                  : false
              "
            >
              <a-button
                @click="paibanAgain()"
                :disabled="paibanWayLimit || isChangeTrimSide"
                >{{ $t('arrangedPage.reArrange') }}</a-button
              >
            </a-tooltip>
            <a-button
              :disabled="
                bigpart.isLocked ||
                (activePlank == null
                  ? !batchActiveIdList.length
                  : activePlank.isUseSaw) ||
                isBatchPosition ||
                hasExpanded
              "
              id="paiban_surplus_rotatePlank_btn"
              @click="rotatePlank"
              >{{ $t('arrangedPage.rotate') }}</a-button
            >
            <div
              class="cutorigin flex flex-cross--center"
              :class="{
                'cutorigin-active': isCutorigin,
                'cutorigin-disable':
                  !isCutorigin &&
                  (bigpart.isLocked || activePlank == null || isBatchPosition),
                'cursor-not-allowed':
                  bigpart.isLocked || activePlank == null || isBatchPosition,
              }"
              @click="
                showPosition(
                  bigpart.isLocked || activePlank == null || isBatchPosition
                )
              "
              id="paiban_surplus_cutorigin_btn"
            >
              <a-checkbox
                v-model="isCutorigin"
                id="paiban_surplus_cutorigin_checkbox"
                class="ml20 mr5"
                :disabled="isBatchPosition || bigpart.isLocked"
                @click.stop
              ></a-checkbox>
              <span>{{ $t('arrangedPage.setCutPoint') }}</span>
            </div>
            <!-- !!this.activePlank.surplusPath || -->
            <a-button
              class="plank-control-del"
              :disabled="
                bigpart.isLocked ||
                (activePlank == null && !batchActiveIdList.length) ||
                isBatchPosition
              "
              id="subtle_calcCutPositionOrder_btn"
              v-if="!ableRewriteRemarks"
              @click="handleRewriteRemarks"
              >{{ $t('arrangedPage.editRemark') }}</a-button
            >
            <div
              v-if="
                ableRewriteRemarks &&
                !bigpart.isLocked &&
                (activePlank != null || batchActiveIdList.length > 0)
              "
              class="w100"
            >
              <div class="w100">
                <a-textarea
                  :maxLength="50"
                  v-model="plankRemarks"
                  :placeholder="translateLang('arrangedPage.editRemark')"
                ></a-textarea>
                <div class="flex flex-main--justify mt8 mb8">
                  <a-button @click="plankRemarks = ''">{{
                    $t('arrangedPage.clearRemark')
                  }}</a-button>
                  <a-button @click="handleChangeRemarks">{{
                    $t('common.confirm')
                  }}</a-button>
                </div>
              </div>
            </div>
            <!-- 分层切割 -->
            <a-button
              class="plank-control-del"
              id="paiban_special_shap_cut_btn"
            >
              <a-checkbox
                :checked="layerCutChecked"
                :indeterminate="isLayerCutIndeterminate"
                :disabled="
                  isBatchPosition ||
                  bigpart.isLocked ||
                  (!activePlank && !batchActiveIdList.length) ||
                  isMatchedLayeredForPartThick
                "
                id="paiban_special_shape_cut_checkbox"
                @change="handleLayerCut"
                ><span id="paiban_special_shape_cut_checkbox_label">{{
                  $t('cuttingDock.cuttingParams.stepCutting')
                }}</span></a-checkbox
              >
            </a-button>
          </div>
        </div>
      </div>
      <div class="modify-plank" v-if="!showSurplusTemp">
        <div class="nav">
          <span
            :class="{
              active: this.plankActiveNav == 'bujian',
            }"
            @click="changeNav(3)"
            >{{ $translateLang('补件库') }}</span
          >
          <span
            :class="{
              active: this.plankActiveNav == 'zancun',
            }"
            @click="changeNav(1)"
            >{{ $t('arrangedPage.subtlePage.storageArea') }}</span
          >
          <span
            :class="{
              active: this.plankActiveNav == 'fangan',
              'cutorigin-disable': bigpart.isLocked || isChangeTrimSide,
            }"
            @click="changeNav(2)"
            >{{ $t('main.sideBar.paibanResult') }}</span
          >
        </div>
        <div
          class="content-zancun drop-area jinxi-paiban-await-store"
          v-show="plankActiveNav != 'fangan'"
        >
          <!-- <m-plank-store
            ref="storeRef"
            :defaultScale="5"
            :scale="scalePercent"
            :activeBigpart="bigpart"
            page="jinxi"

          ></m-plank-store> -->
          <component
            :is="
              plankActiveNav === 'zancun' ? 'm-plank-store' : 'm-bujian-store'
            "
            ref="storeRef"
            :data="bujianStoreData"
            :loading="bujianStoreLoading"
            :defaultScale="5"
            :scale="scalePercent"
            :activeBigpart="bigpart"
            :keyword="bujianKeyword"
            page="jinxi"
            @onStoreDone="handleAwaitStoreDone"
            @onSearch="handleGetBujianStoreData"
          ></component>
        </div>
        <div class="plan-group" v-show="plankActiveNav == 'fangan'">
          <div
            class="plan-item flex flex-dir--top flex-cross--center cursor-pointer w100"
            v-for="(item, index) in paibanWays"
            :key="index"
            @click="handleChangePaibanWay(item)"
          >
            <span class="mt5"
              >{{ $t('main.sideBar.paibanResult') }}{{ index + 1 }}</span
            >
            <canvas
              :ref="`planCanvasRef${item.canvasIndex}-${index}`"
              style="width: 190px"
            />
          </div>
        </div>
      </div>
      <div class="modify-plank">
        <surPlusTemp
          @dealSurPlusCut="dealSurPlusCut"
          :scalePercent="scalePercent"
          :showSurplusTemp.sync="showSurplusTemp"
        ></surPlusTemp>
      </div>
    </div>
    <div
      v-if="showCutOrign"
      @click="handleCloseCutOrign()"
      id="paiban_surplus_dialog_mask"
      class="origin-dialog-mask"
    >
      <div class="origin-dialog" @click.stop>
        <div class="origin-dialog-title">
          <span>{{ $t('arrangedPage.setCutPoint') }}</span>
          <span
            class="iconfont icon-close"
            @click="handleCloseCutOrign()"
            id="paiban_surplus_iconClose_btn"
          ></span>
        </div>
        <div class="origin-btn">
          <a-button
            :class="selectedCutorigin == 'leftTop' ? 'active' : ''"
            @click="changeCutOrigin('leftTop')"
            >{{ $t('cuttingDock.cuttingParams.topLeftD') }}</a-button
          >
          <a-button
            :class="selectedCutorigin == 'rightTop' ? 'active' : ''"
            @click="changeCutOrigin('rightTop')"
            >{{ $t('cuttingDock.cuttingParams.topRightD') }}</a-button
          >
          <a-button
            :class="selectedCutorigin == 'leftBottom' ? 'active' : ''"
            @click="changeCutOrigin('leftBottom')"
            >{{ $t('cuttingDock.cuttingParams.bottomLeftD') }}</a-button
          >
          <a-button
            :class="selectedCutorigin == 'rightBottom' ? 'active' : ''"
            @click="changeCutOrigin('rightBottom')"
            >{{ $t('cuttingDock.cuttingParams.bottomRightD') }}</a-button
          >
        </div>
        <div class="origin-dialog-btns" v-if="!isCutorigin">
          <div>
            <a-button @click="showPositionChange = false">{{
              $t('common.cancel')
            }}</a-button>
            <a-button @click="confirmChangeCutOrigin">{{
              $t('common.confirm')
            }}</a-button>
          </div>
        </div>
        <div v-else class="pl20 pr18 warning">
          {{ $t('cuttingDock.cuttingParams.setBatchPositionWaring') }}
        </div>
      </div>
    </div>
    <bigpartPriority
      v-if="isChangingPriority"
      :visible.sync="isChangingPriority"
      :bigpart="bigpart"
      :trimSide="trimSide"
      @renderAll="renderAll"
      @changeBigPartPriotity="changeBigPartPriotity"
      @resetPriorityChange="resetPriorityChange"
      @updatePriority="updatePriority"
      @goBackPaiban="goBackPaiban"
    ></bigpartPriority>
    <g-base-modal
      :visible="isShowDeleteDialog"
      v-if="isShowDeleteDialog"
      @ok="handleConfirmDelete"
      @cancel="isShowDeleteDialog = false"
      :contain="deleteConfirmTip"
      :ok-text="translateLang('materialPage.delete.confirm')"
    >
    </g-base-modal>
    <div
      class="fixed p10 bg-dark color-f br4"
      v-show="lockHoverInfo.isShow"
      :style="{
        top: `${lockHoverInfo.top}px`,
        left: `${lockHoverInfo.left}px`,
      }"
    >
      <span v-if="lockHoverInfo.isLocked">
        {{ $t('arrangedPage.lockTip1') }}<br />{{ $t('arrangedPage.lockTip2') }}
      </span>
      <span v-else>
        {{ $t('arrangedPage.unlockTip1') }}<br />{{
          $t('arrangedPage.unlockTip2')
        }}
      </span>
    </div>
    <!-- 余料库容量不足弹窗 -->
    <a-modal
      v-model="showSurStoreTip"
      title="提示"
      centered
      okText="存入余料清单"
      class="sur-store-modal"
      width="450px"
      @ok="handleSaveSurStorage"
    >
      <span>余料库容量不足，余料无法存入仓库</span>
    </a-modal>
    <g-base-modal
      :visible="isShowSubtleInspectCutOrder"
      v-if="isShowSubtleInspectCutOrder"
      :ok-text="translateLang('common.autoAdjust')"
      contain=""
      :disabledOkBtn="bigpart.isLocked"
      :cancel-text="translateLang('arrangedPage.checkDetail')"
      @ok="handleSubtleAutoAdjust"
      @cancel="handleSubtleShowConflictDetail"
    >
      <p>
        {{
          $t('common.cutOrderTip', {
            errorCutOrdersString: errorBigPlankCutOrdersStr,
          })
        }}
      </p>
      <p v-if="bigpart.isLocked">
        {{
          $t('common.lockedCutOrderTip', {
            errorCutOrdersString: errorBigPlankCutOrdersStr,
          })
        }}
      </p>
    </g-base-modal>
    <!-- 查看详情弹窗 -->
    <g-detail-pop
      :isShowPlateDetails.sync="isShowSubtleConflictDetail"
      :fullName="currentSubtleCutOrderName"
      :currentIndex="currentSubtleCutOrderIndex"
      :sourceList="errorCutOrders"
      title="materialPage.overSize.conflictWorkInfo"
      idPrefix="drawAllParts_cutOreder"
      :popStyle="popStyle"
      @clickOperate="handleSubtleOperate"
      @clickGoBack="handleSubtleGoBack"
    >
    </g-detail-pop>
    <!-- 余料入库二次确认弹窗 -->
    <MSurplusSecondConfirm
      :visible="isShowSecondConfirm"
      :surplusConfirmList="surplusConfirmList"
      page="layout_sub"
      @delSecCon="handleDelSecCon"
      @cancel="handleCloseSecCon"
      @ok="handleOKSecCon"
    ></MSurplusSecondConfirm>

    <!-- 异形分层切割深度 -->
    <g-base-modal
      v-if="isShowLayerCutDepthModal"
      :visible="isShowLayerCutDepthModal"
      :showIcon="false"
      :title="translateLang('cuttingDock.cuttingParams.stepCutting')"
      :ok-text="translateLang('common.ok')"
      @ok="handleConfirmLayerCutDepth"
      @cancel="handleCancelLayerCutDepth"
      preffix="paiban_save"
    >
      <div class="flex flex-main--center flex-cross--center">
        <span class="" style="width: fit-content; margin-right: 5px"
          >{{ $t('cuttingDock.cuttingParams.secondDeep') }}:</span
        >
        <div class="flex-box--1">
          <a-input
            v-model="layerCutDepth"
            @input="handleLayerCutDepthInput"
          ></a-input>
        </div>
      </div>
    </g-base-modal>
    <!-- 调整大板顺序 -->
    <g-base-modal
      v-if="adjustBigPlankOrderData.isShowAdjustBigPlankOrderModal"
      :visible="adjustBigPlankOrderData.isShowAdjustBigPlankOrderModal"
      :showIcon="false"
      :title="$translateLang('顺序调整')"
      :ok-text="translateLang('common.ok')"
      @ok="handleConfirmAdjustBigPlankOrder"
      @cancel="adjustBigPlankOrderData.isShowAdjustBigPlankOrderModal = false"
      preffix="paiban_save"
    >
      <span>{{ $translateLang('输入顺序') }}：</span>
      <a-input-number
        style="width: 150px"
        :min="adjustBigPlankOrderData.range[0]"
        :max="adjustBigPlankOrderData.range[1]"
        v-model="adjustBigPlankOrderData.targetIndex"
      ></a-input-number>
      <span class="ml15"
        >{{ $translateLang('范围') }} {{ adjustBigPlankOrderData.range[0] }} ~
        {{ adjustBigPlankOrderData.range[1] }}</span
      >
    </g-base-modal>
  </div>
</template>

<script>
// 锁的icon图
import { surplusLock } from '@/apis/surplusManage/index.ts'
// import LockedImg from '@/assets/jiesuo.png'
// import UnLockedImg from '@/assets/suoding.png'
import GBaseModal from '@/components/g-base-modal.vue'
import GDetailPop from '@/components/g-detail-pop.vue'
import newContent from '@/components/newContent.vue'
import { DrawBigPlankParamsJs, DrawPlankColorJs } from '@/data/plank'
import store from '@/store'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import {
  appendPreMillingToEdgeInfoDisplay,
  cutKnifeRadius,
  dealUnionPathSlots,
  getSawKnife,
  judgeIsMergeFrameDoor,
  rolloverPlank,
} from '@/util/LayoutFuncs'
import { isSawPaiban } from '@/util/LayoutFuncs'
import { addPropForPart, exterPathEdgeForPart } from '@/util/LayoutTool'
import { matchLayeredCutForPalnkThick } from '@/util/LayoutTool'
import { dealExpandSlotForPaiban, rotatePart } from '@/util/LayoutTool.js'
import { dealStockPlankRoll, viewDataToNCData } from '@/util/NCGenerator.js'
import EventBus, { EventBusKey } from '@/util/bus'
import {
  BigPlankDrawer,
  drawOverSizeAreaLabel,
  getPathBySplitXWithClipper,
  getPathBySplitYWithClipper,
} from '@/util/canvas/drawBigPlank'
import { Plank } from '@/util/canvas/drawPlank'
import ClipperLib from '@/util/clipper_unminified.js'
import {
  calculateSlantedRectanglePath,
  dealHighlightMatCode,
  translate,
} from '@/util/commonFun'
import {
  buryPointApi,
  calcClosePlank,
  calcPlankSize,
  generateSimplePlankNum,
  mapGuimenToYPB,
  uniquePlankNum,
} from '@/util/commonFuncs.js'
import {
  compare,
  compareTowNum,
  dealNumber,
  getOriginRect,
  isSamePart,
  toDecimal,
} from '@/util/commonFuncs.js'
import {
  getCounterAxisClearance,
  getCounterValidRange,
  isBoundBoxOutsideCounter,
  isPointOutsideCounter,
} from '@/util/counterLimit'
import {
  checkPathInPlankMerge,
  checkPlankEdgeHasChanged,
} from '@/util/dealPaibanData'
import {
  checkOneBigpart,
  checkOnePlank,
  computeMostRectByLine,
  dealBigPlank,
  dealPaibanData,
  dealPlankPoly,
  getPlateKnifeDiameter,
  isCanvasPixelDrawn,
  paibanDataToView,
} from '@/util/dealPaibanData.js'
import { expandPath } from '@/util/dealPlankDataFuncs'
import {
  dealCurrentPointDistance,
  drawActivePlankOtherInfo,
  drawMarkRectTip,
  drawPlankEmptyDistance,
  drawPlankHSDetailInfo,
  drawSinglePlankTip,
} from '@/util/dealPlankExtraDraw'
import { plankDrawFactory } from '@/util/drawPlank'
import {
  applyLastCutPoint,
  calcBigpartArea,
  checkPointInRect,
  getThroughPathObj,
} from '@/util/drawPlankFuncs.js'
import {
  calcStartPositionBySurplus,
  calcSurplusPosition,
  calcSurplusPositionByStartPosition,
} from '@/util/drawPlankFuncs.js'
import { compareNumbers } from '@/util/graphCalc'
import {
  compositeTexturePlanks,
  forEachTextureChild,
  genLabelTextureGroups,
  getSameGroupParts,
  isTextureAlignmentPlank,
  isVirtualCompositePlank,
  showTextureConfirmModal,
} from '@/util/plankAlignTexture'
import {
  PlankControl,
  checkHasExtendSlot,
  checkPathIsClosed,
  clearPlankToBigPlank,
  closePath,
  dealBigPlankEdgeOffset,
  dealPathToBasePoint,
  getPathMinMaxPoint,
  getPotentialCollisionsParts,
  hasSegmentsIntersection,
  isChangeBigPlankSize,
  isExistPriority,
  isSurplusBigPlank,
  judgePlankPushBigPlank,
  mousePointISInElement,
  partIsConflict,
  plankEdgeTransform,
  simplifyPolygon,
  toUpperPointPath,
} from '@/util/plankCommonFuncs'
import { dealLineSegmentIntersect, polyContain } from '@/util/polygonRelation'
import { regReplaceCuttingParamsInputDepth } from '@/util/regReplace'
import { filterSurplusById } from '@/util/surplus'
import {
  SurplusPayloadBuildError,
  applySpecialShapeMinZeroForUpload,
  buildCutSurplusDepotPayloadItem,
  postProcessSurplusPayloadItems,
} from '@/util/surplusWarehousing'
import {
  cutLShapePart,
  dealChecklistID,
  shouldSkipTailor,
  surplusAutoFill,
  surplusMaxtailor,
} from '@/util/tailorSurplus'
import { cutBlueSurplus, updateBlueAreaSurplusPart } from '@/util/tailorSurplus'
import { toLowerCasePoint, transformPathToLine } from '@/util/transform/graph'
import { transformData } from '@/views/newPaiban/util/transformData'
import { cloneDeep, sortBy } from 'lodash'
import { debounce } from 'lodash'
import { nanoid } from 'nanoid'
import QRCode from 'qrcodejs2'
import Sortable from 'sortablejs'
import { mapMutations, mapState } from 'vuex'

import bigpartPriority from './bigpartPriority.vue'
import MBujianStore from './component/m-bujian-store'
import MPlankStore from './component/m-paiban-store'
import {
  checkCurrentDragPlankDataIsLoad,
  genAwaitStoreData,
  getPlankImage,
} from './component/m-paiban-store/utlis'
import MSurplusSecondConfirm from './component/m-surplus-second-confirm.vue'
import surPlusTemp from './component/surPlusTemp'
import edgeCenterStripMixin from './mixins/edgeCenterStripMixin'
import { getPlankMaxIndexByFinalDrawData } from './util'
import {
  buildBujianQueryKey,
  getBujianParticipationIdsFromPaibanData,
} from './util/bujianData'
import { filterNestedParts } from './util/judgePartInOtherPart'
import {
  clearReuseInfo,
  genBeforeTitleSorts,
  isNeedFanByBigPlank,
  isSpecialBigPlank,
} from './util/layoutDataDeal'

// 默认缩放比例
const defaultScale = 5
// 大板和大板边框的默认偏移值
const defaultDeviation = 5
// 下刀顺序距边的默认距离
const defaultTextWidth = 3
// 记录大板之间的间距
const defaultTopInfoHeight = 33
// 下刀点距边的默认距离
const defaultDotWidth = 5
// 用于防抖
let _debounceTime = null
/** 存储排序元素，因为此数据不需要响应式所以在外部定义 */
const sortableElement = {
  /** 当个类的所有材质大板 */
  stockElArr: [],
  /** 单个大板 */
  plankElArr: [],
}
/** 排序 key，用于后续对比顺序是否发生改变 */
let sortableOrderKeys = []
const BODY = document.querySelector('body')

export default {
  mixins: [edgeCenterStripMixin],
  props: {
    isShowMoveStep: {
      type: Boolean,
      default: false,
    },
    moveStep: {
      type: Number,
      default: 20,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    subtleData: {
      type: [Array, Object],
    },
    isNCBtnLoading: {
      type: Boolean,
      default: false,
    },
    standardPlank: {
      type: Object,
      default: () => ({}),
    },
    baseMaterialData: {
      type: Object,
      default: () => ({}),
    },
    isSpecialShape: {
      type: Boolean,
      default: false,
    },
    nestWay: {
      type: Number,
      default: 1,
    },
    isUnuseSurplus: {
      type: Boolean,
      default: false,
    },
    isShowSubtleInspectCutOrder: {
      type: Boolean,
      default: false,
    },
    errorBigPlankCutOrders: {
      type: Array,
      default: () => [],
    },
    errorCutOrders: {
      type: Array,
      default: () => [],
    },
    currentSubtleCutOrderIndex: {
      type: Number,
      default: 1,
    },
    currentSubtleCutOrderName: {
      type: String,
      default: '',
    },
    checkBigPlankIsRotate: {
      type: Function,
    },
    // /** 设置排版主页面中 drawData 的值 */
    // setDrawData: {
    //   type: Function,
    //   default: () => ({}),
    // },
    /** 排版主页面重绘 */
    renderAllByMain: {
      type: Function,
      default: () => ({}),
    },
    isShowPartSize: {
      type: Boolean,
      default: false,
    },
    isMarkModifiedSmallBoards: {
      type: Boolean,
      default: false,
    },
    isUsePlankAdsorption: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    bigpartPriority,
    surPlusTemp,
    GBaseModal,
    GDetailPop,
    MPlankStore,
    newContent,
    MSurplusSecondConfirm,
    MBujianStore,
  },
  data() {
    return {
      // 是否点击重新排版
      hasReformatFlag: false,
      isLoadDownLoadNc: false,
      isTextureConfirming: false,
      lockHoverInfo: {
        isShow: false,
        top: 0,
        left: 0,
        isLocked: false,
      },
      // UnLockedImgInstance: null,
      // LockedImgInstance: null,
      recordBigpart: '',
      //余料裁剪方式 L rect line
      surplusCuttingType: 'rect',
      // 记录可视窗口缩放事件
      resizeEvent: null,
      // 记录canvas的宽度
      canvasWidth: 0,
      // 记录绘制上下文
      ctx: {},
      // 记录大板长宽
      plankWidth: 0,
      plankHeight: 0,
      // 记录缩放后的长宽
      scaleWidth: 0,
      scaleHeight: 0,
      // 记录大板边框和大板的差值
      deviation: 5,
      dotWidth: 5,
      textWidth: 3,
      // 记录大板顶部信息高度
      topInfoHeight: 33,
      // 记录选中的小板
      activePlank: null,
      // 记录缩放比例
      scalePercent: 1,
      scale: 5,
      // 初始大小
      oriScale: 5,
      // 缩放倍数
      zoomNum: 1,
      // 记录当前大板
      bigpart: {},
      // 记录是否在移动板件
      isMovingPlank: false,
      // 记录是否在拖动画布
      isMovingCavnas: false,
      // 记录鼠标按下时鼠标相对于小板的偏移值
      activePlankOff: null,
      // 记录鼠标按下时, 鼠标位置相对于大板的偏移值
      plankRealOff: null,
      // 记录鼠标按下时, 小板的起始坐标
      plankStartPoint: null,
      // 记录画布拖动时的偏移值
      canvasRightDrag: null,
      // 键盘按下事件
      keyDownEvent: null,
      // 鼠标滚轮事件
      mouseWheelEvent: null,
      // 鼠标松开事件
      mouseupEvent: null,
      // 默认展示暂存区
      plankActiveNav: 'zancun',
      // 记录所有的排版方案
      paibanWays: [],
      // 显示下刀点修改弹窗
      showPositionChange: false,
      // 记录选择的下刀点
      selectedCutorigin: '',
      // 记录是否在修改下刀顺序
      isChangingPriority: false,
      // 是否显示加载
      showLoading: false,
      // 记录深拷贝之后的排版数据
      drawData: [],
      // 是否处于预料裁剪状态
      isCuttingSurplus: false,
      // 是否显示余料模板
      showSurplusTemp: false,
      // 记录所有的余料点位
      surplusPoint: [],
      // 记录计算后的下一个余料点位
      nextPoint: null,
      leftDistance: 0,
      rightDistance: 0,
      upDistance: 0,
      downDistance: 0,
      // 记录当前绘制的余料, 下一条线段是横向还是竖向
      nextDirection: false,
      isActivePlankLine: false,
      // 余料绘制引线信息
      lineRecode: {
        left: 0,
        top: 0,
        maxLine: 0,
        current: 0,
        show: false,
        axle: '',
        e: {},
        recordPoint: {},
      },
      xAxleLeadData: {},
      yAxleLeadData: {},
      isAdsorb: false,
      // 记录玻璃扩张
      glassDilate: 0,
      edgeCenterDistances: null,
      edgeOverlayCanvasOrigin: null,
      // 记录板件空白位置距离
      emptyDistance: false,
      // 记录点击的位置
      mousePoint: null,
      // 当前大板序号
      currentIndex: 1,
      // 节流
      isMessage: true,
      messageTimer: null,
      // 保存孔槽详细信息
      hsDetailInfoList: [],
      // 绘制孔槽详细信息后是否再次绘制,防止过多的重绘
      isRenderHSDetail: false,
      // 是否不翻版
      isNoRoll: false,
      // 是否显示删除弹窗
      isShowDeleteDialog: false,
      // 删除余料小板的modal实例
      deleteSurplusPlankModal: null,
      // 操作板件
      plankControl: null,
      // 冲突板件
      conflictPart: null,
      //记录点击的偏移的起始值
      clickPointOffset: {},
      cutOriginObj: {
        leftTop: '左上角',
        rightTop: '右上角',
        leftBottom: '左下角',
        rightBottom: '右下角',
      },
      ableRewriteRemarks: false,
      plankRemarks: '',
      // 余料库容量不足弹窗显示
      showSurStoreTip: false,
      storeRef: null,
      // 待排版库本地数据进入精细排版记录的id
      awaitLocalPlankStoreIds: [],
      // 待排版库远程数据进入精细排版记录的显示的id
      awaitServePlankStoreIds: [],
      // 待排版库在页面上入库板件partuniqueId
      awaitParticipationPaibanPlank: [],
      // 是否批量修改下刀点
      isBatchPosition: false,
      // 复选（Ctrl 多选）小板：是否处于复选状态
      isBatchActive: false,
      // 复选（Ctrl 多选）选中的小板 partUniqueId 列表
      batchActiveIdList: [],
      positionPointsObj: [
        {
          label: 'cuttingDock.cuttingParams.topLeftD',
          value: 'leftTop',
        },
        {
          label: 'cuttingDock.cuttingParams.bottomLeftD',
          value: 'leftBottom',
        },
        {
          label: 'cuttingDock.cuttingParams.topRightD',
          value: 'rightTop',
        },
        {
          label: 'cuttingDock.cuttingParams.bottomRightD',
          value: 'rightBottom',
        },
      ],
      defaultPositionPoint: 'rightBottom',
      // 右侧设置下刀点状态
      isCutorigin: false,
      //已选择的小板数量
      activePartCount: 0,
      // 切割顺序查看详情弹窗
      isShowSubtleConflictDetail: false,
      // 当前展示的板件名称
      // currentSubtleCutOrderName: '',
      // // 当前展示的板件index(默认展示第一个)
      // currentSubtleCutOrderIndex: 1,
      // 弹窗展示位置调整
      popStyle: {
        top: '90px',
        left: '51%',
      },
      // 当前操作对象
      currentSubtleOperate: 'nc',
      trimSide: '',
      isChangeTrimSide: false,
      // 记录标记位置
      needMarkRectArr: [],
      // 记录标记位置
      markRectTip: null,
      // 绘制单面板 tip
      singlePlankTip: null,
      // 余料入库二次确认弹窗
      isShowSecondConfirm: false,
      surplusConfirmList: [],
      // 异形板件分层切割
      isLayerCut: false,
      layerCutDepth: 2,

      isShowLayerCutDepthModal: false,
      /** 手动输入调整大板顺序所需数据 */
      adjustBigPlankOrderData: {
        /** 大板顺序调整弹窗是否显示 */
        isShowAdjustBigPlankOrderModal: false,
        /** 绘制组数据 */
        categorys: [],
        /** 大板数据 */
        planks: [],
        /** 需要调整顺序的数据 */
        target: null,
        /** 目标大板序号 */
        targetIndex: 0,
        /** 之前的位置 */
        beforeIndex: 0,
        /** 当次排序目标 plank 大板 category 绘制组 */
        type: 'plank',
        /** 调整范围 */
        range: [0, 0],
      },
      blueAreaSurplusData: [], // 余料手动裁剪的蓝色余料区域暂存区
      blueAreaSurplusCaches: [], // 小于高度是的缓存区
      changeCutKnifePointCaches: [], // 修改下刀点时的缓存区
      currentBujianColorTextureThickStr: '',
      bujianKeyword: '',
    }
  },
  computed: {
    ...mapState([
      'finalDrawData',
      'ncSetting',
      'tempStorage',
      'finalStorage',
      'paibanData',
      'orderInfo',
      'userInfo',
      'supplusIndex',
      'specialPlankParams',
      'isDragingPlank',
      'beDraggedPlank',
      'surplusCommonSize',
      'surplusTailorWay',
      'surplusAutoTailor',
      'activePaibanWay',
      'plankLableId',
      'isSurplusNoRoll',
      'preLayoutData',
      'selectStandardPlank',
      'customPlankOrder',
      'plankOrderList',
      'surplusParams',
      'isHistoryStatus',
    ]),
    bujianQueryKey() {
      return buildBujianQueryKey({
        colorTextureThickStr: this.currentBujianColorTextureThickStr,
        filterWord: this.bujianKeyword,
        pageScope: 'jinxi',
      })
    },
    bujianStoreData() {
      // 让补件删除/回退后 participation 变化能够稳定触发列表重算
      const participationVersion =
        this.$store.state.bujianStore?.participationVersion ?? 0
      return participationVersion >= 0
        ? this.$store.getters['bujianStore/getVisibleBujianList'](
            this.bujianQueryKey
          )
        : []
    },
    bujianStoreLoading() {
      return this.$store.getters['bujianStore/getLoadingByQueryKey'](
        this.bujianQueryKey
      )
    },
    paibanWayLimit() {
      return this.bigpart.isLocked
    },
    hasExpanded() {
      return this.activePlank && this.activePlank.isExpanded
    },
    showPlankNum() {
      let str = this.activePlank.oriPlankNum
      if (this.ncSetting.genSimpleLabelBarcode) {
        str = this.activePlank.simplePlankNum ?? ''
      }
      return str
    },
    showCutOrign() {
      return this.showPositionChange || (this.isCutorigin && this.activePlank)
    },

    finalBigPart() {
      const data = cloneDeep(this.bigpart)
      delete data.subLockStartX
      delete data.subLockStartY
      delete data.subLockWH
      return data
    },
    isHighPlank() {
      return this.bigpart?.parts[0]?.is_high_gloss_plank
    },
    errorBigPlankCutOrdersStr() {
      this.errorBigPlankCutOrders.sort((a, b) => a - b)
      return this.errorBigPlankCutOrders.join('、')
    },
    // 当前小板所在大板是否满足不同板厚分层切割
    isMatchedLayeredForPartThick() {
      // 复选时按选中的全部小板判断
      if (this.batchActiveIdList.length) {
        return this.getBatchActiveParts().some((part) =>
          matchLayeredCutForPalnkThick(part)
        )
      }
      return matchLayeredCutForPalnkThick(this.activePlank)
    },
    /** 复选的小板分层切割勾选状态：all=全部开启，part=部分开启（非全选），none=都未开启 */
    batchLayerCutState() {
      if (!this.batchActiveIdList.length) return 'none'
      const parts = this.getBatchActiveParts()
      if (!parts.length) return 'none'
      const checkedCount = parts.filter((part) =>
        this.isPartLayerCut(part)
      ).length
      if (!checkedCount) return 'none'
      return checkedCount === parts.length ? 'all' : 'part'
    },
    /** 分层切割复选框回显：单板取激活板件，复选取全部选中小板是否都开启 */
    layerCutChecked() {
      if (this.batchActiveIdList.length) {
        return this.batchLayerCutState === 'all'
      }
      return this.isLayerCut
    },
    /** 分层切割复选框是否处于非全选（半选）状态 */
    isLayerCutIndeterminate() {
      return (
        this.batchActiveIdList.length > 0 && this.batchLayerCutState === 'part'
      )
    },
    // 删除确认弹窗文案（复选时提示删除的小板数量）
    deleteConfirmTip() {
      if (this.batchActiveIdList.length) {
        return this.$translateLang(
          `确定删除选中的 ${this.batchActiveIdList.length} 块小板吗？`
        )
      }
      return this.$t(
        this.activePlank?._isBujian
          ? 'common.confirmDeleteBujianTip'
          : 'common.confirmDeleteTip'
      )
    },
    /** 是否禁止重新排版 */
    isDisableReArrange() {
      let flag = false
      return flag
    },
    newEdgeInfo() {
      if (!this.activePlank?.edgeInfo) {
        return ''
      }
      return appendPreMillingToEdgeInfoDisplay(
        this.activePlank.edgeInfo,
        this.activePlank.edgePreMillingInfo
      )
    },
    showDrawData() {
      return this.drawData.filter((data) => !data.isDesMaterialNoCut)
    },
    stackingMethod: {
      get() {
        return this.bigpart.stackingMethod || 'short'
      },
      set(value) {
        if (this.isRotateBigPlank()) {
          return
        }
        this.bigpart.stackingMethod = value
      },
    },
    preferencesSetting() {
      return this.$store.state.preferencesSetting?.setting ?? {}
    },
  },
  methods: {
    ...mapMutations([
      'setFinalDrawData',
      'setPaibanData',
      'deleteTempStorage',
      'changeDragingPlank',
      'addTempStorage',
      'setSupplusIndex',
      'changeTempStorage',
      'setTempImgPos',
      'recordBeDraggedPlank',
      'deleteFinalStorage',
      'addFinalStorage',
      'resetTempStorage',
      'setPlankLableId',
      'setIsPrintTag',
      'setChangePaiban',
      'setHistorySecondTrimValue',
      'setHistoryPlankEdgeOff',
      'setPreLayoutData',
      'setBatchTaggingList',
      'setBeforeTitleSorts',
    ]),
    translateLang(key) {
      return translate(key)
    },
    checkHasExtendSlot(plank) {
      return plank.parts ? checkHasExtendSlot(plank) : false
    },
    showPartTitle(item) {
      return `${item.thick}${this.dealHighlightMatCode(item.matCode)}(${
        item.texture
      })-${item.data?.length ?? 0}`
    },
    //余料裁剪方式改变
    handleSurplusCuttingTypeChange(type) {
      this.surplusCuttingType = type
      this.surplusPoint = [] //所有余料的点位
      this.nextPoint = null //计算后的下一个余料点位
      this.lineRecode.show = false
      this.renderAll()
      if (type == 'line') {
        buryPointApi('layout_sub', 'surplus_cut_line')
      } else if (type == 'rect') {
        buryPointApi('layout_sub', 'surplus_cut_rect')
      }
    },
    // 计算板件序号
    clacplankIndex(i) {
      let index = 0
      for (let j = 0; j < i; j++) {
        index += this.drawData[j].data.length
      }
      return index
    },
    // 返回排版页面
    goBackPaiban() {
      this.bigpart.isActive = true
      // 这里也需要恢复蓝色余料区域暂存区
      if (
        this.bigpart.parts.some((item) => !item.blueAreaSurplus) &&
        this.changeCutKnifePointCaches
      ) {
        this.bigpart.parts = [
          ...this.bigpart.parts,
          ...this.changeCutKnifePointCaches,
        ]
        this.changeCutKnifePointCaches = []
      }
      const { isChange, isPartsChange } = this.isPlankChange()
      if (isChange) {
        this.$confirm(
          translate('arrangedPage.subtleSaveTip'),
          translate('common.tip'),
          {
            confirmButtonText: translate('common.confirm'),
            cancelButtonText: translate('common.cancel'),
            type: 'warning',
          }
        )
          .then(() => {
            // 恢复暂存区数据
            this.recoverAwaitStoreData()
            this.isCuttingSurplus = false
            this.isAdsorb = false
            this.setChangePaiban(false)
            // 直接清除当前大板的复用信息
            if (isPartsChange) {
              clearReuseInfo(this.bigpart, this.$store.state.paibanData)
            }
            this.$emit('getBigPart', this.bigpart)
            this.$emit('update:visible', false)
            this.$emit('onClose')
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        this.isCuttingSurplus = false
        this.isAdsorb = false
        this.$emit('getBigPart', this.bigpart)
        this.$emit('update:visible', false)
        this.$emit('onClose')
      }
    },
    /** 当前板件相对于进入时是否发生了数据上的变化 */
    isPlankChange() {
      const finalBigPart = cloneDeep(this.finalBigPart)
      // finalBigPart.parts 删除意义不明的newRectInd字段 点击过重新排版的时候不删除
      if (!this.hasReformatFlag) {
        finalBigPart.parts.forEach((part) => {
          delete part.newRectInd
        })
      }
      const isPartsChange =
        JSON.stringify(this.recordBigpart.parts) ===
        JSON.stringify(finalBigPart.parts)
      const isChangeLocked =
        this.recordBigpart.isLocked === finalBigPart.isLocked
      const isSort = this.isSyncSortableData()
      return {
        isPartsChange: !isPartsChange,
        isChangeLocked,
        isSort,
        isChange: !isPartsChange || !isChangeLocked || isSort,
      }
    },
    // 处理左侧目录栏数据
    dealCategory() {
      let arr = this.drawData
      for (let i = 0; i < arr.length; ++i) {
        arr[i].show = true
        for (let k = 0; k < arr[i].data.length; ++k) {
          arr[i].data[k].show = false
          if (
            arr[i].data[k].stockKey == this.subtleData.stockKey &&
            arr[i].data[k].canvasIndex == this.subtleData.canvasIndex
          ) {
            arr[i].data[k].show = true
          }
        }
      }
      this.$forceUpdate()
    },
    // 展开关闭左侧目录
    foldCategory(item) {
      let arr = this.drawData
      for (let i = 0; i < arr.length; ++i) {
        if (arr[i].title == item.title) {
          item.show = !item.show
        }
      }
      this.$forceUpdate()
    },
    // 切换大板
    changeBigPart(item, index, bigpartIndex, isNotClickCanvas) {
      // 在批量修改下刀点状态下不能切换大板
      if (this.isBatchPosition) return
      let arr = this.drawData
      this.currentIndex = index
      this.plankActiveNav =
        this.$store.state.preferencesSetting?.setting?.layoutStoreType ===
        'bujianStore'
          ? 'bujian'
          : 'zancun'
      for (let i = 0; i < arr.length; ++i) {
        if (bigpartIndex && bigpartIndex === i) {
          arr[i].show = true
        }

        for (let k = 0; k < arr[i].data.length; ++k) {
          arr[i].data[k].show = false
        }
      }
      this.$forceUpdate()

      item.subtleStartX = 500
      item.subtleStartY = 100
      item.show = true
      this.bigpart = item
      this.activePlank = null
      this.resetSubtleSize(this.bigpart)
      if (this.plankActiveNav == 'fangan') {
        this.paibanAgain(true, 'changeBigPart')
      }
      this.$emit('changeBigpart', this.bigpart)
      this.clickCanvas(event, isNotClickCanvas)
      this.renderAll()
    },
    // 切换上一个大板
    changeLastBigpart(e, isNotClickCanvas) {
      let arr = this.drawData
      let newBigpart = {}
      for (let i = 0; i < arr.length; ++i) {
        let data = arr[i].data
        let flag = false
        for (let k = 0; k < data.length; ++k) {
          let bigpart = data[k]
          if (bigpart.show) {
            bigpart.show = false
            if (k != 0) {
              data[k - 1].show = true
              newBigpart = data[k - 1]
              flag = true
              break
            } else {
              let newData = []
              if (i != 0) {
                newData = arr[i - 1].data
              } else {
                newData = arr[arr.length - 1].data
              }
              newBigpart = newData[newData.length - 1]
              newBigpart.show = true
              flag = true
              break
            }
          }
        }
        if (flag) break
      }
      this.resetSubtleSize(newBigpart)
      newBigpart.subtleStartX = 500
      newBigpart.subtleStartY = 100
      this.bigpart = newBigpart
      // 切换大板后清空复选选区
      this.batchActiveIdList = []
      this.$forceUpdate()
      if (this.plankActiveNav == 'fangan') {
        this.paibanAgain(true, 'changeBigPart')
      }
      this.$emit('changeBigpart', this.bigpart)
      this.clickCanvas(e, isNotClickCanvas)
      this.renderAll()
    },
    // 切换下一个大板
    changeNextBigpart(e, isNotClickCanvas) {
      let arr = this.drawData
      let newBigpart = {}
      for (let i = 0; i < arr.length; ++i) {
        let data = arr[i].data
        let flag = false
        for (let k = 0; k < data.length; ++k) {
          let bigpart = data[k]
          if (bigpart.show) {
            bigpart.show = false
            if (k != data.length - 1) {
              data[k + 1].show = true
              newBigpart = data[k + 1]
              flag = true
              break
            } else {
              let newData = []
              if (i != arr.length - 1) {
                newData = arr[i + 1].data
              } else {
                newData = arr[0].data
              }
              newBigpart = newData[0]
              newBigpart.show = true
              flag = true
              break
            }
          }
        }
        if (flag) break
      }
      this.resetSubtleSize(newBigpart)
      newBigpart.subtleStartX = 500
      newBigpart.subtleStartY = 100
      this.bigpart = newBigpart
      // 切换大板后清空复选选区
      this.batchActiveIdList = []
      this.$forceUpdate()
      this.clickCanvas(e, isNotClickCanvas)
      this.renderAll()
      if (this.plankActiveNav == 'fangan') {
        this.paibanAgain(true, 'changeBigPart')
      }
      this.$emit('changeBigpart', this.bigpart)
    },

    // 判断大板是否可以进行正反切换
    judgeAbleFanban(bigpart) {
      let toggleFlag = false
      for (let k = 0; k < bigpart.parts.length; ++k) {
        let plank = bigpart.parts[k]
        let slotBackFlag = plank.slots?.some((v) => v.side == -1)
        let holeBackFlag = plank.holes?.some((v) => v.side == -1)
        let curveHoles = plank.curveHoles?.some((v) => v.side == -1)
        let millInfo
        if (plank.millInfo) {
          millInfo = plank.millInfo?.some((v) => v.side == -1)
        }
        let handleSlope
        if (plank.handleSlopes) {
          handleSlope = plank.handleSlopes.some((v) => v.side == -1)
        }

        if (
          slotBackFlag ||
          holeBackFlag ||
          curveHoles ||
          millInfo ||
          handleSlope
        ) {
          toggleFlag = true
          break
        }
      }
      // 通孔通槽双面加工，大板显示正反
      const holeArr = bigpart.parts
        .filter((p) => p.specialType !== 'supplus')
        .map((part) => [
          ...part.holes,
          // ...(part.curveHoles ? part.curveHoles : []),
        ])
      const slotArr = bigpart.parts
        .filter((p) => p.specialType !== 'supplus')
        .map((part) => [
          ...part.slots,
          ...(part.millInfo ? part.millInfo : []),
          ...(part.handleSlopes ?? []),
        ])
      const holeToggle = holeArr
        .flat(1)
        .some((v) => v.deep * 1 + 0.001 >= bigpart.thick)
      const slotToggle = slotArr
        .flat(1)
        .some((v) => v.deep * 1 + 0.001 >= bigpart.thick)
      bigpart.ableToggle =
        toggleFlag ||
        (this.ncSetting.throughTowSideToCut && holeToggle) ||
        (this.ncSetting.through_slot_two_side_cut && slotToggle)
    },
    // 初始化点位数据用于预料吸附和引线
    initBigPlanDeal() {
      this.xAxleLeadData = {}
      this.yAxleLeadData = {}
      this.bigpart.parts.forEach((item) => {
        item.polyArr[0].forEach((item) => {
          // 将0-2400 0-1200 划成100个为一组的对象，方便查找，防止卡顿
          const xKey = `X${Math.ceil(item.X / 100)}`
          const yKey = `Y${Math.ceil(item.Y / 100)}`
          if (!this.xAxleLeadData[xKey]) {
            this.xAxleLeadData[xKey] = []
          }
          if (!this.yAxleLeadData[yKey]) {
            this.yAxleLeadData[yKey] = []
          }
          this.xAxleLeadData[xKey].push({ ...item })
          this.yAxleLeadData[yKey].push({ ...item })
        })
      })
    },
    // 切换暂存区和排版方案
    changeNav(type) {
      if (type == 2) {
        if (this.bigpart.isLocked) {
          return
        }
        if (this.isChangeTrimSide) {
          return
        }
        this.plankActiveNav = 'fangan'
        this.paibanAgain(true)
        buryPointApi('layout_sub', 'layout_plan')
      } else if (type == 1) {
        this.plankActiveNav = 'zancun'
        buryPointApi('layout_sub', 'await_store')
        updateLocalPreference({
          layoutStoreType: 'awaitStore',
        })
      } else {
        this.plankActiveNav = 'bujian'
        buryPointApi('layout_sub', 'bujian_store')
        updateLocalPreference({
          layoutStoreType: 'bujianStore',
        })
      }
    },
    // 修改切割顺序
    changeCutOrder() {
      this.batchActiveIdList = []
      buryPointApi('layout_sub', 'modify_cut_order')
      if (this.bigpart.parts.some((item) => item.blueAreaSurplus)) {
        // 暂存蓝色余料数据，不参与切割顺序的修改
        this.changeCutKnifePointCaches = this.bigpart.parts.filter(
          (item) => item.blueAreaSurplus
        )
        this.bigpart.parts = this.bigpart.parts.filter(
          (item) => !item.blueAreaSurplus
        )
      }
      this.isChangingPriority = true
      this.isBatchPosition = false
      this.isCuttingSurplus = false
    },
    changeBigPartPriotity(part, num) {
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        if (
          this.bigpart.parts[i].index == part.index &&
          this.bigpart.parts[i].plankID == part.plankID &&
          this.bigpart.parts[i].partUniqueId == part.partUniqueId
        ) {
          this.bigpart.parts[i].showPriority = num
          break
        }
      }
    },
    // 重置切割顺序的更改
    resetPriorityChange() {
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        if (this.bigpart.parts[i].showPriority) {
          delete this.bigpart.parts[i].showPriority
        }
      }
      // 恢复暂存区的内容
      if (this.changeCutKnifePointCaches.length) {
        this.bigpart.parts = [
          ...this.bigpart.parts,
          ...this.changeCutKnifePointCaches,
        ]
        this.changeCutKnifePointCaches = []
      }
    },
    // 确认修改
    updatePriority() {
      const oriBigpart = JSON.parse(JSON.stringify(this.bigpart))
      this.isChangingPriority = false
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        this.bigpart.parts[i].priority = this.bigpart.parts[i].showPriority
        delete this.bigpart.parts[i].showPriority
      }

      // 恢复数据
      if (
        this.bigpart.parts.some((item) => !item.blueAreaSurplus) &&
        this.changeCutKnifePointCaches
      ) {
        this.bigpart.parts = [
          ...this.bigpart.parts,
          ...this.changeCutKnifePointCaches,
        ]
        this.changeCutKnifePointCaches = []
      }
      this.renderAll()
      // 关闭弹窗 这里修改的切割顺序只有对的才能成功保存，所以直接关闭弹窗
      this.isShowSubtleConflictDetail = false
      // this.$nextTick(() => {
      //   this.calcCutPositionOrder(this.bigpart, true)
      // })

      this.$emit('recordUpdatePriority', {
        key: `精细排版修改切割顺序-大板序号：${this.bigpart.canvasIndex}`,
        dataArr: this.bigpart.parts.map((part, index) => {
          return {
            type: 'form',
            current: {
              priority: part?.priority,
            }, // 当前表单数据
            ori: {
              priority: oriBigpart.parts[index]?.priority,
            }, // 原始表单数据
            compareMsg: [
              {
                title: part.partName,
                keys: ['priority'],
              },
            ], // 要比较的内容
            formTextObj: {
              priority: '切割顺序',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          }
        }),
      })
    },
    async paibanAgain(needMorePlan, changeBigPart) {
      // 记得异形余料上了后删除此逻辑
      if (this.isRotateBigPlank()) {
        return
      }
      if (!needMorePlan) {
        this.bigpart.parts = this.bigpart.parts.filter(
          (p) => !p.blueAreaSurplus
        )
      }
      if (!changeBigPart) {
        const hasChanged = await checkPlankEdgeHasChanged(this.baseMaterialData)
        if (!hasChanged) return
      }
      this.paibanWays = []
      buryPointApi('layout_sub', 'reload_layout')
      this.showLoading = true
      this.setChangePaiban(true)
      const cloneBigPart = cloneDeep(
        this.bigpart.parts.filter(
          (p) => !p.blueAreaSurplus && p.specialType !== 'supplus'
        )
      )

      // 剔除余料
      let cloneBigPartData = cloneDeep({
          ...this.bigpart,
          parts: cloneBigPart,
        }),
        oriData
      if (needMorePlan) {
        oriData = [cloneBigPartData]
      } else {
        // 标记点击过重新排版
        this.hasReformatFlag = true
        this.bigpart.parts = this.bigpart.parts.filter(
          (part) => part.specialType !== 'supplus'
        )
        // oriData = [this.bigpart]
        oriData = [cloneDeep({ ...this.bigpart, parts: cloneBigPart })]
      }

      oriData.forEach((stockData) => {
        if (stockData.hasAutoRollOver) {
          dealStockPlankRoll(stockData)
        }
      })
      if (this.ncSetting.xyReverse) {
        oriData = viewDataToNCData(oriData, 'toView')
      }
      let rectInd = 1
      let arr = oriData[0].parts
      let rectMap = []
      let title = `${this.bigpart.texture}:${this.bigpart.matCode}:${this.bigpart.thick}`
      const sawToLayout =
        this.$store.state.ncSetting.sawSetting.mentaoji_enable &&
        this.$store.state.ncSetting.sawSetting.sawToLayout &&
        isSawPaiban(this.$store) &&
        this.$store.state.ncSetting.sawSetting.processType === 'weldingPlank'
      const sawCutOnlyWeld =
        this.$store.state.ncSetting.sawSetting.sawCutOnlyWeld &&
        this.$store.state.ncSetting.sawSetting.processType === 'weldingPlank'
      const isSurNotLayoutMat =
        this.$store.state.preferencesSetting?.setting?.isSurNotLayoutMat
      const isSurNotLayout =
        this.$store.state.preferencesSetting?.setting?.isSurNotLayout
      const realSurNotLayout = isSurNotLayout && isSurNotLayoutMat
      const plankNames =
        this.$store.state.preferencesSetting?.setting?.plankNames

      const allParts = this.bigpart.parts.filter(
        (p) => !p.blueAreaSurplus && p.specialType !== 'supplus'
      )
      const layoutCtx = {
        sawToLayout,
        sawCutOnlyWeld,
        realSurNotLayout,
        plankNames,
      }
      const partsForLayout = []
      for (let i = 0; i < allParts.length; ++i) {
        const part = allParts[i]
        const oriPart =
          arr.find((p) => p.partUniqueId === part.partUniqueId) ?? arr[i]
        exterPathEdgeForPart(oriPart)
        const cutD = part.isUseSaw
          ? getSawKnife(this.ncSetting)
          : getPlateKnifeDiameter(title, this.ncSetting)
        try {
          oriPart.finalExtendDisMap = dealExpandSlotForPaiban(
            oriPart,
            this.ncSetting,
            Number(cutD) / 2
          )
          part.finalExtendDisMap = oriPart.finalExtendDisMap
        } catch (error) {
          this.$message.error(
            error.message || '槽扩板计算失败，请在开料清单页面重新排版'
          )
          return
        }
        oriPart._curve_layered_cutting = part.curve_layered_cutting
        oriPart._curve_layered_cutting_deep = part.curve_layered_cutting_deep

        const expandedX = oriPart.finalExtendDisMap
          ? oriPart.finalExtendDisMap.left + oriPart.finalExtendDisMap.right
          : 0
        const expandedY = oriPart.finalExtendDisMap
          ? oriPart.finalExtendDisMap.top + oriPart.finalExtendDisMap.bottom
          : 0
        if (expandedX || expandedY) {
          oriPart.expandRect = {
            ...oriPart.rect,
            width: oriPart.rect.width + expandedX,
            height: oriPart.rect.height + expandedY,
          }
          part.expandRect = oriPart.expandRect
        }
        partsForLayout.push(oriPart)
      }
      const layoutGap = this.ncSetting.panelSize?.layoutGap ?? 0
      const compositedParts = compositeTexturePlanks(
        partsForLayout,
        layoutGap,
        true,
        true,
        this.ncSetting?.decimal ?? 2,
        true
      )
      compositedParts.forEach((part) => {
        rectMap.push(this.buildSubtlePlankParamForPaiban(part, layoutCtx))
      })
      arr = []
      rectInd = 1
      compositedParts.forEach((part) => {
        if (isVirtualCompositePlank(part)) {
          for (const child of part._virtualCompositePlanks ?? []) {
            child.rectInd = rectInd
            arr.push(child)
            const bp = this.bigpart.parts.find(
              (p) => p.partUniqueId === child.partUniqueId
            )
            if (bp) {
              bp.newRectInd = rectInd
            }
            rectInd++
          }
        } else {
          part.rectInd = rectInd
          arr.push(part)
          const bp = this.bigpart.parts.find(
            (p) => p.partUniqueId === part.partUniqueId
          )
          if (bp) {
            bp.newRectInd = rectInd
          }
          rectInd++
        }
      })
      if (!rectMap.length) {
        this.$message.error('已无可用小板（余料除外），不支持重新排版')
        this.showLoading = false
        this.bigpart.parts = cloneBigPart.filter(
          (item) => item.specialType == 'supplus'
        )
        return
      }
      let layoutRectMap = {}

      layoutRectMap[title] = rectMap
      const diameter = +getPlateKnifeDiameter(
        this.bigpart.stockKey,
        this.ncSetting
      )
      const sawKnife = getSawKnife(this.ncSetting)
      const { plankWidth, plankHeight } = this.getPaibanPlankSize(oriData[0])
      const isDoorFrame =
        this.ncSetting.sawSetting?.mentaoji_enable &&
        this.ncSetting.sawSetting?.processType === 'doorFrame' &&
        isSawPaiban(this.$store)
      let ncConfig = {
        stationWidth: this.ncSetting.counter_width,
        stationLimitable: this.ncSetting.counter_limit_able,
        changeKnifePosition: this.ncSetting.xyReverse ? true : false,
        decimal: this.ncSetting.decimal,
        gap: isDoorFrame ? 0 : this.ncSetting.panelSize.layoutGap,
        knifeR: diameter / 2,
        sawKnifeR: sawKnife / 2,
        outHeight: plankHeight,
        outWidth: plankWidth,
        startPosition: this.ncSetting.startPosition,
        margin: this.standardPlank.plankEdgeOff,
        xyReverse: this.ncSetting.xyReverse ? 1 : 0,
        surplus_no_roll: this.isSurplusNoRoll,
        nesting_version: this.nestWay,
        sortByHeight: this.ncSetting.sawSetting.sortByHeight,
        colorMap: Object.keys(store.state.materialListStore.colorMap).length
          ? store.state.materialListStore.colorMap
          : null,
        isSurNotLayoutMat: realSurNotLayout,
        stacking_method: this.bigpart.stackingMethod || 'short',
      }
      // 大板尺寸是否被修改
      const isChangePlankSize = isChangeBigPlankSize(
        this.standardPlank,
        oriData[0]
      )
      const isSpecialPlank = isSpecialBigPlank(oriData[0])
      // 精细排版中始终都会使用这一块大板来重排，那么特殊大板的情况下，直接认为它是默认选用的，强制让算法使用这张板来排
      if (!isChangePlankSize) {
        if (isSpecialPlank) {
          const {
            texture,
            matCode,
            thick,
            otherPlate: { width, height, margin },
          } = oriData[0]
          const edge = plankEdgeTransform(margin)
          let key = `${texture}:${matCode}:${thick}`
          ncConfig.outSizeMap = {
            [key]: {
              width,
              height,
              trim_edge: edge,
            },
          }
        }
      }
      ncConfig.processType = this.ncSetting.sawSetting.processType
      ncConfig.sameWidthPlank =
        this.ncSetting.sawSetting.sameWidthPlank &&
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.sawToLayout &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      ncConfig.sawToLayout =
        this.ncSetting.sawSetting.sawToLayout &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      ncConfig.mentaoji_enable = this.ncSetting.sawSetting.mentaoji_enable
      ncConfig.surplus_position = this.ncSetting.surplusPosition
      ncConfig.trim_side = this.ncSetting.trimSide
      // TODO: 焊接板才使用锯片加工
      ncConfig.sawCutOnlyWeld =
        this.ncSetting.sawSetting.sawCutOnlyWeld &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      // 最小余料匹配宽度差
      if (
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.sawToLayout &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      ) {
        ncConfig.minSurplusWidthDiff =
          this.ncSetting.sawSetting.minSurplusWidthDiff
      }
      let layout_data = {
        layoutConfig: ncConfig,
        layoutHoleMap: {},
        layoutRectMap: layoutRectMap,
      }
      let surplusInfo = {}
      if (
        this.bigpart.surplusInfo &&
        Object.keys(this.bigpart.surplusInfo).length > 0
      ) {
        let title = `${
          this.bigpart.surplusInfo?.origin_color || this.bigpart.texture
        }:${this.bigpart.matCode}:${this.bigpart.thick}`
        // 需在surplusParams获取原始的余料数据，大板上的余料数据适用于绘制，会进行修改
        const target = filterSurplusById(
          this.bigpart.surplusInfo.id,
          this.surplusParams[title]
        )
        if (target) {
          surplusInfo[title] = target
        }
      }
      let paramObj = {
        data: {
          count_list: [1],
          cutDirection: this.ncSetting.cutDirection,
          id: this.orderInfo.order_codes,
          layout_data: JSON.stringify(layout_data),
          oids: this.orderInfo.order_ids,
          surplus: isChangePlankSize ? void 0 : JSON.stringify(surplusInfo),
          uid: this.userInfo.id,
        },
        status: 1,
      }
      const plankType = this.getPlankType(this.bigpart)
      const res = await dealPaibanData(
        [paramObj],
        arr,
        this.activePaibanWay[0],
        false,
        false,
        false,
        false,
        [0, 0],
        {
          // 普通大板才将当前尺寸传入，特殊/余料大板都会在函数内部重计算的
          plankWidth:
            plankType == 'normal' || isChangePlankSize ? plankWidth : void 0,
          plankHeight:
            plankType == 'normal' || isChangePlankSize ? plankHeight : void 0,
        }
      )

      if (!res || !res.length) {
        this.showLoading = false
        return
      }
      const resultParts = res[0].parts
      // 精细排版排除两块大板，就不进行后续的操作
      if (res.length > 1) {
        this.showLoading = false
        return this.$message.warning('没有更好的排版方式')
      }
      if (!needMorePlan) {
        this.replaceRectData(resultParts)
        // 大板由于设置进行了翻面，那么是否是双面板的判断也需要重新运行
        this.bigpart.ableToggle = isNeedFanByBigPlank(
          this.bigpart,
          this.ncSetting
        )
        this.tailorSurplus(this.bigpart)
        this.renderAll()
      }

      this.dealMorePlan(arr)
      this.showLoading = false
      if (this.bigpart.sideType == -1) {
        this.bigpart.sideType = 1
        this.toggleBigpartData()
      }
      // 重新排版 锁定解锁的余料
      if (
        this.bigpart.surplusInfo &&
        Object.keys(this.bigpart.surplusInfo).length > 0 &&
        this.$store.state.preferencesSetting.setting.surplus_lock
      ) {
        let params = {
          match_list: [
            {
              thick: Number(this.bigpart.thick),
              type: this.bigpart.matCode,
              color: this.bigpart.texture,
            },
          ],
          page: 1,
          limit: 9999,
        }
        // 获取最新余料数据
        this.$token('/search_surplus_depot', params, (res) => {
          if (res.status == 1) {
            let currentSurplus = res.data.data.find(
              (item) => item.id == this.bigpart.surplusInfo.id
            )
            if (currentSurplus && currentSurplus.lock_status != 1) {
              const lockParams = {
                surplus: [
                  {
                    ...currentSurplus,
                    lock_status: 1,
                    lock_order: this.orderInfo.order_address.replace(
                      /\(.*?\)|历史记录/g,
                      ''
                    ),
                    lock_num: 1,
                  },
                ],
                release_all: false,
              }
              surplusLock(lockParams)
            }
          }
        })
      }
    },
    /**
     * @desc 获取当次排版大板应该使用的排版默认长于宽
     */
    getPaibanPlankSize(plank) {
      const type = this.getPlankType(plank)
      // 非余料和超大版则默认使用板子本身的尺寸，这点和排版页不同
      if (type == 'normal') {
        return {
          plankWidth: plank.plankWidth,
          plankHeight: plank.plankHeight,
        }
      }
      // 尺寸被更改过也使用板件长宽
      if (isChangeBigPlankSize(this.standardPlank, plank)) {
        return {
          plankWidth: plank.plankWidth,
          plankHeight: plank.plankHeight,
        }
      }
      // 超尺大板和余料则默认使用原片设置(但是算法也不会用，所以用哪个也无所谓)
      const { plankWidth, plankHeight } = this.standardPlank
      return {
        plankWidth,
        plankHeight,
      }
    },
    /**
     * @desc 获取板件类型
     * @param plank 板件
     * @returns {string} 板件类型
     */
    getPlankType(plank) {
      const isSpecial = isSpecialBigPlank(plank)
      const isSurplus = isSurplusBigPlank(plank)
      if (isSpecial) {
        return 'special'
      }
      if (isSurplus) {
        return 'surplus'
      }
      return 'normal'
    },

    tailorSurplus(bigpart, needCalculate = false) {
      if (this.surplusAutoTailor) {
        // 父板锁定时复用子板不自动裁剪余料
        if (shouldSkipTailor(bigpart)) return
        const data = [bigpart]
        if (this.surplusTailorWay == 'maxRect') {
          surplusMaxtailor(data[0], this.ncSetting, this.userInfo)
          if (store.state.isCombineToLShape) {
            const newParts = cutLShapePart(data[0])
            data[0].parts = newParts
          }
        }
        if (this.surplusTailorWay == 'commonRect') {
          surplusAutoFill(
            data,
            this.surplusCommonSize,
            this.ncSetting,
            this.userInfo
          )
        }
        // 重新设定下刀点和切割顺序  多种排版方案不算下刀点 因为弄不来
        !needCalculate && this.calcCutPositionOrder(bigpart)
        !needCalculate &&
          calcBigpartArea(bigpart, this.ncSetting, this.isUnuseSurplus).usedRate
      }
    },
    // 旋转板件
    async rotatePlank() {
      // 复选（Ctrl 多选）选中多块小板时，旋转操作同样应用到全部选中小板
      if (this.batchActiveIdList.length) {
        return this.batchRotatePlank()
      }
      if (isTextureAlignmentPlank(this.activePlank)) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          getSameGroupParts(this.activePlank, this.bigpart.parts)
        )
        if (!confirmed) return
      }
      const oriActivePlank = JSON.parse(JSON.stringify(this.activePlank))
      buryPointApi('layout_sub', 'rotate_90')
      rotatePart(this.activePlank, 'manual-rotatePlank')
      dealPlankPoly(this.activePlank)
      dealBigPlank(this.bigpart)
      checkOneBigpart(this.bigpart)
      this.renderAll()
      this.$emit('recordRotatePlank', {
        key: '精细排版旋转小板',
        dataArr: [
          {
            type: 'form',
            current: {
              oRectWidth: this.activePlank.oRect.width,
            }, // 当前表单数据
            ori: {
              oRectWidth: oriActivePlank.oRect.width,
            }, // 原始表单数据
            compareMsg: [
              {
                title: `${this.activePlank.partName}-大板序号: ${this.bigpart.canvasIndex}`,
                keys: ['oRectWidth'],
              },
            ], // 要比较的内容
            formTextObj: {
              oRectWidth: '成品宽度',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          },
        ],
      })
    },
    /**
     * @description 复选（Ctrl 多选）批量旋转小板，与单板旋转保持一致
     * @returns {Promise<void>}
     */
    async batchRotatePlank() {
      const targets = this.getBatchActivePartsForAction()
      if (!targets.length) return
      // 与单板一致：对纹板件统一确认一次
      const textureParts = this.getBatchMatchParts(
        targets,
        isTextureAlignmentPlank
      )
      if (textureParts.length) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          textureParts
        )
        if (!confirmed) return
      }
      const oriList = targets.map((part) => ({
        part,
        partName: part.partName,
        oriRectWidth: part.oRect?.width,
      }))
      buryPointApi('layout_sub', 'rotate_90')
      targets.forEach((part) => {
        rotatePart(part, 'manual-rotatePlank')
        dealPlankPoly(part)
      })
      dealBigPlank(this.bigpart)
      checkOneBigpart(this.bigpart)
      this.renderAll()
      this.$emit('recordRotatePlank', {
        key: '精细排版旋转小板',
        dataArr: oriList.map((item) => ({
          type: 'form',
          current: {
            oRectWidth: item.part.oRect?.width,
          }, // 当前表单数据
          ori: {
            oRectWidth: item.oriRectWidth,
          }, // 原始表单数据
          compareMsg: [
            {
              title: `${item.partName}-大板序号: ${this.bigpart.canvasIndex}`,
              keys: ['oRectWidth'],
            },
          ], // 要比较的内容
          formTextObj: {
            oRectWidth: '成品宽度',
          }, // key对应的意思
          formValueObj: {}, // value对应的意思
        })),
      })
    },
    showPosition(able) {
      if (able) return
      buryPointApi('layout_sub', 'set_cut_point')
      this.showPositionChange = true
      this.selectedCutorigin = this.activePlank.cutOrigin
    },
    handleCloseCutOrign() {
      this.activePlank = null
      this.showPositionChange = false
      this.renderAll()
    },
    // 修改下刀位置
    changeCutOrigin(type) {
      this.selectedCutorigin = type
      if (this.isCutorigin) {
        this.confirmChangeCutOrigin()
        this.activePlank = null
        this.renderAll()
        this.defaultPositionPoint = 'rightBottom'
      }
    },
    confirmChangeCutOrigin() {
      const oriActivePlank = JSON.parse(JSON.stringify(this.activePlank))
      this.activePlank.cutOrigin = this.selectedCutorigin
      this.showPositionChange = false
      this.renderAll()
      this.$emit('recordChangeCutOrigin', {
        key: `精细排版设置下刀点-大板序号: ${this.bigpart.canvasIndex}`,
        dataArr: [
          {
            type: 'form',
            current: {
              cutOrigin: this.cutOriginObj[this.activePlank.cutOrigin],
            }, // 当前表单数据
            ori: {
              cutOrigin: this.cutOriginObj[oriActivePlank.cutOrigin],
            }, // 原始表单数据
            compareMsg: [
              {
                title: this.activePlank.partName,
                keys: ['cutOrigin'],
              },
            ], // 要比较的内容
            formTextObj: {
              cutOrigin: '下刀点',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          },
        ],
      })
    },
    // 根据窗口缩放计算canvas宽度
    calcCanvasWidth() {
      return (e) => {
        let windowWidth = document.body.offsetWidth
        if (windowWidth >= 1440) {
          this.canvasWidth = windowWidth - 220 - 316 - 48
        }
      }
    },
    handleRewriteRemarks() {
      if (!this.plankRemarks) {
        // 复选时优先取激活小板备注，其次取任意一块已填写备注的选中小板
        const target = this.getBatchActiveParts().find(
          (part) => part.plank_remarks
        )
        this.plankRemarks =
          this.activePlank?.plank_remarks || target?.plank_remarks || ''
      }
      this.ableRewriteRemarks = true
    },
    handleChangeRemarksAble(val) {
      this.ableRewriteRemarks = val
      this.plankRemarks = ''
      if (!this.plankRemarks) {
        this.plankRemarks = this.activePlank.plank_remarks
      }
    },
    handleChangeRemarks() {
      // 复选（Ctrl 多选）选中多块小板时，备注同样写入全部选中小板
      if (this.batchActiveIdList.length) {
        this.ableRewriteRemarks = false
        this.getBatchActiveParts().forEach((part) => this.setPlankRemarks(part))
        this.plankRemarks = ''
        buryPointApi('layout_sub', 'edit_plank_remarks')
        return
      }
      if (this.activePlank) {
        this.ableRewriteRemarks = false
        this.setPlankRemarks(this.activePlank)
        this.plankRemarks = ''
        buryPointApi('layout_sub', 'edit_plank_remarks')
      }
    },
    /**
     * @description 写入小板备注（同一大板下相同原始板号、相同切割顺序的小板一起更新），单板与复选共用
     * @param {Object} part - 小板
     * @returns {void}
     */
    setPlankRemarks(part) {
      this.bigpart.parts.forEach((nowPlank) => {
        if (
          part.oriPlankNum == nowPlank.oriPlankNum &&
          part.priority == nowPlank.priority
        ) {
          nowPlank.plank_remarks = this.plankRemarks
          this.$set(part, 'plank_remarks', this.plankRemarks)
        }
      })
    },
    // 开始绘制前的准备
    startDraw() {
      this.$nextTick(() => {
        let dom = this.$refs.subtleCanvas
        this.ctx = dom.getContext('2d')
        this.resetSubtleSize(this.bigpart)
        // this.initPlankLock(this.ctx)
        this.recordBigpart = cloneDeep(this.bigpart)
        this.drawOneBigpart()
        // 初始化板件控制
        this.plankControl = new PlankControl(this)
      })
    },
    // 将size通过scale进行转换
    tranlateSizeFromScale(size) {
      return (size / defaultScale) * this.scalePercent
    },
    // 绘制一个大板的所有东西
    drawOneBigpart() {
      const draw = new BigPlankDrawer(
        this.bigpart,
        this.ncSetting,
        defaultScale,
        this.scalePercent
      )
      let left = this.bigpart.subtleStartX
      let top = this.bigpart.subtleStartY
      if (this.canvasOffset) {
        left += this.canvasOffset.x
        top += this.canvasOffset.y
      }
      draw.setStart(left, top - this.topInfoHeight)
      draw.setSize(this.bigpart.subtleWidth, this.bigpart.subtleHeight)
      // 如果是活跃大板
      if (
        (this.activePlank &&
          this.activePlank.stockKey == this.bigpart.stockKey) ||
        this.bigpart.isActive
      ) {
        draw.setActive(true)
      }
      draw.drawMargin(this.ctx)
      draw.drawToggle(this.ctx)
      // 绘制四边修边
      draw.drawFourEdge(this.ctx)
      draw.drawContainer(this.ctx, {
        trimSide: this.trimSide,
        plankBgColor: DrawBigPlankParamsJs.plankBgColor2,
      })
      draw.drawOverSizeArea(this.ctx, { trimSide: this.trimSide })
      draw.drawLock(this.ctx)
      draw.drawTopInfo(this.ctx)
      // 大板绘制完成后，需要标记的地方
      this.needMarkRectArr = this.needMarkRectArr.concat(draw.needMarkRectArr)
      const { x: newLeft, y: newTop } = draw.getContainerStart()
      // 绘制小板
      // 记录是否有激活板件, 激活的板件最后绘制
      // 夹手先绘制，在底层最后绘制
      const targetData = (this.bigpart.clampHandInfo ?? []).concat(
        this.bigpart.parts
      )
      let finalPart = []
      for (let i = 0; i < targetData.length; ++i) {
        let part = targetData[i]
        if (this.activePlank && part.index == this.activePlank.index) {
          finalPart.push(part)
          continue
        }
        this.drawParts(this.ctx, part, newLeft, newTop, this.bigpart)
      }
      if (finalPart && finalPart.length) {
        finalPart.forEach((item) => {
          this.drawParts(this.ctx, item, newLeft, newTop, this.bigpart)
        })
      }
      if (!this.isAdsorb && !this.isCuttingSurplus) {
        // 绘制空白位置距离
        drawPlankEmptyDistance(this.ctx, this.emptyDistance, this.mousePoint)
        // 绘制孔槽详细信息
        drawPlankHSDetailInfo(this.ctx, this.hsDetailInfoList, this.mousePoint)
      }
      // 绘制标记说明
      if (this.markRectTip) {
        drawMarkRectTip(
          this.ctx,
          this.markRectTip.x,
          this.markRectTip.y,
          this.markRect
        )
      }
      if (
        this.activePlank &&
        this.activePlank.stockKey === this.bigpart.stockKey
      ) {
        this.edgeOverlayCanvasOrigin = {
          stockKey: this.bigpart.stockKey,
          newLeft,
          newTop,
        }
      } else {
        this.edgeOverlayCanvasOrigin = null
      }
      this.updateEdgeCenterDistances()
      this.drawEdgeCenterOverlayLast()
    },

    /**
     * 绘制大板顶部信息包括正反切换和优化率
     * @param { Object } bigpart 大板信息
     */
    drawTopInfo() {
      let fontSize = 14 * this.scalePercent
      this.ctx.font = `bold ${fontSize}px 'PingFangSC-Regular, PingFang SC' `
      let startX = this.bigpart.subtleStartX
      let startY = this.bigpart.subtleStartY
      if (this.canvasOffset) {
        startX += this.canvasOffset.x
        startY += this.canvasOffset.y
      }
      let width = this.bigpart.subtleWidth + 2 * this.deviation
      const isLshape =
        this.bigpart.surplusInfo && this.bigpart.surplusInfo.shape == 'lshape'
      const plankSize = calcPlankSize(this.bigpart, isLshape)
      let usedRate =
        '【' +
        this.bigpart.orderIndex +
        '】' +
        ((this.bigpart.usedRate > 1 ? 1 : this.bigpart.usedRate) * 100).toFixed(
          2
        ) +
        '%' +
        (isLshape
          ? ` (${plankSize.longW}(${plankSize.shortW})X${plankSize.longH}(${plankSize.shortH}))`
          : `  (${this.bigpart.plankWidth}X${this.bigpart.plankHeight})`)
      if (this.bigpart.ableToggle) {
        if (this.isHighPlank) {
          // 绘制正
          this.ctx.fillStyle = '#18a8c7'
          this.ctx.fillRect(startX, startY, width / 2, this.topInfoHeight)
          // 绘制正字
          this.ctx.fillStyle = '#fff'
          let textWidth = this.calcTextSize(translate('common.front'))
          let topInfoHeight = (width / 2 - textWidth) / 2
          this.ctx.fillText(
            translate('common.front'),
            startX + topInfoHeight,
            startY + 22 * this.scalePercent
          )

          // 绘制反
          this.ctx.fillStyle = '#d7d7d7'
          this.ctx.fillRect(
            startX + width / 2,
            startY,
            width / 2,
            this.topInfoHeight
          )
          this.ctx.fillStyle = '#666'
          // 绘制反字
          this.ctx.fillText(
            translate('common.back'),
            startX + width / 2 + topInfoHeight,
            startY + 22 * this.scalePercent
          )

          // 绘制优化率
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX,
            startY - 33 * this.scalePercent,
            width,
            this.topInfoHeight / 2
          )
          this.ctx.fillStyle = '#333'
          textWidth = this.calcTextSize(usedRate)
          topInfoHeight = (width / 3 - textWidth) / 2
          // 绘制优化率文字
          this.ctx.fillText(usedRate, startX, startY - 6 * this.scalePercent)
          return
        }
        if (this.bigpart.sideType == 1) {
          // 绘制正
          this.ctx.fillStyle = '#18a8c7'
          this.ctx.fillRect(startX, startY, width / 2, this.topInfoHeight)
          // 绘制正字
          this.ctx.fillStyle = '#fff'
          let textWidth = this.calcTextSize(translate('common.front'))
          let topInfoHeight = (width / 2 - textWidth) / 2
          this.ctx.fillText(
            translate('common.front'),
            startX + topInfoHeight,
            startY + 22 * this.scalePercent
          )

          // 绘制反
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX + width / 2,
            startY,
            width / 2,
            this.topInfoHeight
          )
          this.ctx.fillStyle = '#333'
          // 绘制反字
          this.ctx.fillText(
            translate('common.back'),
            startX + width / 2 + topInfoHeight,
            startY + 22 * this.scalePercent
          )

          // 绘制优化率
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX,
            startY - 33 * this.scalePercent,
            width,
            this.topInfoHeight / 2
          )
          this.ctx.fillStyle = '#333'
          textWidth = this.calcTextSize(usedRate)
          topInfoHeight = (width / 3 - textWidth) / 2
          // 绘制优化率文字
          this.ctx.fillText(usedRate, startX, startY - 6 * this.scalePercent)
        } else {
          // 绘制正
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(startX, startY, width / 2, this.topInfoHeight)
          // 绘制正字
          this.ctx.fillStyle = '#333'
          let textWidth = this.calcTextSize(translate('common.front'))
          let topInfoHeight = (width / 2 - textWidth) / 2
          this.ctx.fillText(
            translate('common.front'),
            startX + topInfoHeight,
            startY + 22 * this.scalePercent
          )

          // 绘制反
          this.ctx.fillStyle = '#18a8c7'
          this.ctx.fillRect(
            startX + width / 2,
            startY,
            width / 2,
            this.topInfoHeight
          )
          this.ctx.fillStyle = '#fff'
          // 绘制反字
          this.ctx.fillText(
            translate('common.back'),
            startX + width / 2 + topInfoHeight,
            startY + 22 * this.scalePercent
          )

          // 绘制优化率
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX + width / 2,
            startY - 33 * this.scalePercent,
            width / 2,
            this.topInfoHeight / 2
          )
          this.ctx.fillStyle = '#333'
          textWidth = this.calcTextSize(usedRate)
          topInfoHeight = (width / 3 - textWidth) / 2
          // 绘制优化率文字
          this.ctx.fillText(usedRate, startX, startY - 6 * this.scalePercent)
        }
      } else {
        // 绘制优化率
        this.ctx.fillStyle = '#cfcfcf'
        this.ctx.fillRect(startX, startY, width, this.topInfoHeight)
        this.ctx.fillStyle = '#333'
        let textWidth = this.calcTextSize(usedRate)
        let topInfoHeight = (width - textWidth) / 2
        // 绘制优化率文字
        this.ctx.fillText(
          usedRate,
          startX + topInfoHeight,
          startY + 22 * this.scalePercent
        )
      }
    },

    // 获取文字宽度, 用于中心绘制
    calcTextSize(text) {
      let span = document.createElement('span')
      let result = {}
      result.width = span.offsetWidth
      result.height = span.offsetHeight
      span.style.visibility = 'hidden'
      span.style.fontSize = '14px'
      span.style.fontFamily = 'PingFangSC-Regular, PingFang SC'
      span.style.display = 'inline-block'
      document.body.appendChild(span)
      if (typeof span.textContent != 'undefined') {
        span.textContent = text
      } else {
        span.innerText = text
      }
      result.width =
        parseFloat(window.getComputedStyle(span).width) - result.width
      result.height =
        parseFloat(window.getComputedStyle(span).height) - result.height
      document.body.removeChild(span)
      return result.width * this.scalePercent
    },

    /**
     * 绘制小板
     * @param { Object } part 小板数据
     * @param { Number } startX 大板的绘制起始横坐标
     * @param { Number } startY 大板的绘制起始纵坐标
     */
    drawParts(ctx, part, startX, startY, bigpart, onlyOnePart = false) {
      const partTemp = transformData(part, store)
      let rect = {
        x: startX + (partTemp.startX / defaultScale) * this.scalePercent,
        y: startY + (partTemp.startY / defaultScale) * this.scalePercent,
        width: (partTemp.rect.width / defaultScale) * this.scalePercent,
        height: (partTemp.rect.height / defaultScale) * this.scalePercent,
      }
      if (onlyOnePart) {
        rect.x = 5
        rect.y = 5
      }
      if (this.activePlankOff) {
        if (
          this.activePlank &&
          this.activePlank.partUniqueId == part.partUniqueId &&
          this.dragPosition
        ) {
          let newPlankStartX =
            (this.dragPosition.x / this.scalePercent) * defaultScale -
            this.activePlankOff.x
          let newPlankStartY =
            (this.dragPosition.y / this.scalePercent) * defaultScale -
            this.activePlankOff.y
          rect.x = startX + (newPlankStartX / defaultScale) * this.scalePercent
          rect.y = startY + (newPlankStartY / defaultScale) * this.scalePercent
        }
      }
      const plank = new Plank(
        ctx,
        partTemp,
        rect.x,
        rect.y,
        defaultScale,
        this.scalePercent,
        { plankLineWidth: 1 }
      )
      // 激活板件或者入库时需要设置板件激活颜色
      const isBatchActivePart =
        !this.isBatchPosition &&
        this.batchActiveIdList.some(
          (id) => String(id) === String(partTemp.partUniqueId)
        )
      if (this.isBatchPosition) {
        if (partTemp.checked) {
          plank.setFillStyle(DrawPlankColorJs.active)
        }
      } else if (isBatchActivePart) {
        if (this.activePlank && isSamePart(this.activePlank, partTemp)) {
          this.selectedCutorigin = partTemp.cutOrigin
        }
        plank.setFillStyle(DrawPlankColorJs.active)
      } else {
        if (this.activePlank && isSamePart(this.activePlank, partTemp)) {
          this.selectedCutorigin = partTemp.cutOrigin
          plank.setFillStyle(DrawPlankColorJs.active)
        }
      }
      if (partTemp.plankMerge) {
        plank.setFillStyle(DrawPlankColorJs.plankMerge)
      }
      // 跨材质板件使用虚线边框
      if (partTemp._isCrossMaterial) {
        plank.setDashedBorder(true)
      }
      // 判断这块大板是否满足了分层切割
      const isMatched = matchLayeredCutForPalnkThick({
        matCode: bigpart.matCode,
        thick: bigpart.thick,
        is_high_gloss_plank: bigpart.highlight === '非高光' ? false : true,
      })
      // 异形板件，且开启了异形板分层切割
      if (
        partTemp.curve_layered_cutting &&
        Number(partTemp.curve_layered_cutting_deep) < partTemp.thick &&
        !isMatched
      ) {
        plank.setStrokeStyle('skyblue')
        plank.setLineWidth(3)
      }
      //  是否展示小班尺寸 含有plankSize 不绘制
      const notDraw = []
      if (!this.isShowPartSize) {
        notDraw.push('plankSize')
      }
      if (!this.isMarkModifiedSmallBoards) {
        notDraw.push('markModifiedSmallBoards')
      }
      const draws = plankDrawFactory(
        ctx,
        partTemp,
        rect.x,
        rect.y,
        defaultScale,
        this.scalePercent,
        {
          dotWidth: this.dotWidth,
          textWidth: this.textWidth,
          fontSize: 14,
        },
        notDraw
      )
      // 添加其他绘制
      plank.addStrategy(Object.keys(draws).map((it) => draws[it]))
      plank.draw()
    },
    // 绘制异形孔
    drawAllCurveHole(ctx, part, rect, bigpart, isThumbnail = false) {
      if (part.curveHoles && part.curveHoles.length) {
        const thick = (bigpart && bigpart.thick) || 0
        // const finalCurveHoles = this.dealCurveHoles(part.curveHoles)
        const noThroughCurveHoles = getThroughPathObj(
          part.curveHoles,
          thick,
          false
        )
        noThroughCurveHoles.forEach((hole) => {
          if (hole.side == 1) {
            ctx.strokeStyle = '#f008'
          } else {
            ctx.strokeStyle = '#00f8'
          }
          ctx.beginPath()
          for (let i = 0; i < hole.path.length; i++) {
            let x, y
            if (isThumbnail) {
              x = rect.x + hole.path[i].x
              y = rect.y + hole.path[i].y
            } else {
              x = rect.x + (hole.path[i].x / defaultScale) * this.scalePercent
              y = rect.y + (hole.path[i].y / defaultScale) * this.scalePercent
            }

            if (i == 0) {
              ctx.moveTo(x, y)
            } else {
              ctx.lineTo(x, y)
            }
          }
          ctx.stroke()
          ctx.closePath()
        })
      }
    },
    /**
     * 绘制孔位
     * @param { Object } part 小板数据
     * @param { Object } rect 小板的绘制属性
     */
    drawAllHoles(ctx, part, rect, isThumbnail = false) {
      if (part.holes.length > 0) {
        for (let i = 0; i < part.holes.length; ++i) {
          let hole = part.holes[i]
          if (hole.side == 1) {
            ctx.strokeStyle = '#f008'
          } else {
            ctx.strokeStyle = '#00f8'
          }
          let circle
          if (isThumbnail) {
            circle = {
              x: rect.x + hole.center.x,
              y: rect.y + hole.center.y,
              r: hole.diameter / 2,
            }
          } else {
            circle = {
              x: rect.x + (hole.center.x / defaultScale) * this.scalePercent,
              y: rect.y + (hole.center.y / defaultScale) * this.scalePercent,
              r: (hole.diameter / 2 / defaultScale) * this.scalePercent,
            }
          }
          ctx.beginPath()
          ctx.arc(circle.x, circle.y, circle.r, 0, Math.PI * 2, true)
          ctx.closePath()
          ctx.stroke()
        }
      }
    },
    /**
     * 绘制拉槽
     * @param { Object } part 小板数据
     * @param { Object } rect 小板的绘制属性
     */
    drawAllSlots(ctx, part, rect, isThumbnail = false) {
      let slotsArr = [part.slots, part.handleSlopes, part.lineSlots]
      slotsArr.forEach((item, index) => {
        if (item && item.length > 0) {
          for (let i = 0; i < item.length; ++i) {
            let slot = item[i]
            if (slot.side == 1) {
              ctx.strokeStyle = '#f008'
            } else {
              ctx.strokeStyle = '#00f8'
            }
            if (slot.symbol == 'lineSlot') {
              ctx.beginPath()
              slot.polygonArr.forEach((polygon) => {
                polygon.forEach((point, idx) => {
                  const x = rect.x + point.x
                  const y = rect.y + point.y
                  if (idx == 0) {
                    ctx.moveTo(x, y)
                  } else {
                    ctx.lineTo(x, y)
                  }
                })
              })
              ctx.stroke()
              ctx.closePath()
              continue
            }
            let slotInfo = {}
            // 拉槽两点pt1, pt2为拉槽平行边的中点, 所以计算起始点需要减去拉槽的宽度的一半
            // 如果拉槽两点的横坐标相等 则为竖拉槽
            slotInfo.width = isThumbnail
              ? slot.width
              : (slot.width / defaultScale) * this.scalePercent
            if (slot.pt1.x === slot.pt2.x) {
              // 找出更小的纵坐标, 因为canvas是从左上角绘制的
              // isThumbnail=true 是缩略图
              if (isThumbnail) {
                slotInfo.x = rect.x + slot.pt1.x - slot.width / 2
                slotInfo.long = Math.abs(slot.pt1.y - slot.pt2.y)
              } else {
                slotInfo.x =
                  rect.x +
                  (slot.pt1.x / defaultScale) * this.scalePercent -
                  ((slot.width / defaultScale) * this.scalePercent) / 2
                slotInfo.long = Math.abs(
                  ((slot.pt1.y - slot.pt2.y) / defaultScale) * this.scalePercent
                )
              }
              if (slot.pt1.y > slot.pt2.y) {
                if (isThumbnail) {
                  slotInfo.y = rect.y + slot.pt2.y
                } else {
                  slotInfo.y =
                    rect.y + (slot.pt2.y / defaultScale) * this.scalePercent
                }
              } else {
                if (isThumbnail) {
                  slotInfo.y = rect.y + slot.pt1.y
                } else {
                  slotInfo.y =
                    rect.y + (slot.pt1.y / defaultScale) * this.scalePercent
                }
              }
              const { x, y, width, long } = slotInfo
              if (x + width > rect.x + rect.width && index == 1) {
                ctx.strokeRect(x - width / 2, y, width, long)
              } else if (x < rect.x && index == 1) {
                ctx.strokeRect(x + width / 2, y, width, long)
              } else {
                ctx.strokeRect(x, y, width, long)
              }
            }
            // 如果拉槽两点的纵坐标相等, 则为横拉槽
            if (slot.pt1.y === slot.pt2.y) {
              if (isThumbnail) {
                slotInfo.y = rect.y + slot.pt1.y - slot.width / 2
                slotInfo.long = Math.abs(slot.pt1.x - slot.pt2.x)
              } else {
                // 找出更小的横坐标
                slotInfo.y =
                  rect.y +
                  (slot.pt1.y / defaultScale) * this.scalePercent -
                  ((slot.width / defaultScale) * this.scalePercent) / 2
                slotInfo.long = Math.abs(
                  ((slot.pt1.x - slot.pt2.x) / defaultScale) * this.scalePercent
                )
              }
              if (slot.pt1.x > slot.pt2.x) {
                if (isThumbnail) {
                  slotInfo.x = rect.x + slot.pt2.x
                } else {
                  slotInfo.x =
                    rect.x + (slot.pt2.x / defaultScale) * this.scalePercent
                }
              } else {
                if (isThumbnail) {
                  slotInfo.x = rect.x + slot.pt1.x
                } else {
                  slotInfo.x =
                    rect.x + (slot.pt1.x / defaultScale) * this.scalePercent
                }
              }
              const { x, y, width, long } = slotInfo
              if (y < rect.y && index == 1) {
                ctx.strokeRect(x, y + width / 2, long, width)
              } else if (y + width > rect.y + rect.height && index == 1) {
                ctx.strokeRect(x, y - width / 2, long, width)
              } else {
                ctx.strokeRect(x, y, long, width)
              }
            }
            // 斜槽
            if (slot.symbol === 'CCompSlot') {
              const obliqueSlot = calculateSlantedRectanglePath(
                slot.pt1,
                slot.pt2,
                slot.width
              )
              const path = obliqueSlot.path.map((point) => ({
                x: rect.x + point.x,
                y: rect.y + point.y,
              }))
              ctx.beginPath()
              path.forEach((point) => {
                ctx.lineTo(point.x, point.y)
              })
              ctx.stroke()
            }
          }
        }
      })
    },

    /**
     * 该方法用来绘制一个有填充色的圆角矩形
     * @param cxt:canvas的上下文环境
     * @param x:左上角x轴坐标
     * @param y:左上角y轴坐标
     * @param width:矩形的宽度
     * @param height:矩形的高度
     * @param radius:圆的半径
     * @param fillColor:填充颜色
     **/
    fillRoundRect(cxt, x, y, width, height, radius, /*optional*/ fillColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false
      }

      cxt.save()
      cxt.translate(x, y)
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius)
      cxt.fillStyle = fillColor || '#000' //若是给定了值就用给定的值否则给予默认值
      cxt.fill()
      cxt.restore()
    },

    /**
     * 该方法用来绘制圆角矩形
     * @param cxt:canvas的上下文环境
     * @param x:左上角x轴坐标
     * @param y:左上角y轴坐标
     * @param width:矩形的宽度
     * @param height:矩形的高度
     * @param radius:圆的半径
     * @param lineWidth:线条粗细
     * @param strokeColor:线条颜色
     **/
    strokeRoundRect(
      cxt,
      x,
      y,
      width,
      height,
      radius,
      /*optional*/ lineWidth,
      /*optional*/ strokeColor
    ) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false
      }

      cxt.save()
      cxt.translate(x, y)
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius)
      cxt.lineWidth = lineWidth || 1 //若是给定了值就用给定的值否则给予默认值2
      cxt.strokeStyle = strokeColor || '#000'
      cxt.stroke()
      cxt.restore()
    },

    drawRoundRectPath(cxt, width, height, radius) {
      cxt.beginPath(0)
      //从右下角顺时针绘制，弧度从0到1/2PI
      cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2)
      //矩形下边线
      cxt.lineTo(radius, height)
      //左下角圆弧，弧度从1/2PI到PI
      cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI)
      //矩形左边线
      cxt.lineTo(0, radius)
      //左上角圆弧，弧度从PI到3/2PI
      cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2)
      //上边线
      cxt.lineTo(width - radius, 0)
      //右上角圆弧
      cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2)
      //右边线
      cxt.lineTo(width, height - radius)
      cxt.closePath()
    },

    /**
     * 设置激活板件
     * @param { Object } e 事件对象
     * @returns
     */
    setActivePlank(e, isNotClickCanvas, skipCheckedToggle = false) {
      let mousePoint = {
        x: e.offsetX,
        y: e.offsetY,
      }
      // 如果找到了, 则判断点击的位置
      if (
        mousePoint.x <=
          this.bigpart.subtleStartX +
            this.bigpart.subtleWidth +
            2 * this.deviation &&
        mousePoint.y <=
          this.bigpart.subtleStartY +
            this.bigpart.subtleHeight +
            this.topInfoHeight +
            2 * this.deviation
      ) {
        // 判断点击的是否为大板, 还是顶部信息
        if (mousePoint.y >= this.bigpart.subtleStartY + this.topInfoHeight) {
          this.bigpart.isActive = true
          // 遍历所有小板，找到最后一个匹配的板件（即视觉上最上层的板件）
          // 异形嵌套场景下，外层异形的多边形区域包含内层小板，需要取最后一个匹配才能正确选中内层小板
          let lastMatchedPart = null
          for (let i = 0; i < this.bigpart.parts.length; ++i) {
            let part = this.bigpart.parts[i]
            // 禁止蓝色余料区域选中：跳过蓝色余料而非直接中断整个查找
            if (part.blueAreaSurplus) {
              continue
            }
            if (!this.isAdsorb && !this.isCuttingSurplus) {
              this.emptyDistance = dealCurrentPointDistance(
                this.bigpart,
                mousePoint,
                this.deviation,
                this.topInfoHeight,
                this.scalePercent,
                defaultScale,
                'jingxi'
              )
              this.mousePoint = mousePoint
            }
            let rect = {
              x:
                this.bigpart.subtleStartX +
                this.deviation +
                (part.startX / defaultScale) * this.scalePercent,
              y:
                this.bigpart.subtleStartY +
                this.deviation +
                this.topInfoHeight +
                (part.startY / defaultScale) * this.scalePercent,
            }
            let newPos = {
              x: ((mousePoint.x - rect.x) / this.scalePercent) * defaultScale,
              y: ((mousePoint.y - rect.y) / this.scalePercent) * defaultScale,
            }
            let curvePath = []
            if (part.path) {
              const curveHolesArr = part.curveHoles?.map((it) => it.path)
              curvePath = [...part.path]
              if (curveHolesArr?.length && curveHolesArr[0]) {
                curvePath.push(...curveHolesArr)
              }
            } else {
              curvePath = [
                [
                  { x: 0, y: 0 },
                  { x: part.rect.width, y: 0 },
                  { x: part.rect.width, y: part.rect.height },
                  { x: 0, y: part.rect.height },
                ],
              ]
            }
            const isInpoly = curvePath
              .map((curve) => this.isInPolygon(newPos, curve))
              .filter(Boolean)
            // 与排版页一致：仅落在单一轮廓区域内才命中（排除异形挖洞区域）
            if (isInpoly.length === 1) {
              lastMatchedPart = part
            }
          }
          if (lastMatchedPart) {
            this.emptyDistance = false
            this.conflictPart = null
            // 给每块板子上添加一个是否被选中的状态  再次被选中的时候取消它的状态
            // 复选（Ctrl 多选）时不改动 checked，避免影响批量设置下刀点的勾选数据
            if (!skipCheckedToggle) {
              this.$set(
                lastMatchedPart,
                'checked',
                lastMatchedPart.checked ? false : true
              )
              this.activePartCount = this.calcActivePartCount(this.bigpart)
            }
            return lastMatchedPart
          }
        } else if (
          // 操作热区修改为顶部的信息部分
          mousePoint.y >= this.bigpart.subtleStartY &&
          mousePoint.y < this.bigpart.subtleStartY + this.topInfoHeight
        ) {
          this.plankRemarks = ''
          const holeArr = this.bigpart.parts
            .filter((p) => p.specialType !== 'supplus')
            .map((part) => [
              ...part.holes,
              // ...(part.curveHoles ? part.curveHoles : []),
            ])
          const slotArr = this.bigpart.parts
            .filter((p) => p.specialType !== 'supplus')
            .map((part) => [
              ...part.slots,
              ...(part.millInfo ? part.millInfo : []),
              ...(part.handleSlopes ?? []),
            ])
          const holeToggle = holeArr
            .flat(1)
            .some(
              (v) => v.deep * 1 + 0.001 >= this.bigpart.thick && !v.isFixedSide
            )
          const slotToggle = slotArr
            .flat(1)
            .some((v) => v.deep * 1 + 0.001 >= this.bigpart.thick)
          const isReverePlank = this.bigpart.parts.some(
            (part) => part.reverePlank
          )
          // 点击翻板数据
          if (this.bigpart && this.bigpart.ableToggle) {
            if (this.bigpart.parts[0].is_high_gloss_plank && !isNotClickCanvas)
              return this.$message.error(translate('arrangedPage.glossRollErr'))
            if (
              ((this.ncSetting.throughTowSideToCut && holeToggle) ||
                (this.ncSetting.through_slot_two_side_cut && slotToggle)) &&
              !isReverePlank
            ) {
              return this.$message.error(translate('arrangedPage.rollTip'))
            }
            if (this.bigpart.parts.some((part) => part.isExpanded)) {
              return this.$message.error(
                this.$translateLang(
                  '板件存在拉槽特殊工艺或特殊异形板，不支持正反面切换操作！'
                )
              )
            }
            if (
              mousePoint.x >= this.bigpart.subtleStartX &&
              mousePoint.x <=
                this.bigpart.subtleStartX + this.bigpart.subtleWidth / 2
            ) {
              if (this.bigpart.sideType == -1) {
                this.bigpart.sideType = 1
                this.toggleBigpartData()
              }
            }
            if (
              mousePoint.x >=
                this.bigpart.subtleStartX + this.bigpart.subtleWidth / 2 &&
              mousePoint.x <=
                this.bigpart.subtleStartX + this.bigpart.subtleWidth
            ) {
              if (this.bigpart.sideType == 1) {
                this.bigpart.sideType = -1
                this.toggleBigpartData()
              }
            }
          }
          this.emptyDistance = false
          return null
        }
      } else {
        this.emptyDistance = false
        return null
      }
    },

    toggleBigpartData() {
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        let plank = this.bigpart.parts[i]
        rolloverPlank(plank)
        dealPlankPoly(plank)
        checkOneBigpart(this.bigpart)
        this.judgeAbleFanban(this.bigpart)
      }
    },
    isInBigPlank(point) {
      let bigpartPolyList = []
      for (let i = 0; i < this.bigpart.bigPlank[0].length; ++i) {
        let point2 = this.bigpart.bigPlank[0][i]
        bigpartPolyList.push({
          x:
            this.bigpart.subtleStartX +
            this.deviation +
            (point2.X / defaultScale) * this.scalePercent,
          y:
            this.bigpart.subtleStartY +
            this.deviation +
            this.topInfoHeight +
            (point2.Y / defaultScale) * this.scalePercent,
        })
      }
      return this.isInPolygon(point, bigpartPolyList)
    },
    // 判断点是否在多边形内部
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0
      let i
      let xinters
      let p1, p2
      let pointCount = polygonPoints.length
      p1 = polygonPoints[0]
      for (i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount]
        if (
          checkPoint.x >= Math.min(p1.x, p2.x) &&
          checkPoint.x <= Math.max(p1.x, p2.x)
        ) {
          if (checkPoint.y <= Math.max(p1.y, p2.y)) {
            if (p1.x != p2.x) {
              xinters =
                ((checkPoint.x - p1.x) * (p2.y - p1.y)) / (p2.x - p1.x) + p1.y
              if (p1.y == p2.y || checkPoint.y < xinters) {
                counter++
              }
            }
          }
        }
        p1 = p2
      }
      if (counter % 2 == 0) {
        return false
      } else {
        return true
      }
    },

    // 重新绘制
    renderAll() {
      this.needMarkRectArr = []
      if (this.ctx.clearRect) {
        this.ctx.clearRect(0, 0, 1289, 744)
        this.drawOneBigpart()
        this.initBigPlanDeal()
        // 绘制单面板说明
        if (this.singlePlankTip) {
          drawSinglePlankTip(
            this.ctx,
            this.singlePlankTip.x,
            this.singlePlankTip.y
          )
        }
      }
    },
    /**
     * @description 复选（Ctrl 多选）切换一块小板的选中状态
     * @param {Object} part - 点击命中的小板
     * @returns {void}
     */
    toggleBatchActivePart(part) {
      if (!part) return
      const partId = part.partUniqueId
      // 第一次多选时，把当前已经激活的小板带进列表，避免只剩新点的那一块
      if (
        !this.batchActiveIdList.length &&
        this.activePlank?.partUniqueId &&
        String(this.activePlank.partUniqueId) !== String(partId)
      ) {
        this.batchActiveIdList = [this.activePlank.partUniqueId]
      }
      const isSelected = this.batchActiveIdList.some(
        (id) => String(id) === String(partId)
      )
      if (isSelected) {
        this.batchActiveIdList = this.batchActiveIdList.filter(
          (id) => String(id) !== String(partId)
        )
        // 取消选中后，激活小板回到最后一块仍处于选中的小板
        const lastId = this.batchActiveIdList[this.batchActiveIdList.length - 1]
        this.activePlank = lastId
          ? this.bigpart.parts.find(
              (item) => String(item.partUniqueId) === String(lastId)
            ) || null
          : null
        return
      }
      this.batchActiveIdList = [...this.batchActiveIdList, partId]
      this.activePlank = part
      // 与单板点击一致：同步分层切割的回显
      this.isLayerCut = !!part.curve_layered_cutting
      this.layerCutDepth = part.curve_layered_cutting_deep
    },
    /**
     * @description 复选（Ctrl 多选）选中的小板（当前精细排版大板内）
     * @returns {Array} 小板数组
     */
    getBatchActiveParts() {
      if (!this.batchActiveIdList.length) return []
      const idSet = new Set(this.batchActiveIdList.map((id) => String(id)))
      return (this.bigpart?.parts || []).filter((part) =>
        idSet.has(String(part.partUniqueId))
      )
    },
    /**
     * @description 复选（Ctrl 多选）批量操作前的校验，返回可操作的小板列表
     * @returns {Array} 小板数组
     */
    getBatchActivePartsForAction() {
      const targets = this.getBatchActiveParts()
      if (!targets.length) {
        this.$message({
          message: translate('arrangedPage.selectPlankTip'),
          type: 'info',
        })
        return []
      }
      if (this.bigpart.isLocked) {
        this.$message.error(translate('arrangedPage.lockDeleteErr'))
        return []
      }
      return targets
    },
    /**
     * @description 取出复选的小板中符合条件（含同对纹组）的板件，用于统一弹窗确认
     * @param {Array} targets - getBatchActiveParts 的结果
     * @param {Function} match - 判断小板是否符合条件
     * @returns {Array} 去重后的板件数组
     */
    getBatchMatchParts(targets, match) {
      const partMap = new Map()
      targets.forEach((part) => {
        if (!match(part)) return
        getSameGroupParts(part, this.bigpart.parts).forEach((item) => {
          partMap.set(String(item.partUniqueId), item)
        })
      })
      return [...partMap.values()]
    },
    //判断鼠标点击点是否再大版上
    checkMousePoint(e) {
      let point = {
        x: e.offsetX,
        y: e.offsetY,
      }
      let bigpartPolyList = []
      for (let i = 0; i < this.bigpart.bigPlank[0].length; ++i) {
        let point2 = this.bigpart.bigPlank[0][i]
        bigpartPolyList.push({
          x:
            this.bigpart.subtleStartX +
            this.deviation +
            (point2.X / defaultScale) * this.scalePercent,
          y:
            this.bigpart.subtleStartY +
            this.deviation +
            this.topInfoHeight +
            (point2.Y / defaultScale) * this.scalePercent,
        })
      }
      let isInBigPlank = this.isInPolygon(point, bigpartPolyList)
      if (!isInBigPlank) {
        this.$message({
          // '只能在大板上进行切割, 不可超出大板!'
          message: translate('arrangedPage.subtlePage.cutErr2'),
          type: 'error',
        })
        return false
      }
      // 台面宽度限制：裁剪点不可超出台面外
      if (!this.checkPointInCounter(point)) {
        this.$message({
          message: this.$translateLang('裁剪余料不能超出台面外'),
          type: 'error',
        })
        return false
      }
      return true
    },
    /**
     * @description 画布点是否在台面有效宽度内
     */
    checkPointInCounter(point) {
      const plankX =
        ((point.x - this.bigpart.subtleStartX - this.deviation) /
          this.scalePercent) *
        defaultScale
      const plankY =
        ((point.y -
          this.bigpart.subtleStartY -
          this.deviation -
          this.topInfoHeight) /
          this.scalePercent) *
        defaultScale
      return !isPointOutsideCounter(
        { x: plankX, y: plankY },
        {
          plankWidth: this.bigpart.plankWidth,
          plankHeight: this.bigpart.plankHeight,
          bigpart: this.bigpart,
        },
        this.ncSetting
      )
    },
    /**
     * @description 将画布坐标点限制在台面有效宽度内（xyReverse 时限制 Y）
     */
    clampSurplusPointToCounter(point) {
      const range = getCounterValidRange(
        {
          plankWidth: this.bigpart.plankWidth,
          plankHeight: this.bigpart.plankHeight,
          bigpart: this.bigpart,
        },
        this.ncSetting
      )
      if (!range || !point) return point
      if (range.axis === 'x') {
        const minCanvasX =
          this.bigpart.subtleStartX +
          this.deviation +
          (range.min / defaultScale) * this.scalePercent
        const maxCanvasX =
          this.bigpart.subtleStartX +
          this.deviation +
          (range.max / defaultScale) * this.scalePercent
        return {
          ...point,
          x: Math.min(maxCanvasX, Math.max(minCanvasX, point.x)),
        }
      }
      const minCanvasY =
        this.bigpart.subtleStartY +
        this.deviation +
        this.topInfoHeight +
        (range.min / defaultScale) * this.scalePercent
      const maxCanvasY =
        this.bigpart.subtleStartY +
        this.deviation +
        this.topInfoHeight +
        (range.max / defaultScale) * this.scalePercent
      return {
        ...point,
        y: Math.min(maxCanvasY, Math.max(minCanvasY, point.y)),
      }
    },
    //绘制最大矩形
    drawMostRect(e) {
      if (!this.checkMousePoint(e)) return
      let mousePoint = {
        x: e.offsetX,
        y: e.offsetY,
      }
      let newPoint = {
        x: Number(
          (
            ((mousePoint.x - this.bigpart.subtleStartX - this.deviation) /
              this.scalePercent) *
            defaultScale
          ).toFixed(this.ncSetting.decimal)
        ),
        y: Number(
          (
            ((mousePoint.y -
              this.bigpart.subtleStartY -
              this.deviation -
              this.topInfoHeight) /
              this.scalePercent) *
            defaultScale
          ).toFixed(this.ncSetting.decimal)
        ),
      }
      let rectInfo = computeMostRectByLine(
        JSON.parse(JSON.stringify(this.bigpart)),
        newPoint
      )
      if (!rectInfo) {
        return
      }

      // 台面宽度限制：最大矩形裁剪结果不得超出台面外
      rectInfo = this.clipMostRectToCounter(rectInfo)
      if (!rectInfo) {
        this.$message({
          message: this.$translateLang('裁剪余料不能超出台面外'),
          type: 'error',
        })
        return
      }

      this.surplusPoint = rectInfo.map((item) => ({
        x:
          (item.x / defaultScale) * this.scalePercent +
          this.deviation +
          this.bigpart.subtleStartX,
        y:
          (item.y / defaultScale) * this.scalePercent +
          this.topInfoHeight +
          this.deviation +
          this.bigpart.subtleStartY,
      }))
      this.addNewSurplus()
    },
    /**
     * @description 将最大矩形裁剪点限制在台面有效宽度内
     * @returns 裁剪后的四点路径；无有效区域时返回 null
     */
    clipMostRectToCounter(rectInfo) {
      if (!rectInfo?.length) return null
      const range = getCounterValidRange(
        {
          plankWidth: this.bigpart.plankWidth,
          plankHeight: this.bigpart.plankHeight,
          bigpart: this.bigpart,
        },
        this.ncSetting
      )
      if (!range) return rectInfo

      const xs = rectInfo.map((p) => p.x)
      const ys = rectInfo.map((p) => p.y)
      let minX = Math.min(...xs)
      let maxX = Math.max(...xs)
      let minY = Math.min(...ys)
      let maxY = Math.max(...ys)

      if (range.axis === 'x') {
        minX = Math.max(minX, range.min)
        maxX = Math.min(maxX, range.max)
        if (minX >= maxX) return null
      } else {
        minY = Math.max(minY, range.min)
        maxY = Math.min(maxY, range.max)
        if (minY >= maxY) return null
      }

      return [
        { x: minX, y: minY },
        { x: minX, y: maxY },
        { x: maxX, y: maxY },
        { x: maxX, y: minY },
      ]
    },
    // 鼠标按下事件
    async clickCanvas(e, isNotClickCanvas) {
      // 保存起始offset信息
      this.clickPointOffset.x = e.offsetX
      this.clickPointOffset.y = e.offsetY

      // 鼠标左键
      if (e.button == 0) {
        const mousePoint = {
          x: e.offsetX,
          y: e.offsetY,
        }
        // 裁剪模式下，可以选中移动小板
        if (
          this.isCuttingSurplus &&
          !(
            isCanvasPixelDrawn(this.ctx, e.offsetX, e.offsetY) &&
            !this.surplusPoint.length
          )
        ) {
          this.activePlank = null
          if (this.surplusCuttingType == 'rect') {
            this.drawMostRect(e)
          } else if (this.surplusCuttingType == 'L') {
          } else if (this.surplusCuttingType == 'line') {
            if (this.isAdsorb && this.surplusPoint.length === 0) {
              this.surPlusAbsorb(e, 'down')
            } else {
              this.drawSurplus(e)
            }
            this.lineRecode.e = e
          }
          return
        }
        if (this.isMovingCavnas) return
        // 复选（Ctrl 多选）：点击小板切换选中状态，不进入拖动等其他交互
        if (this.isBatchActive && !this.isBatchPosition) {
          const batchClickedPart = this.setActivePlank(
            e,
            isNotClickCanvas,
            true
          )
          this.toggleBatchActivePart(batchClickedPart)
          this.plankRemarks = ''
          this.ableRewriteRemarks = false
          this.renderAll()
          return
        }
        // 非复选点击时清空复选选区
        if (this.batchActiveIdList.length) {
          this.batchActiveIdList = []
        }
        // 选中板件时, 先清除所有分类的选中状态
        this.activePlank = this.setActivePlank(e, isNotClickCanvas)
        this.plankRemarks = ''
        this.ableRewriteRemarks = false
        this.renderAll()
        const plankPath = this.getPlankPath()
        const onPlank = this.jundgeLocation(mousePoint, plankPath)
        const { lockPath } = this.setLockInfo()
        const onLock = this.jundgeLocation(mousePoint, lockPath)
        // 在锁上的点击
        if (onLock && (this.bigpart.isLocked || this.bigpart.isActive)) {
          buryPointApi('layout_sub', 'bigpart_locked')
          this.bigpart.isLocked = this.lockHoverInfo.isLocked =
            !this.bigpart.isLocked
          if (!this.bigpart.isLocked) {
            this.$message.success(translate('lockModal.lockSeccess'))
            this.renderAll()
            this.lockHoverInfo.isShow = false
            this.bigpart.isActive = false
          } else {
            this.$message.success(translate('lockModal.lockSeccessTip'))
          }
          this.renderAll()
        }
        // 大板被激活过一次但是点击在大板和锁之外把激活状态置为false
        if (this.bigpart.isActive && !onLock && !onPlank) {
          this.bigpart.isActive = false
        }
        if (this.activePlank) {
          this.$nextTick(() => {
            if (this.activePlank.ggid) {
              this.$refs.qrcode.innerHTML = ''
              new QRCode('subtle-qrcode', {
                width: 80,
                height: 80,
                colorDark: '#000000', //前景色
                colorLight: '#ffffff', //背景色
                typeNumber: 4,
                correctLevel: QRCode.CorrectLevel.H,
                text: 'http://eggi.cn/÷' + this.activePlank.ggid,
              })
            }
          })
          // 如果激活了板件则记录当前的位置, 以便移动时的使用
          this.isMovingPlank = true
          // 记录当前板件的起始坐标
          this.plankStartPoint = {
            x: this.activePlank.startX,
            y: this.activePlank.startY,
          }
          // 记录选中板件的起始点和鼠标位置的差距
          this.activePlankOff = {
            x:
              (e.offsetX / this.scalePercent) * defaultScale -
              this.activePlank.startX,
            y:
              (e.offsetY / this.scalePercent) * defaultScale -
              this.activePlank.startY,
          }
          // 计算当前点击的位置, 鼠标位置相对于大板的偏移值
          this.plankRealOff = {
            x:
              ((e.offsetX - this.bigpart.subtleStartX - this.deviation) /
                this.scalePercent) *
                defaultScale -
              this.activePlank.startX,
            y:
              ((e.offsetY -
                this.bigpart.subtleStartY -
                this.topInfoHeight -
                this.deviation) /
                this.scalePercent) *
                defaultScale -
              this.activePlank.startY,
          }
          const sameWidthPlank =
            this.ncSetting.sawSetting.mentaoji_enable &&
            this.ncSetting.sawSetting.sawToLayout &&
            (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
              this.activePlank.isWeldingPlank)
          if (
            this.ncSetting.glass_setting ||
            this.bigpart.isLocked ||
            (this.activePlank && this.activePlank.isExpanded) ||
            sameWidthPlank ||
            (this.activePlank && isTextureAlignmentPlank(this.activePlank))
          ) {
            this.isMovingPlank = false
            if (_debounceTime) {
              clearTimeout(_debounceTime)
            }
            _debounceTime = setTimeout(() => {
              if (this.ncSetting.glass_setting) {
                this.$message.error(
                  this.$translateLang('生产线为玻璃切割机时，板件无法被移动')
                )
              }
              if (this.bigpart.isLocked) {
                this.$message.error(this.$translateLang('板件被锁定，无法编辑'))
              }
              if (this.activePlank.isExpanded) {
                this.$message.error(
                  this.$translateLang('板件存在拉槽特殊工艺，不支持编辑操作！')
                )
              }
              if (sameWidthPlank) {
                this.$message.error(
                  this.$translateLang('开启了锯片排版,板件无法移动')
                )
              }
              if (
                this.activePlank &&
                isTextureAlignmentPlank(this.activePlank)
              ) {
                this.$message.error(this.$translateLang('对纹板件无法移动'))
              }
            }, 100)
            return
          }
          // 异形板件，且开启了异形板分层切割
          this.isLayerCut = this.activePlank.curve_layered_cutting
          this.layerCutDepth = this.activePlank.curve_layered_cutting_deep
        }
      }
      // 鼠标右键
      if (e.button == 2) {
        if (this.isCuttingSurplus) {
          if (this.surplusPoint.length >= 4) {
            const isIntersect = hasSegmentsIntersection(this.surplusPoint)
            const firstPoint = this.surplusPoint[0]
            const endPoint = this.surplusPoint[this.surplusPoint.length - 1]
            if (isIntersect) {
              this.$message({
                message: '裁剪点位存在交叉问题，请重新裁剪',
                type: 'error',
              })
            } else if (
              firstPoint.x == endPoint.x ||
              firstPoint.y == endPoint.y
            ) {
              // 关闭输入框展示
              this.lineRecode.show = false
              this.addNewSurplus()
            } else {
              this.$message({
                message:
                  '不满足余料裁剪规则，请确保最后一个点位与第一个点位对齐',
                type: 'error',
              })
            }
          }
        } else {
          if (this.isMovingPlank) return
          this.bigpart.isActive = false
          this.emptyDistance = false
          this.isMovingCavnas = true
          this.canvasRightDrag = {
            x: e.offsetX,
            y: e.offsetY,
          }
        }
      }
    },
    // 鼠标松开事件
    async clickUpCanvas(e) {
      const { offsetX, offsetY } = e
      if (e.button == 0) {
        const mousePoint = {
          x: e.offsetX,
          y: e.offsetY,
        }
        if (this.isMovingCavnas) return
        const hasMoved = this.dragPosition !== null
        this.isMovingPlank = false
        this.dragPosition = null
        this.activePlankOff = null

        if (this.activePlank) {
          const sameWidthPlank =
            this.ncSetting.sawSetting.mentaoji_enable &&
            this.ncSetting.sawSetting.sawToLayout &&
            (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
              this.activePlank.isWeldingPlank)
          const oriActivePlank = JSON.parse(JSON.stringify(this.activePlank))
          if (
            this.ncSetting.glass_setting ||
            this.bigpart.isLocked ||
            this.activePlank.isExpanded ||
            sameWidthPlank
          )
            return
          // 如果鼠标位置在大板上, 则继续执行后面的逻辑, 否则弹回原位置重新绘制
          if (
            e.offsetX <=
              this.bigpart.subtleStartX +
                this.bigpart.subtleWidth +
                2 * this.deviation &&
            e.offsetY <=
              this.bigpart.subtleStartY +
                this.bigpart.subtleHeight +
                this.topInfoHeight +
                2 * this.deviation
          ) {
            // 计算选中板件相对于大板的位置
            this.activePlank.startX =
              ((e.offsetX - this.bigpart.subtleStartX - this.deviation) /
                this.scalePercent) *
                defaultScale -
              this.plankRealOff.x
            this.activePlank.startY =
              ((e.offsetY -
                this.bigpart.subtleStartY -
                this.topInfoHeight -
                this.deviation) /
                this.scalePercent) *
                defaultScale -
              this.plankRealOff.y
            this.plankRealOff = null
            buryPointApi('layout_sub', 'move_plate')
            // 重新处理选中板件的轮廓路径
            dealPlankPoly(this.activePlank)
            dealBigPlank(this.bigpart)

            let flag = false
            // 判断鼠标点击左键抬起和点击位置是否一样 一样就不需要吸附
            const { x, y } = this.clickPointOffset
            const t = !!(x === offsetX && y === offsetY)

            if (this.checkPlankAdsorption(this.activePlank)) {
              // 如果移动后的板件还是在当前选中的大板上, 则直接判断是否冲突
              const result = calcClosePlank(this.activePlank, this.bigpart)
              if (result && !t) {
                const { x, y } = result
                this.activePlank.startX = x
                this.activePlank.startY = y
                // 重新处理选中板件的轮廓路径
                dealPlankPoly(this.activePlank)
              }
            }
            flag = checkOnePlank(this.activePlank, this.bigpart)

            if (!flag) {
              this.activePlank.startX = this.plankStartPoint.x
              this.activePlank.startY = this.plankStartPoint.y
              dealPlankPoly(this.activePlank)
            }
            checkOneBigpart(this.bigpart)
          } else {
            this.activePlank.startX = this.plankStartPoint.x
            this.activePlank.startY = this.plankStartPoint.y
            dealPlankPoly(this.activePlank)
          }
          if (!this.isCuttingSurplus) {
            // 更新蓝色余料的数据
            this.updateBlueAreaSurplusPart(this.bigpart)
          }

          // 判断完冲突后, 重新绘制
          this.renderAll()
          this.$emit('recordPlankMove', {
            key: '精细排版移动小板',
            dataArr: [
              {
                type: 'form',
                current: {
                  startX: this.activePlank.startX,
                  startY: this.activePlank.startY,
                }, // 当前表单数据
                ori: {
                  startX: oriActivePlank.startX,
                  startY: oriActivePlank.startY,
                }, // 原始表单数据
                compareMsg: [
                  {
                    title: `${this.activePlank.partName}-大板序号：${this.bigpart.canvasIndex}`,
                    keys: ['startX', 'startY'],
                  },
                ], // 要比较的内容
                formTextObj: {
                  startX: '横坐标',
                  startY: '纵坐标',
                }, // key对应的意思
                formValueObj: {}, // value对应的意思
              },
            ],
          })
        }
      }
      if (e.button == 2) {
        if (this.isMovingPlank) return
        if (this.canvasOffset) {
          this.bigpart.subtleStartX += this.canvasOffset.x
          this.bigpart.subtleStartY += this.canvasOffset.y
        }
        this.isMovingCavnas = false
        this.canvasOffset = null
      }
    },
    drawDashLine(recordPoint, point, e) {
      const box = document.querySelector('#line_box')
      const firstPoint = this.surplusPoint[0]
      const diameter = this.ncSetting.glass_setting
        ? 0
        : Number(getPlateKnifeDiameter(this.bigpart.stockKey, this.ncSetting))
      if (this.nextDirection) {
        // 如果新的点在记录的点下方, 则长度不能超过计算的下方距离
        if (recordPoint.y > point.y) {
          let distance = Math.abs(recordPoint.y - point.y)
          if (distance > this.upDistance) {
            point.y = recordPoint.y - this.upDistance
          }
        } else {
          let distance = Math.abs(recordPoint.y - point.y)
          if (distance > this.downDistance) {
            point.y = recordPoint.y + this.downDistance
          }
        }
      } else {
        if (recordPoint.x > point.x) {
          let distance = Math.abs(recordPoint.x - point.x)
          if (distance > this.leftDistance) {
            point.x = recordPoint.x - this.leftDistance
          }
        } else {
          let distance = Math.abs(recordPoint.x - point.x)
          if (distance > this.rightDistance) {
            point.x = recordPoint.x + this.rightDistance
          }
        }
      }

      // 移动输入框位置
      if (point.x !== recordPoint.x || point.y !== recordPoint.y) {
        this.lineRecode.show = true
        this.lineRecode.point = { ...point }
        this.lineRecode.recordPoint = { ...recordPoint }
        if (this.nextDirection) {
          this.lineRecode.left = point.x + 30 + 'px'
          this.lineRecode.top = point.y - box.offsetHeight / 2 + 'px'
        } else {
          this.lineRecode.left = point.x - box.offsetWidth / 2 + 'px'
          this.lineRecode.top = point.y + 30 + 'px'
        }
        const { direction, axle, sym } = this.dealLineDirection(
          point,
          recordPoint
        )
        // 为了防止自动聚焦，影响裁剪撤销，所以注释掉
        // box.querySelector('input').focus()
        this.lineRecode.axle = axle
        this.lineRecode.sym = sym
        this.lineRecode.maxLine =
          (
            (this[`${direction}Distance`] / this.scalePercent) *
            defaultScale
          ).toFixed(2) -
          diameter -
          this.glassDilate
        this.lineRecode.current =
          (
            (Math.abs(point[axle] - recordPoint[axle]) * defaultScale) /
            this.scalePercent
          ).toFixed(2) -
          diameter -
          this.glassDilate
        this.drawSurplusLead(point, direction)
      } else {
        this.lineRecode.show = false
      }
      // 如果已经有三个点了, 且没有按住ctrl键, 则当第四个点与第一个点比较持平的时候, 会自动吸附到和第一个点持平的位置
      if (this.surplusPoint.length >= 3 && !e.ctrlKey) {
        // 通过判断第四个点和第一个点是否相近, 相近则自动校正x, y, 不相近说明是L形
        // 获取第一个记录点
        // 如果最后两个点的y轴相等, 说明最后一条绘制的线段为横线, 则下一条只能为竖线
        // body.style.cursor = 'crosshair'
        let closeIndex = 0
        const newPointList = this.surplusPoint.map((p, index) => {
          const newP = { ...p, index }
          // close 前缀为校正距离 Dis用于判断最近的矫正点
          if (this.nextDirection) {
            newP.closeY = Math.abs(e.offsetY - p.y)
            newP.xDis = Math.abs(e.offsetX - p.x)
          } else {
            newP.closeX = Math.abs(e.offsetX - p.x)
            newP.yDis = Math.abs(e.offsetY - p.y)
          }

          return newP
        })

        const closePointList = newPointList.filter((p) => {
          if (this.nextDirection) {
            return p.closeY <= 5
          } else {
            return p.closeX <= 5
          }
        })

        // 从近到远排序
        closePointList.sort((a, b) => {
          if (this.nextDirection) {
            return a.xDis - b.xDis
          } else {
            return a.yDis - b.yDis
          }
        })
        /** 取出最接近的点位 */
        const closePoint = closePointList[0]

        // 有就直接吸附靠近
        if (closePoint) {
          if (this.nextDirection) {
            point.y = closePoint.y
          } else {
            point.x = closePoint.x
          }
          closeIndex = closePoint.index
        }
        // 绘制吸附靠近点引线
        if (closePoint && closeIndex !== this.surplusPoint.length - 1) {
          this.drawLine(closePoint, point)
          BODY.style.cursor = 'crosshair'
          this.lineRecode.show = false
        } else {
          BODY.style.cursor = 'default'
        }
      }

      // const newPoint = this.cutPointComp(point)
      // if (newPoint) {
      //   point = newPoint
      //   this.drawLine(newPoint, firstPoint)
      // }

      // console.log({ ...recordPoint }, { ...newPoint }, '====')
      this.ctx.beginPath()
      this.ctx.setLineDash([])
      this.ctx.moveTo(recordPoint.x, recordPoint.y)
      this.ctx.lineTo(point.x, point.y)
      this.ctx.stroke()
      this.ctx.setLineDash([])
      this.ctx.closePath()
    },
    /** 裁剪点位最后的自动补全 */
    cutPointComp(point) {
      if (this.surplusPoint.length < 4) return null
      /** 裁剪点位第一个点 */
      const firstPoint = this.surplusPoint[0]
      const finalPoint = this.surplusPoint[this.surplusPoint.length - 1]
      const finalSecondPoint = this.surplusPoint[this.surplusPoint.length - 2]
      const nextDirection = finalPoint.y == finalSecondPoint.y
      switch (this.surplusPoint.length) {
        // 如果已经有7个点了, 则会直接确定第8个点，如果有 8 个点, 则自动确定第 9 个点
        case 7:
        case 8:
          const copyPoint = { ...point }
          // 如果竖向绘制, 则第八个点的y轴等于第一个点的y轴 并且没有其他点与第一点齐平
          if (nextDirection) {
            copyPoint.y = firstPoint.y
          } else {
            // 如果横向绘制, 则第八个点的x轴等于第一个点的x轴
            copyPoint.x = firstPoint.x
          }
          // const isShapeSingle = checkShapeSingle([
          //   ...this.surplusPoint,
          //   copyPoint,
          // ])

          const checkArr = [
            ...this.surplusPoint,
            copyPoint,
            this.surplusPoint[0],
          ]

          const isIntersect = hasSegmentsIntersection(checkArr)
          this.lineRecode.show = false
          if (!isIntersect) {
            return copyPoint
          }
          break
        default:
          break
      }
    },
    /**绘制一条线段 */
    drawLine(head, tail) {
      this.ctx.save()
      this.ctx.beginPath()
      this.ctx.strokeStyle = '#9DCEFF'
      this.ctx.setLineDash([4, 2])
      this.ctx.moveTo(tail.x, tail.y)
      this.ctx.lineTo(head.x, head.y)
      this.ctx.stroke()
      this.ctx.restore()
    },
    /** 绘制余料引线 */
    drawSurplusLead(currentPoint, direction) {
      const startX = this.bigpart.subtleStartX
      const startY = this.bigpart.subtleStartY
      const axle = direction == 'up' || direction == 'down' ? 'Y' : 'X'
      let { x, y } = currentPoint
      const p = {
        X:
          ((x - this.bigpart.subtleStartX - this.deviation) /
            this.scalePercent) *
          defaultScale,
        Y:
          ((y -
            this.bigpart.subtleStartY -
            this.deviation -
            this.topInfoHeight) /
            this.scalePercent) *
          defaultScale,
        key: true,
      }

      const key = `${axle}${Math.ceil(p[axle] / 100)}`
      const result = this[`${axle.toLowerCase()}AxleLeadData`][key]
      if (!result) return
      // 很难找到和当前位置对应的点位 所以有上下5像素的误差
      let d = this[`${axle.toLowerCase()}AxleLeadData`][key].filter((item) => {
        return Math.abs(Math.ceil(item[`${axle}`]) - p[`${axle}`]) <= 5
      })
      if (d.length === 0) return
      d = [...d, p]
      // 在X轴上移动，找Y轴上在范围内的点位
      const leadAxle = axle == 'X' ? 'Y' : 'X'
      d = d.sort(compare(leadAxle, 'up', leadAxle))
      const index = d.findIndex((item) => item.key)
      const leadPoint = [d[index - 1], d[index + 1]]
      leadPoint.forEach((point) => {
        if (!point) return
        const sx =
          (p.X * this.scalePercent) / defaultScale + this.deviation + startX
        const sy =
          (p.Y * this.scalePercent) / defaultScale +
          this.topInfoHeight +
          this.deviation +
          startY
        const ex =
          (point.X * this.scalePercent) / defaultScale + this.deviation + startX
        const ey =
          (point.Y * this.scalePercent) / defaultScale +
          this.topInfoHeight +
          this.deviation +
          startY
        const w = 10,
          h = 10
        this.ctx.save()
        this.ctx.beginPath()
        this.ctx.strokeStyle = '#FF0000'
        this.ctx.setLineDash([4, 2])
        this.ctx.moveTo(ex, ey)
        // 根据方向的不同，保持和计算各个方向可延申的线段一样都最长距离上减去0.001，吸附过去但是点位不会和吸附的点位一摸一样
        // 会放置在点位旁边
        const boundaryV =
          direction == 'right' || direction == 'down' ? -0.001 : 0.001
        if (axle === 'X') {
          this.ctx.lineTo(ex, sy)
          this.nextPoint = {
            x: ex + boundaryV,
            y: sy,
          }
        } else {
          this.ctx.lineTo(sx, ey)
          this.nextPoint = {
            x: sx,
            y: ey + boundaryV,
          }
        }

        this.ctx.strokeRect(ex - w / 2, ey - h / 2, w, h)
        this.ctx.stroke()
        this.ctx.restore()
      })
    },
    // 余料吸附
    surPlusAbsorb(e, type = 'move') {
      const startX = this.bigpart.subtleStartX
      const startY = this.bigpart.subtleStartY
      const point = {
        x: e.offsetX,
        y: e.offsetY,
      }
      const p = {
        x:
          ((point.x - this.bigpart.subtleStartX - this.deviation) /
            this.scalePercent) *
          defaultScale,
        y:
          ((point.y -
            this.bigpart.subtleStartY -
            this.deviation -
            this.topInfoHeight) /
            this.scalePercent) *
          defaultScale,
        key: true,
      }
      // 找当前点位对应的key的值
      const xKey = `X${Math.ceil(p.x / 100)}`
      const yKey = `Y${Math.ceil(p.y / 100)}`
      const xData = this.xAxleLeadData[xKey] ? this.xAxleLeadData[xKey] : []
      const yData = this.yAxleLeadData[yKey] ? this.yAxleLeadData[yKey] : []
      const directionArr = [...xData, ...yData]
      // 找当当前鼠标点位周边xy相加之和在50之内所有点位
      const result = directionArr.filter((item) => {
        if (!item) return
        const total = p.x + p.y
        const itemTotal = item.X + item.Y
        return Math.abs(total - itemTotal) <= 50
      })
      if (type !== 'move' && (!result || result.length === 0)) {
        this.drawSurplus(e)
      }
      if (!result || result.length === 0) return
      let resultPoint = result[0]
      // 在找到的点位中找到，距离鼠标位置最近的一个点位
      let num = 50
      result.forEach((item) => {
        const total = p.x + p.y
        const itemTotal = item.X + item.Y
        if (Math.abs(total - itemTotal) <= num) {
          num = Math.abs(total - itemTotal)
          resultPoint = item
        }
      })
      // 过滤后的有效点位
      let filterPoint = null
      const ex =
        (resultPoint.X * this.scalePercent) / defaultScale +
        this.deviation +
        startX
      const ey =
        (resultPoint.Y * this.scalePercent) / defaultScale +
        this.topInfoHeight +
        this.deviation +
        startY
      // 将吸附点位放置在找到的点为周边，需先判断点位放置的位置是否在板件内部
      // 在各个方向上进行点位变化，找到和板件不冲突的点位
      // 0.001太小会导致某些不应该能够吸附的点位也能吸附
      const dealPoint = [
        { offsetX: ex - 0.1, offsetY: ey - 0.1, k: '上左--' },
        { offsetX: ex + 0.1, offsetY: ey + 0.1, k: '上右++' },
        { offsetX: ex - 0.1, offsetY: ey + 0.1, k: '下左-+' },
        { offsetX: ex + 0.1, offsetY: ey - 0.1, k: '下右+-' },
      ]
      // 将点位在小板中和小板外的分开
      const passPoint = [] //保存小板内的点位
      filterPoint = dealPoint.filter((item) => {
        if (!this.setActivePlank(item)) {
          return true
        } else {
          passPoint.push(item)
        }
      })
      if (!filterPoint.length) return
      // 排除不在大板内的点位
      const inBigPlankPoint = filterPoint.filter((item) => {
        const { offsetX: x, offsetY: y } = item
        return this.isInBigPlank({ x, y })
      })
      if (!inBigPlankPoint.length) return
      this.ctx.save()
      this.ctx.strokeStyle = '#0000FF'
      this.ctx.strokeRect(ex - 5, ey - 5, 10, 10)
      this.ctx.stroke()
      this.ctx.restore()
      if (type !== 'move') {
        let resPoint = {}
        /**
         * 排除小板内大板外的点位后，判断是否能找到和小板内点位xy都不相同的在大板内的点位
         * 找到则用这个点位，没找到则用被排除的第一个点位 也就是 d数组
         */
        if (passPoint.length === 1) {
          let p = passPoint[0]
          let d = []
          resPoint = inBigPlankPoint.filter((item) => {
            if (item.offsetX !== p.offsetX && item.offsetY !== p.offsetY) {
              return true
            } else {
              d.push(item)
            }
          })
          resPoint = resPoint.length ? resPoint[0] : d[0]
        } else {
          resPoint = filterPoint[0]
        }
        const ePoint = {
          offsetX: resPoint.offsetX,
          offsetY: resPoint.offsetY,
        }
        this.drawSurplus(ePoint)
      }
    },
    /**
     * sym true +号  false -号
     */
    dealLineDirection(point, recordPoint) {
      let direction = ''
      let axle = ''
      let sym = ''
      if (point.x === recordPoint.x) {
        if (point.y < recordPoint.y) {
          direction = 'up'
          sym = false
        } else {
          direction = 'down'
          sym = true
        }
        axle = 'y'
      } else {
        if (point.x < recordPoint.x) {
          direction = 'left'
          sym = false
        } else {
          direction = 'right'
          sym = true
        }
        axle = 'x'
      }
      return { direction, axle, sym }
    },
    // 输入生成引线
    dealCurrentLineLength() {
      if (
        this.lineRecode.current < 1 ||
        this.lineRecode.current > this.lineRecode.maxLine
      ) {
        this.$message.warning('输入数值有误,请重新输入!')
        return
      }
      let diameter = +getPlateKnifeDiameter(
        this.bigpart.stockKey,
        this.ncSetting
      )
      if (this.ncSetting.glass_setting) {
        diameter = 0
      }
      const long =
        ((+this.lineRecode.current + diameter + this.glassDilate) *
          this.scalePercent) /
        defaultScale
      this.lineRecode.recordPoint[this.lineRecode.axle] = this.lineRecode.sym
        ? this.lineRecode.recordPoint[this.lineRecode.axle] + long
        : this.lineRecode.recordPoint[this.lineRecode.axle] - long
      let point = {
        x: this.lineRecode.recordPoint.x,
        y: this.lineRecode.recordPoint.y,
      }
      if (this.lineRecode.current == this.lineRecode.maxLine) {
        point[this.lineRecode.axle] -= 0.001
      }
      this.nextPoint = point
      this.drawSurplus(this.lineRecode.e)
    },
    // 鼠标拖动生成模板
    dealSurPlusCut(surPlus, e) {
      const startX = this.bigpart.subtleStartX
      const startY = this.bigpart.subtleStartY
      // 转化成数值类型
      surPlus.width = +surPlus.width
      surPlus.length = +surPlus.length
      const d = {
        x: surPlus.width / 2,
        y: surPlus.length / 2,
      }
      const point = this.windowToCanvas(e.offsetX, e.offsetY)
      if (!point) return
      // this.scalePercent和defaultScale是缩放比例 this.deviation是大板和大板边框的差值
      const p = {
        x:
          ((point.x - this.bigpart.subtleStartX - this.deviation) /
            this.scalePercent) *
          defaultScale,
        y:
          ((point.y -
            this.bigpart.subtleStartY -
            this.deviation -
            this.topInfoHeight) /
            this.scalePercent) *
          defaultScale,
      }
      const diameter = +getPlateKnifeDiameter(
        this.bigpart.stockKey,
        this.ncSetting
      )
      const plank = {
        polyArr: [
          [
            { X: p.x - d.x, Y: p.y - d.y },
            { X: surPlus.width + p.x - d.x, Y: p.y - d.y },
            { X: surPlus.width + p.x - d.x, Y: surPlus.length + p.y - d.y },
            { X: p.x - d.x, Y: surPlus.length + p.y - d.y },
          ],
        ],
        startX: p.x - d.x,
        startY: p.y - d.y,
        rect: {
          x: 0,
          y: 0,
          width: surPlus.width + diameter,
          height: surPlus.length + diameter,
        },
      }
      const isFlag = checkOnePlank(plank, this.bigpart)
      if (!isFlag) {
        return this.$message.error(translate('arrangedPage.tempErr'))
      }
      const next = plank.polyArr[0].shift()
      this.surplusPoint = plank.polyArr[0].map((item) => ({
        x:
          (item.X * this.scalePercent) / defaultScale + this.deviation + startX,
        y:
          (item.Y * this.scalePercent) / defaultScale +
          this.topInfoHeight +
          this.deviation +
          startY,
      }))
      this.nextPoint = {
        x:
          (next.X * this.scalePercent) / defaultScale + this.deviation + startX,
        y:
          (next.Y * this.scalePercent) / defaultScale +
          this.topInfoHeight +
          this.deviation +
          startY,
      }
      this.drawSurplus(point)
      this.lineRecode.show = false
      this.addNewSurplus()
    },
    calcNextPoint(e) {
      let point1 = this.surplusPoint[this.surplusPoint.length - 2]
      let point2 = this.surplusPoint[this.surplusPoint.length - 1]
      // 判断下一条线段的方向, true为竖线, false为横线
      // 如果最后两个点的y轴相等, 说明最后一条绘制的线段为横线, 则下一条只能为竖线
      if (point1.y == point2.y) {
        this.nextDirection = true
      }
      if (point1.x == point2.x) {
        this.nextDirection = false
      }
      let point = {}
      if (this.nextDirection) {
        point = {
          x: point2.x,
          y: e.offsetY,
        }
      } else {
        point = {
          x: e.offsetX,
          y: point2.y,
        }
      }
      const clampedPoint = this.clampSurplusPointToCounter(point)
      this.drawDashLine(point2, clampedPoint, e)
      this.nextPoint = clampedPoint
    },
    // 鼠标移动事件
    movePlank(e) {
      // 锁的Hover事件
      const mousePoint = {
        x: e.offsetX,
        y: e.offsetY,
      }
      const { lockPath } = this.setLockInfo()
      const result = this.jundgeLocation(mousePoint, lockPath)
      if (result && (this.bigpart.isLocked || this.bigpart.isActive)) {
        this.lockHoverInfo.isShow = true
        this.lockHoverInfo.top = e.pageY + 24 * this.scalePercent
        this.lockHoverInfo.left = e.pageX - 94
        this.lockHoverInfo.isLocked = this.bigpart.isLocked
      } else {
        this.lockHoverInfo.isShow = false
      }
      // 裁剪模式下，可以选中移动小板
      if (
        this.isCuttingSurplus &&
        !(
          isCanvasPixelDrawn(this.ctx, e.offsetX, e.offsetY) &&
          !this.surplusPoint.length
        )
      ) {
        if (this.isAdsorb) {
          this.renderAll()
          this.surPlusAbsorb(e)
        }
        if (this.surplusPoint.length > 0) {
          this.renderAll()
          this.ctx.beginPath()
          this.ctx.setLineDash([])
          this.ctx.strokeStyle = '#000'
          for (let i = 0; i < this.surplusPoint.length; ++i) {
            if (i == 0) {
              this.ctx.moveTo(this.surplusPoint[i].x, this.surplusPoint[i].y)
            } else {
              this.ctx.lineTo(this.surplusPoint[i].x, this.surplusPoint[i].y)
            }
          }
          this.ctx.stroke()
          this.ctx.closePath()

          // 如果只有一个点, 则可以任意选择是横向还是竖向
          if (this.surplusPoint.length == 1) {
            let point = {
              x: e.offsetX,
              y: e.offsetY,
            }
            let recordPoint = this.surplusPoint[0]
            let pointXOff = Math.abs(recordPoint.x - e.offsetX)
            let pointYOff = Math.abs(recordPoint.y - e.offsetY)
            if (pointXOff <= pointYOff) {
              point.x = recordPoint.x
              this.nextDirection = true
            } else {
              point.y = recordPoint.y
              this.nextDirection = false
            }
            this.nextPoint = this.clampSurplusPointToCounter(point)
            this.drawDashLine(recordPoint, this.nextPoint, e)
          } else {
            this.calcNextPoint(e)
          }
        }
        return
      }
      if (this.isMovingPlank) {
        if (this.activePlank) {
          this.dragPosition = {
            x: e.offsetX,
            y: e.offsetY,
          }
          this.renderAll()
        }
      } else {
        const pointInRect = this.needMarkRectArr.find((rect) =>
          checkPointInRect(mousePoint, rect)
        )
        if (pointInRect) {
          this.markRect = pointInRect
          this.markRectTip = {
            x: pointInRect.x,
            y:
              pointInRect.y -
              (pointInRect.height * 2 * this.scalePercent) / defaultScale,
          }
          this.mousePoint = {
            x: pointInRect.x,
            y:
              pointInRect.y -
              (pointInRect.height * 2 * this.scalePercent) / defaultScale,
          }
          this.renderAll()
        } else {
          this.markRect = null
          this.markRectTip = null
          this.renderAll()
        }
      }
      // 裁剪模式下 不能拖动大板
      if (this.isMovingCavnas && !this.isCuttingSurplus) {
        this.canvasOffset = {
          x: e.offsetX - this.canvasRightDrag.x,
          y: e.offsetY - this.canvasRightDrag.y,
        }
        this.renderAll()
      }
      if (!this.activePlank) {
        if (_debounceTime) {
          clearTimeout(_debounceTime)
        }
        _debounceTime = setTimeout(() => {
          const activePart = this.plankControl.gitDetailActivePart(
            e,
            this.bigpart,
            {
              deviation: this.deviation,
              topInfoHeight: this.topInfoHeight,
              scalePercent: this.scalePercent,
              defaultScale,
            }
          )
          this.conflictPart =
            partIsConflict(activePart) && !this.activePlank ? activePart : null
        }, 200)
      }

      if (this.activePlank && !this.isMovingPlank) {
        const point = { x: e.offsetX, y: e.offsetY }
        if (_debounceTime) {
          clearTimeout(_debounceTime)
        }
        const activePlankTemp = transformData(this.activePlank, store)
        _debounceTime = setTimeout(() => {
          // 绘制孔槽等的详细信息
          // 我知道你会疑惑上面不是判断了this.activePlank有值才会进入，为啥这里又要判断，这一步是因为这里是宏任务，这里的this.activePlank可能存在null的情况
          if (this.activePlank) {
            this.hsDetailInfoList = drawActivePlankOtherInfo(
              this.bigpart,
              point,
              activePlankTemp,
              {
                deviation: this.deviation,
                padding: this.topInfoHeight,
                scalePercent: this.scalePercent,
                defaultScale: defaultScale,
              },
              'jingxi'
            )
          }
          if (this.isRenderHSDetail) {
            this.renderAll()
            this.isRenderHSDetail = false
          }
          if (this.hsDetailInfoList.length) {
            this.mousePoint = point
            this.renderAll()
            this.isRenderHSDetail = true
          }
        }, 50)
      } else {
        this.hsDetailInfoList = []
      }
    },
    // 滚轮缩放
    wheelScale(e) {
      if (e.ctrlKey) {
        this.emptyDistance = false
        this.scaleCanvas(e)
      }
    },
    /**
     * 滚轮缩放事件
     * @param { Object } event 事件对象
     */
    scaleCanvas(event, toolScale, isReset = false) {
      // 判断滚轮方向
      let direction = true
      if (isReset) {
        this.scale = this.oriScale = 5
        this.zoomNum = 1
      } else {
        if (event.wheelDelta > 0) {
          if (toolScale) {
            this.scale += this.oriScale * toolScale
          } else {
            this.scale += this.oriScale * 0.1
          }
          this.zoomNum += 0.1
        } else {
          if (this.scale - this.oriScale * 0.5 < 0.0001) return

          if (toolScale) {
            this.scale += this.oriScale * toolScale
          } else {
            this.scale -= this.oriScale * 0.1
          }
          this.zoomNum -= 0.1

          direction = false
        }
      }

      this.drawData.forEach((draw) => {
        draw.data.forEach((plank) => {
          if (plank.stockKey === this.bigpart.stockKey) {
            plank.zoomNum = this.zoomNum
          }
        })
      })
      this.$emit('wheelScale', this.zoomNum)
      this.scaleComputed()
    },
    scaleComputed() {
      // 记录上一次缩放的比例
      let lastScale = this.scalePercent
      // 计算缩放的比例
      this.scalePercent = this.scale / defaultScale
      // 计算各种间距和大板宽度缩放后的值
      this.topInfoHeight = defaultTopInfoHeight * this.scalePercent
      this.deviation = defaultDeviation * this.scalePercent
      this.dotWidth = defaultDotWidth * this.scalePercent
      this.textWidth = defaultTextWidth * this.scalePercent
      this.bigpart.subtleWidth =
        (this.bigpart.subtleWidth / lastScale) * this.scalePercent
      this.bigpart.subtleHeight =
        (this.bigpart.subtleHeight / lastScale) * this.scalePercent
      this.renderAll()
    },

    /**
     *
     * @param {String} info 提示信息
     */
    messageDebunce(info) {
      clearTimeout(this.messageTimer)
      if (this.isMessage) {
        this.$message({
          message: info,
          type: 'info',
          duration: 2000,
        })
        this.isMessage = false
        this.messageTimer = setTimeout(() => {
          this.isMessage = true
        }, 500)
      }
    },
    /*坐标转换*/
    windowToCanvas(x, y) {
      let canvasDom = this.$refs.subtleCanvas
      if (!canvasDom) return null
      // getBoundingClientRect()获取元素相对于视口的位置
      let box = canvasDom.getBoundingClientRect() //这个方法返回一个矩形对象，包含四个属性：left、top、right和bottom。分别表示元素各边与页面上边和左边的距离
      return {
        x: x - box.left - (box.width - canvasDom.width) / 2,
        y: y - box.top - (box.height - canvasDom.height) / 2,
      }
    },

    // 判断哪些是需要进行距离计算的选段
    judgeDirectionLine(
      activeArr,
      partArr,
      activePath,
      activePlank,
      part,
      direction,
      stripMeasureActiveBbox = false
    ) {
      // 记录板件间隙
      let distanceArr = []
      const isDoorFrame =
        this.ncSetting.sawSetting?.mentaoji_enable &&
        this.ncSetting.sawSetting?.processType === 'doorFrame' &&
        isSawPaiban(this.$store)
      let gap = isDoorFrame ? 0 : this.ncSetting.panelSize.layoutGap
      let { activeTop, activeBottom, activeLeft, activeRight } = activeArr
      let { partTop, partBottom, partLeft, partRight } = partArr
      let maxNum = 0
      let minNum = 0
      const epsStrip = 0.5
      if (direction == 'up' || direction == 'down') {
        if (stripMeasureActiveBbox) {
          const cxActive = (activeLeft + activeRight) / 2
          maxNum = Math.max(partLeft, cxActive - epsStrip)
          minNum = Math.min(partRight, cxActive + epsStrip)
        } else {
          maxNum = Math.max(partLeft, activeLeft)
          minNum = Math.min(partRight, activeRight)
        }
      } else {
        if (stripMeasureActiveBbox) {
          const cyActive = (activeTop + activeBottom) / 2
          maxNum = Math.max(partTop, cyActive - epsStrip)
          minNum = Math.min(partBottom, cyActive + epsStrip)
        } else {
          maxNum = Math.max(partTop, activeTop)
          minNum = Math.min(partBottom, activeBottom)
        }
      }
      // 判断交集的方法, 取两个区间(a, b)(c, d), 如果a和c的最大值小于b和d的最小值, 说明存在交集
      // 注意精度问题
      // 当最大的坐标小于最小的坐标且不相等时, 才会进入判断
      if (maxNum < minNum && Math.abs(maxNum - minNum) > 0.0001) {
        // 如果记录板件与选中板件都为矩形, 则直接求两个板件之间的距离
        if (!activePlank.path && !part.path) {
          if (direction == 'up') {
            // 如果比较板件的顶部小于选中板件的底部, 则在按上的时候不需要继续计算距离
            if (activeBottom < partTop) return { msg: 'continue' }
            // 如果是已经贴合了, 则直接记录最小的板件间隙的值, 当前不可移动, 直接跳出循环
            if (Math.abs(activeTop - partBottom + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = activeTop - partBottom
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
          if (direction == 'down') {
            // 如果比较板件的底部小于选中板件的顶部, 则在按下的时候不需要继续计算距离
            if (partBottom < activeTop) return { msg: 'continue' }
            // 如果是已经贴合了, 则直接记录最小的板件间隙的值, 当前不可移动, 直接跳出循环
            if (Math.abs(partTop - activeBottom + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = partTop - activeBottom
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
          if (direction == 'left') {
            // 如果比较板件的
            if (activeLeft < partRight) return { msg: 'continue' }
            if (Math.abs(activeLeft - partRight + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = activeLeft - partRight
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
          if (direction == 'right') {
            if (activeRight > partLeft) return { msg: 'continue' }
            if (Math.abs(partLeft - activeRight + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = partLeft - activeRight
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
        }
        // 记录交集
        let range = {}
        if (direction == 'up' || direction == 'down') {
          range.x1 = maxNum
          range.x2 = minNum
        } else {
          range.y1 = maxNum
          range.y2 = minNum
        }

        // 记录比较板件的边框点位
        let partPath = []
        if (part.path) {
          // 先判断小板是否处于比较板件的内部
          if (part.path.length > 1) {
            // 如果是在内部, 则判断是否存在挖洞, 则循环判断每一个选中的板件是否在某一个挖洞内部
            let flag = polyContain([part.polyArr[0]], [activePlank.polyArr[0]])
            if (flag) {
              for (let i = 0; i < part.path.length; ++i) {
                if (i == 0) continue
                let newFlag = polyContain(
                  [part.polyArr[i]],
                  [activePlank.polyArr[0]]
                )
                if (newFlag) {
                  partPath = part.path[i]
                  break
                }
              }
            } else {
              partPath = part.path[0]
            }
          } else {
            partPath = part.path[0]
          }
        } else {
          partPath = [
            { x: 0, y: 0 },
            { x: part.rect.width, y: 0 },
            { x: part.rect.width, y: part.rect.height },
            { x: 0, y: part.rect.height },
          ]
        }

        // 记录比较板件的所有在交集范围内的横线线段
        let partLineArr = this.getPlankLine(
          partPath,
          part.startX,
          part.startY,
          direction,
          range
        )
        // 根据方向获取选中板件的线段
        // 如果选中的板件是有挖洞的, 则需要重新计算选中板件的点位, 判断和其他板件是否有包含关系
        if (
          !stripMeasureActiveBbox &&
          activePlank.path &&
          activePlank.path.length > 1
        ) {
          // 如果是在内部, 则判断是否存在挖洞, 则循环判断每一个选中的板件是否在某一个挖洞内部
          let flag = polyContain([activePlank.polyArr[0]], [part.polyArr[0]])
          if (flag) {
            for (let i = 0; i < activePlank.path.length; ++i) {
              if (i == 0) continue
              let newFlag = polyContain(
                [activePlank.polyArr[i]],
                [part.polyArr[0]]
              )
              if (newFlag) {
                activePath = activePlank.path[i]
                break
              }
            }
          }
        }
        this.isActivePlankLine = true
        let activeLineArr = this.getPlankLine(
          activePath,
          activePlank.startX,
          activePlank.startY,
          direction,
          range
        )
        this.isActivePlankLine = false
        distanceArr = this.calcDistance(
          activeLineArr,
          partLineArr,
          direction,
          true
        )
        return {
          msg: 'finish',
          data: distanceArr,
          activeLineArr: activeLineArr,
        }
      }
      return { msg: 'continue' }
    },

    /** Ctrl+Z / Cmd+Z：键盘撤销（不在输入框内拦截，避免影响原生撤销） */
    handleKeyboardShortcut(e) {
      const isZ = e.code === 'KeyZ' || e.key === 'z' || e.key === 'Z'
      // 如果按下的是Ctrl+Z或Cmd+Z，则执行撤销操作
      if (!(e.ctrlKey || e.metaKey) || !isZ || e.shiftKey) {
        // 如果按下的是回车键，则自动聚焦到输入框
        if (e.code === 'Enter') {
          const box = document.querySelector('#line_box')
          if (box) {
            box.querySelector('input').focus()
          }
        }
      } else {
        const el = e.target
        if (
          el &&
          (el.tagName === 'INPUT' ||
            el.tagName === 'TEXTAREA' ||
            el.isContentEditable)
        ) {
          return false
        }
        e.preventDefault()
        this.surplusCuttingUndo()
      }
    },

    surplusCuttingUndo() {
      this.surplusPoint.pop()
      this.renderAll()

      if (this.surplusPoint.length > 0) {
        const lastPoint = this.surplusPoint[this.surplusPoint.length - 1]
        this.calcPointDistance(lastPoint)
        this.ctx.beginPath()
        this.ctx.setLineDash([])
        this.ctx.strokeStyle = '#000'
        for (let i = 0; i < this.surplusPoint.length; ++i) {
          if (i == 0) {
            this.ctx.moveTo(this.surplusPoint[i].x, this.surplusPoint[i].y)
          } else {
            this.ctx.lineTo(this.surplusPoint[i].x, this.surplusPoint[i].y)
          }
        }
        this.ctx.stroke()
        this.ctx.closePath()
      } else {
        this.lineRecode.show = false
        this.nextPoint = null
      }
    },

    // 键盘按下事件
    keyDownFuncs() {
      return async (e) => {
        if (this.isCuttingSurplus) {
          this.handleKeyboardShortcut(e)
          return
        }
        if (e.ctrlKey) {
          // e.preventDefault()
          this.isScaling = true
          // 复选（Ctrl 多选）：首次进入时把当前激活小板带进列表，避免高亮瞬间消失
          const wasBatchActive = this.isBatchActive
          this.isBatchActive = true
          if (
            !wasBatchActive &&
            !this.batchActiveIdList.length &&
            this.activePlank?.partUniqueId
          ) {
            this.batchActiveIdList = [this.activePlank.partUniqueId]
            this.renderAll()
          }
        }
        if (
          (e.code == 'ArrowUp' ||
            e.code == 'ArrowDown' ||
            e.code == 'ArrowLeft' ||
            e.code == 'ArrowRight') &&
          this.isMovingPlank
        ) {
          e.preventDefault()
          return
        }
        if (
          this.activePlank &&
          (e.code == 'ArrowUp' ||
            e.code == 'ArrowDown' ||
            e.code == 'ArrowLeft' ||
            e.code == 'ArrowRight')
        ) {
          e.preventDefault()
          const sameWidthPlank =
            this.ncSetting.sawSetting.mentaoji_enable &&
            ((this.ncSetting.sawSetting.sawToLayout &&
              (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
                this.activePlank.isWeldingPlank)) ||
              this.ncSetting.sawSetting.processType === 'doorFrame')
          if (this.ncSetting.glass_setting) {
            return this.$message.error(
              this.$translateLang('生产线为玻璃切割机时，板件无法被移动')
            )
          }
          if (this.bigpart.isLocked) {
            return this.$message.error(
              this.$translateLang('板件被锁定，无法编辑')
            )
          }
          if (this.activePlank.isExpanded) {
            return this.$message.error(
              this.$translateLang('板件存在拉槽特殊工艺，不支持编辑操作！')
            )
          }
          if (sameWidthPlank) {
            return this.$message.error(
              this.$translateLang('开启了锯片排版,板件无法移动')
            )
          }
          if (isTextureAlignmentPlank(this.activePlank)) {
            return this.$message.error(this.$translateLang('对纹板件无法移动'))
          }
          let direction = ''
          switch (e.code) {
            case 'ArrowUp':
              direction = 'up'
              break
            case 'ArrowDown':
              direction = 'down'
              break
            case 'ArrowLeft':
              direction = 'left'
              break
            case 'ArrowRight':
              direction = 'right'
              break
          }
          // 记录移动前的位置
          const { startX, startY } = this.activePlank
          const bigpart = this.bigpart
          const filteredParts = bigpart.parts.filter(
            (part) => !part.blueAreaSurplus
          )

          let distance = 0
          let moveAp = this.resolveLiveActivePart(bigpart) || this.activePlank

          if (this.$props.isShowMoveStep) {
            const ap = moveAp
            if (!ap) return
            if (ap !== this.activePlank) {
              this.activePlank = ap
            }
            distance = this.calcKeyboardMoveDistance(
              ap,
              bigpart,
              filteredParts,
              direction
            )
          } else {
            // 记录所有距离（未开启步长显示时沿用原逻辑，单次最大 20）
            let distanceArr = []
            // 计算当前选中板件上下左右四个方向的坐标
            let activeArr = {
              activeLeft: this.activePlank.startX,
              activeRight:
                this.activePlank.startX + this.activePlank.rect.width,
              activeTop: this.activePlank.startY,
              activeBottom:
                this.activePlank.startY + this.activePlank.rect.height,
            }

            // 获取选中板件的边框点位
            let activePath = []
            if (this.activePlank.path) {
              activePath = this.activePlank.path[0]
            } else {
              activePath = [
                { x: 0, y: 0 },
                { x: this.activePlank.rect.width, y: 0 },
                {
                  x: this.activePlank.rect.width,
                  y: this.activePlank.rect.height,
                },
                { x: 0, y: this.activePlank.rect.height },
              ]
            }
            const loopParts = getPotentialCollisionsParts(
              this.activePlank,
              filteredParts,
              direction
            )
            for (let i = 0; i < loopParts.length; ++i) {
              let part = loopParts[i]
              let partArr = {
                partLeft: part.startX,
                partRight: part.startX + part.rect.width,
                partTop: part.startY,
                partBottom: part.startY + part.rect.height,
              }
              let result = this.judgeDirectionLine(
                activeArr,
                partArr,
                activePath,
                this.activePlank,
                part,
                direction
              )
              if (result.data) {
                distanceArr = [...distanceArr, ...result.data]
              }
              if (result.msg == 'continue') continue
              if (result.msg == 'break') break
            }

            let distanceArr2 = []
            let bigPartLineArr = this.dealBigPlankLine(bigpart.bigPlank[0])
            this.isActivePlankLine = true
            let activeLineArr = this.getPlankLine(
              activePath,
              this.activePlank.startX,
              this.activePlank.startY,
              direction
            )
            this.isActivePlankLine = false
            distanceArr2 = this.calcBigPlankDistance(
              activeLineArr,
              bigPartLineArr,
              direction
            )

            // 台面宽度限制：按 xyReverse 计入到台面边界的距离
            const counterClearance = getCounterAxisClearance(
              direction,
              activeArr,
              {
                plankWidth: Number(bigpart.plankWidth) || 0,
                plankHeight: Number(bigpart.plankHeight) || 0,
                bigpart,
              },
              this.ncSetting
            )
            if (
              Number.isFinite(counterClearance) &&
              compareTowNum(counterClearance, 0, '>=')
            ) {
              distanceArr2.push(Math.max(0, counterClearance))
            }

            let distance999 = 99999
            let distance2 = Math.min(...distanceArr2)
            if (compareTowNum(distance2, 20, '>=')) distance2 = 20

            if (distanceArr.length > 0) {
              let plankDistance = Math.min(...distanceArr)
              if (compareTowNum(plankDistance, 0, '>=')) {
                distance999 = plankDistance
                const isDoorFrame =
                  this.ncSetting.sawSetting?.mentaoji_enable &&
                  this.ncSetting.sawSetting?.processType === 'doorFrame' &&
                  isSawPaiban(this.$store)
                let gap = isDoorFrame ? 0 : this.ncSetting.panelSize.layoutGap
                gap = gap == 0 ? 0.01 : gap
                if (compareTowNum(distance999, gap, '>=')) {
                  distance999 = distance999 - gap
                  if (distance999 < 0) distance999 = 0
                  if (distance999 > 0) {
                    if (compareTowNum(distance999, 20, '>=')) {
                      distance999 = 20
                    }
                  }
                } else {
                  distance999 = 0
                }
              }
            }

            distance = compareTowNum(distance999, distance2, '<=')
              ? distance999
              : distance2
          }

          this.applyKeyboardPlankMove(
            this.activePlank,
            bigpart,
            direction,
            distance,
            startX,
            startY
          )
          if (!this.isCuttingSurplus) {
            // 更新蓝色余料的数据
            this.updateBlueAreaSurplusPart(this.bigpart)
          }
          this.renderAll()
        }
        // 复选（Ctrl 多选）选中多块小板时，批量删除全部选中小板
        if (this.batchActiveIdList.length && e.code == 'Delete') {
          if (this.bigpart.isLocked) {
            return this.$message.error(translate('arrangedPage.lockDeleteErr'))
          }
          const batchTargets = this.getBatchActiveParts()
          if (!batchTargets.length) {
            return this.$message({
              message: translate('arrangedPage.selectPlankTip'),
              type: 'info',
            })
          }
          e.preventDefault()
          const batchTextureParts = this.getBatchMatchParts(
            batchTargets,
            isTextureAlignmentPlank
          )
          if (batchTextureParts.length) {
            if (this.isTextureConfirming) return
            this.isTextureConfirming = true
            const batchConfirmed = await showTextureConfirmModal(
              this.$translateLang(
                '当前操作会清除板件对纹信息，请确认是否继续？'
              ),
              batchTextureParts
            )
            this.isTextureConfirming = false
            if (!batchConfirmed) return
          }
          this.isShowDeleteDialog = true
          return
        }
        if (
          this.activePlank &&
          this.activePlank.specialType &&
          e.code == 'Delete'
        ) {
          if (this.bigpart.isLocked) {
            return this.$message.error(translate('arrangedPage.lockDeleteErr'))
          }
          e.preventDefault()
          let isSavedSurplus =
            this.activePlank.specialType && this.activePlank.hasSaved
          if (isSavedSurplus || this.activePlank.specialType === 'supplus') {
            if (this.deleteSurplusPlankModal) return
            const h = this.$createElement
            let dom = h('div', {}, [
              // 进入待排版库的提示
              h('span', {}, translate('common.confirmDeleteTip')),
            ])
            this.deleteSurplusPlankModal = this.$antdConfirm({
              title: translate('arrangedPage.deleteConfirm'),
              content: dom,
              okText: translate('common.confirm'),
              cancelText: translate('common.cancel'),
              centered: true,
              onOk: () => {
                let arr = []
                for (let i = 0; i < this.drawData.length; ++i) {
                  arr = [...arr, ...this.drawData[i].data]
                }
                this.setPaibanData(arr)
                this.setFinalDrawData(this.drawData)
                this.$emit('updatePaibanData')
                this.confirmDeleteSurplusPlank()

                this.deleteSurplusPlankModal = null
              },
              onCancel: () => {
                this.deleteSurplusPlankModal = null
              },
            })
          } else {
            this.confirmDeleteSurplusPlank()
          }
        } else if (this.activePlank && e.code == 'Delete') {
          if (this.bigpart.isLocked) {
            return this.$message.error(translate('arrangedPage.lockDeleteErr'))
          }
          if (isTextureAlignmentPlank(this.activePlank)) {
            if (this.isTextureConfirming) return
            this.isTextureConfirming = true
            const confirmed = await showTextureConfirmModal(
              this.$translateLang(
                '当前操作会清除板件对纹信息，请确认是否继续？'
              ),
              getSameGroupParts(this.activePlank, this.bigpart.parts)
            )
            this.isTextureConfirming = false
            if (!confirmed) return
          }
          this.isShowDeleteDialog = true
        } else if (!this.activePlank && e.code === 'Delete') {
          this.$message({
            message: translate('arrangedPage.selectPlankTip'),
            type: 'info',
          })
        }
      }
    },
    // 删除精细排版item
    async handleConfirmDelete() {
      // 复选（Ctrl 多选）时批量删除全部选中小板
      if (this.batchActiveIdList.length) {
        return this.handleConfirmBatchDelete()
      }
      if (isTextureAlignmentPlank(this.activePlank)) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          getSameGroupParts(this.activePlank, this.bigpart.parts)
        )
        if (!confirmed) return
      }
      this.isShowDeleteDialog = false
      const activePlank = this.activePlank
      let oriBigpart
      this.drawData.forEach((draw, index) => {
        draw.data.forEach((bigPlank) => {
          if (bigPlank.stockKey === this.bigpart.stockKey) {
            oriBigpart = JSON.parse(JSON.stringify(bigPlank))
            // 删除小板
            this.handleAddPlankToAwaitStore(activePlank, bigPlank)
          }
          this.$emit('judgeAbleFanban', bigPlank, index)
          // 重新计算优化率
          calcBigpartArea(bigPlank, this.ncSetting, this.isUnuseSurplus)
        })
      })

      // 更新蓝色余料的数据
      this.updateBlueAreaSurplusPart(this.bigpart)
      // 触发父组件的判断方法
      this.renderAll()
      this.$emit('recordDeletePlank', {
        key: '精细排版删除小板',
        dataArr: [
          {
            type: 'form',
            current: {
              partsNum: this.bigpart.parts.length,
            }, // 当前表单数据
            ori: {
              partsNum: oriBigpart.parts.length,
            }, // 原始表单数据
            compareMsg: [
              {
                title: `${activePlank.partName}-大板序号: ${this.bigpart.canvasIndex}`,
                keys: ['partsNum'],
              },
            ], // 要比较的内容
            formTextObj: {
              partsNum: '小板数量',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          },
        ],
      })
      // 如果删除板件是待排版服务器上的数据则需要将板件再显示出来
      if (activePlank?._isAwaitStorePlank) {
        this.$store.commit(
          'awaitPaibanStore/showPlank',
          activePlank.partUniqueId
        )
      }
    },
    /**
     * @description 复选（Ctrl 多选）批量删除小板，与单板删除保持一致
     * @returns {Promise<void>}
     */
    async handleConfirmBatchDelete() {
      const targets = this.getBatchActiveParts()
      this.isShowDeleteDialog = false
      if (!targets.length) {
        this.activePlank = null
        this.batchActiveIdList = []
        this.renderAll()
        return
      }
      const oriPartsNum = this.bigpart.parts.length
      for (const part of targets) {
        this.drawData.forEach((draw, index) => {
          draw.data.forEach((bigPlank) => {
            if (bigPlank.stockKey === this.bigpart.stockKey) {
              // 删除小板（普通小板回到待排版库）
              this.handleAddPlankToAwaitStore(part, bigPlank)
            }
            this.$emit('judgeAbleFanban', bigPlank, index)
            // 重新计算优化率
            calcBigpartArea(bigPlank, this.ncSetting, this.isUnuseSurplus)
          })
        })
        // 如果删除板件是待排版服务器上的数据则需要将板件再显示出来
        if (part?._isAwaitStorePlank) {
          this.$store.commit('awaitPaibanStore/showPlank', part.partUniqueId)
        }
      }
      // 更新蓝色余料的数据
      this.updateBlueAreaSurplusPart(this.bigpart)
      // 与单板一致：删除余料小板后重新计算下刀点顺序
      if (
        this.bigpart.parts.length > 0 &&
        targets.some(
          (part) =>
            part.specialType === 'supplus' ||
            (part.specialType && part.hasSaved)
        )
      ) {
        this.calcCutPositionOrder(this.bigpart)
      }
      this.batchActiveIdList = []
      this.activePlank = null
      this.renderAll()
      this.$emit('recordDeletePlank', {
        key: '精细排版删除小板',
        dataArr: [
          {
            type: 'form',
            current: {
              partsNum: this.bigpart.parts.length,
            }, // 当前表单数据
            ori: {
              partsNum: oriPartsNum,
            }, // 原始表单数据
            compareMsg: [
              {
                title: `${targets[0].partName}-大板序号: ${this.bigpart.canvasIndex}`,
                keys: ['partsNum'],
              },
            ], // 要比较的内容
            formTextObj: {
              partsNum: '小板数量',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          },
        ],
      })
    },
    confirmDeleteSurplusPlank() {
      this.handleAddPlankToAwaitStore(this.activePlank, this.bigpart)
      this.activePlank = null
      this.ableRewriteRemarks = false
      if (this.bigpart.parts.length > 0) {
        this.calcCutPositionOrder(this.bigpart)
      }
      calcBigpartArea(this.bigpart, this.ncSetting, this.isUnuseSurplus)
      this.renderAll()
    },
    dealBigPlankLine(path) {
      let arr = []
      for (let i = 0; i < path.length; ++i) {
        let point = path[i]
        let nextPoint = i == path.length - 1 ? path[0] : path[i + 1]
        if (point.X == nextPoint.X && point.Y == nextPoint.Y) continue
        let pathLine = {
          x1: point.X,
          y1: point.Y,
          x2: nextPoint.X,
          y2: nextPoint.Y,
        }
        arr.push(pathLine)
      }
      return arr
    },
    // 计算板件和大板的距离
    calcBigPlankDistance(activeLineArr, bigPartLineArr, direction) {
      let distanceArr = []
      for (let i = 0; i < activeLineArr.length; ++i) {
        let line1 = activeLineArr[i]
        for (let k = 0; k < bigPartLineArr.length; ++k) {
          let line2 = bigPartLineArr[k]
          if (this.checkRangeIntersect(line1, line2, direction)) {
            if (direction == 'up') {
              if (compareTowNum(line1.y1, line1.y2, '>=')) {
                let distance = line1.y2 - line2.y1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              } else {
                let distance = line1.y1 - line2.y1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              }
            }
            if (direction == 'down') {
              if (compareTowNum(line1.y1, line1.y2, '>=')) {
                let distance = line1.y1 - line2.y1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              } else {
                let distance = line1.y2 - line2.y1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              }
            }
            if (direction == 'left') {
              if (compareTowNum(line1.x1, line1.x2, '>=')) {
                let distance = line1.x2 - line2.x1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              } else {
                let distance = line1.x1 - line2.x1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              }
            }
            if (direction == 'right') {
              if (compareTowNum(line1.x1, line1.x2, '>=')) {
                let distance = line1.x1 - line2.x1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              } else {
                let distance = line1.x2 - line2.x1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              }
            }
          }
        }
      }
      return distanceArr
    },
    // 获取大板边框
    getBigPlankPath(bigpart) {
      const diameter = +getPlateKnifeDiameter(bigpart.stockKey, this.ncSetting)
      // 计算大板修边
      let plankOffset = Math.abs(
        diameter / 2 - this.ncSetting.panelSize.plankEdgeOff
      )
      let bigPartsPath = []
      let plankWidth = 0
      let plankHeight = 0
      if (bigpart.surplusInfo && Object.keys(bigpart.surplusInfo).length > 0) {
        let surplusInfo = bigpart.surplusInfo
        // 如果为L形余料
        if (surplusInfo.shape && surplusInfo.shape == 'lshape') {
          let x3 = this.ncSetting.xyReverse
            ? Number(surplusInfo.y5)
            : Number(surplusInfo.x3)
          let y3 = this.ncSetting.xyReverse
            ? Number(surplusInfo.x5)
            : Number(surplusInfo.y3)
          let x4 = this.ncSetting.xyReverse
            ? Number(surplusInfo.y4)
            : Number(surplusInfo.x4)
          let y4 = this.ncSetting.xyReverse
            ? Number(surplusInfo.x4)
            : Number(surplusInfo.y4)
          let x5 = this.ncSetting.xyReverse
            ? Number(surplusInfo.y3)
            : Number(surplusInfo.x5)
          let y5 = this.ncSetting.xyReverse
            ? Number(surplusInfo.x3)
            : Number(surplusInfo.y5)
          let newWidth = surplusInfo.width
          let newHeight = surplusInfo.height
          plankWidth = newWidth
          plankHeight = newHeight
          if (
            this.ncSetting.xyReverse &&
            (this.ncSetting.startPosition == '右下角' ||
              this.ncSetting.startPosition == '左上角')
          ) {
            x3 = newWidth - x3
            x4 = newWidth - x4
            x5 = newWidth - x5

            bigPartsPath = [
              { x: -plankOffset, y: -plankOffset },
              { x: newWidth + plankOffset, y: -plankOffset },
              { x: newWidth + plankOffset, y: newHeight + plankOffset },
              { x: x3 - plankOffset, y: y3 + plankOffset },
              { x: x4 - plankOffset, y: y4 + plankOffset },
              { x: x5 - plankOffset, y: y5 + plankOffset },
            ]
          } else {
            bigPartsPath = [
              { x: -plankOffset, y: -plankOffset },
              { x: x3 + plankOffset, y: y3 - plankOffset },
              { x: x4 + plankOffset, y: y4 - plankOffset },
              { x: x5 + plankOffset, y: y5 + plankOffset },
              { x: newWidth + plankOffset, y: newHeight + plankOffset },
              { x: -plankOffset, y: newHeight + plankOffset },
            ]
          }
        } else if (surplusInfo.shape && surplusInfo.shape == 'specialShape') {
          bigPartsPath = [
            ...dealBigPlankEdgeOffset(surplusInfo.path, -plankOffset),
          ]
          plankWidth = surplusInfo.width
          plankHeight = surplusInfo.height
        } else {
          bigPartsPath = [
            { x: -plankOffset, y: -plankOffset },
            { x: Number(surplusInfo.width) + plankOffset, y: -plankOffset },
            {
              x: Number(surplusInfo.width) + plankOffset,
              y: Number(surplusInfo.height) + plankOffset,
            },
            { x: -plankOffset, y: Number(surplusInfo.height) + plankOffset },
          ]
          plankWidth = surplusInfo.width
          plankHeight = surplusInfo.height
        }
      } else {
        bigPartsPath = [
          { x: -plankOffset, y: -plankOffset },
          { x: this.plankWidth + plankOffset, y: -plankOffset },
          {
            x: this.plankWidth + plankOffset,
            y: this.plankHeight + plankOffset,
          },
          { x: -plankOffset, y: this.plankHeight + plankOffset },
        ]
        plankWidth = this.plankWidth
        plankHeight = this.plankHeight
      }
      return {
        bigPartsPath,
        bigPartArr: {
          bigpartTop: -plankOffset,
          bigpartLeft: -plankOffset,
          bigpartRight: plankOffset + plankWidth,
          bigpartBottom: plankOffset + plankHeight,
        },
      }
    },
    // 获取一个板件的所有线段
    getPlankLine(path, startX = 0, startY = 0, direction, range) {
      // 将点位处理成顺时针点位, 然后求相邻两点的垂直向量
      // 判断点位是否是顺时针点位, 通过clipper判断面积, 面积为正数则为逆时针点位, 但是由于canvas原点在左上角, 所以要反过来判断顺逆时针
      let area = ClipperLib.JS.AreaOfPolygon(path)
      if (area < 0) {
        path.reverse()
      }
      // 求垂直的单位向量
      let lineArr = []
      let pathLen = path.length
      for (let k = 0; k < pathLen; ++k) {
        let pathLine = {}
        let point = path[k]
        let nextPoint = k == pathLen - 1 ? path[0] : path[k + 1]
        if (point.x == nextPoint.x && point.y == nextPoint.y) continue
        let a = {
          x: point.x + startX,
          y: point.y + startY,
        }
        let b = {
          x: nextPoint.x + startX,
          y: nextPoint.y + startY,
        }
        // 计算当前线段向量的垂直单位向量
        let c = {
          x: b.x - a.x,
          y: b.y - a.y,
        }
        // 计算方式, 已知向量(x, y) 设要求的单位垂直向量为(a, b)单位向量的摸长为1, 也就是a² + b² = 1, 然后和已知向量垂直就有x * a + y * b = 0, 解二元方程
        // 则a = Math.sqrt( Math.pow(y, 2) / ( Math.pow(x, 2) + Math.pow(y, 2) ) )
        // b = Math.sqrt( 1 - Math.pow(a, 2) )
        let aa = Math.sqrt(
          Math.pow(c.y, 2) / (Math.pow(c.x, 2) + Math.pow(c.y, 2))
        )
        let bb = Math.sqrt(1 - Math.pow(aa, 2))
        if (c.x > 0 && c.y < 0) {
          aa = -aa
          bb = -bb
        }
        if (c.x < 0 && c.y < 0) {
          aa = -aa
        }
        if (c.x > 0 && c.y > 0) {
          bb = -bb
        }
        if (c.x > 0 && c.y == 0) {
          bb = -bb
        }
        if (c.x == 0 && c.y < 0) {
          aa = -aa
        }
        let cd = {}
        if (direction == 'up') {
          cd = { x: 0, y: -1 }
        }
        if (direction == 'down') {
          cd = { x: 0, y: 1 }
        }
        if (direction == 'left') {
          cd = { x: -1, y: 0 }
        }
        if (direction == 'right') {
          cd = { x: 1, y: 0 }
        }
        let cos =
          (aa * cd.x + bb * cd.y) /
          (Math.sqrt(aa * aa + bb * bb) * Math.sqrt(cd.x * cd.x + cd.y * cd.y))
        let angle = (180 * Math.acos(cos)) / Math.PI
        if (
          (compareTowNum(angle, 0, '>=') && compareTowNum(angle, 90, '<=')) ||
          !this.isActivePlankLine
        ) {
          pathLine = {
            x1: a.x,
            y1: a.y,
            x2: b.x,
            y2: b.y,
          }
          // 将pathLine的值按照区间从小到大正常排列之后再进行判断
          if (direction == 'up' || direction == 'down') {
            if (range) {
              if (this.checkRangeIntersect(pathLine, range, direction)) {
                if (pathLine.x1 != pathLine.x2) lineArr.push(pathLine)
              }
            } else {
              if (pathLine.x1 != pathLine.x2) lineArr.push(pathLine)
            }
          }
          if (direction == 'left' || direction == 'right') {
            if (range) {
              if (this.checkRangeIntersect(pathLine, range, direction)) {
                if (pathLine.y1 != pathLine.y2) lineArr.push(pathLine)
              }
            } else {
              if (pathLine.y1 != pathLine.y2) lineArr.push(pathLine)
            }
          }
        }
      }
      return lineArr
    },
    // 计算两条线段的距离
    calcDistance(activeLineArr, partLineArr, direction) {
      let distanceArr = []
      for (let i = 0; i < activeLineArr.length; ++i) {
        let line1 = activeLineArr[i]

        for (let k = 0; k < partLineArr.length; ++k) {
          let line2 = partLineArr[k]
          if (direction == 'up' || direction == 'down') {
            // 先判断点是否在另外一条线段上的区间内, 如果再, 才去求距离
            let a,
              b,
              c,
              d = {}
            let startY = 0
            // 判断line1和line2是否平行
            let isPingxing =
              (line1.x2 - line1.x1) * (line2.y2 - line2.y1) -
              (line2.x2 - line2.x1) * (line1.y2 - line1.y1)
            // 如果两条线段平行, 则直接求任意一点到另一条线段的距离
            if (isPingxing == 0) {
              // 计算直线斜率, 由于平行, 计算任意一条线段的斜率即可, 以line1为准
              let k = (line1.y2 - line1.y1) / (line1.x2 - line1.x1)
              // line1对应的直线则为 y - line1.y1 = k * (x - line1.x1)
              // line2对应的直线则为 y - line2.y1 = k * (x - line2.x1)
              // 化为一般式则是 -kx + y - line1.y1 + k * line1.x1 = 0和-kx + y - line2.y1 + k * line2.x1 = 0
              // 平行线之间的距离则为
              let distance =
                Math.abs(
                  -line1.y1 + k * line1.x1 - (-line2.y1 + k * line2.x1)
                ) / Math.sqrt(Math.pow(k, 2) + 1)
              distanceArr.push(distance)
              continue
            }
            // point.x1在另一条point2内部
            let isInRange = false
            // 将两条线段的横坐标从小到大排列
            let newLine1 = JSON.parse(JSON.stringify(line1))
            if (line1.x1 > line1.x2) {
              newLine1.y1 = line1.y2
              newLine1.y2 = line1.y1
              newLine1.x1 = line1.x2
              newLine1.x2 = line1.x1
            }
            let newLine2 = JSON.parse(JSON.stringify(line2))
            if (line2.x1 > line2.x2) {
              newLine2.y1 = line2.y2
              newLine2.y2 = line2.y1
              newLine2.x1 = line2.x2
              newLine2.x2 = line2.x1
            }
            if (newLine1.x1 > newLine2.x1 && newLine1.x1 < newLine2.x2) {
              // 由该点延伸出一条直线, 求与另一条线段的交点, 然后纵坐标相减求出距离
              // 该点为(x1, y1), 上下移动时延伸出向量, 也就是(0, y1), 和另一条线段的向量(x2 - x1, y2 - y1), 求得交点(x, y), 距离则为|y - y1|
              a = { x: newLine1.x1, y: newLine1.y1 }
              b = { x: newLine1.x1, y: 0 }
              c = { x: newLine2.x1, y: newLine2.y1 }
              d = { x: newLine2.x2, y: newLine2.y2 }
              startY = newLine1.y1
              isInRange = true
            }
            // newLine1.x2在另一条point2内部
            if (newLine1.x2 > newLine2.x1 && newLine1.x2 < newLine2.x2) {
              a = { x: newLine1.x2, y: newLine1.y2 }
              b = { x: newLine1.x2, y: 0 }
              c = { x: newLine2.x1, y: newLine2.y1 }
              d = { x: newLine2.x2, y: newLine2.y2 }
              startY = newLine1.y2
              isInRange = true
            }
            // newLine2.x1在point1内部
            if (newLine2.x1 > newLine1.x1 && newLine2.x1 < newLine1.x2) {
              a = { x: newLine2.x1, y: newLine2.y1 }
              b = { x: newLine2.x1, y: 0 }
              c = { x: newLine1.x1, y: newLine1.y1 }
              d = { x: newLine1.x2, y: newLine1.y2 }
              startY = newLine2.y1
              isInRange = true
            }
            if (newLine2.x2 > newLine1.x1 && newLine2.x2 < newLine1.x2) {
              a = { x: newLine2.x2, y: newLine2.y2 }
              b = { x: newLine2.x2, y: 0 }
              c = { x: newLine1.x1, y: newLine1.y1 }
              d = { x: newLine1.x2, y: newLine1.y2 }
              startY = newLine2.y2
              isInRange = true
            }
            if (!isInRange) continue
            let denominator =
              (b.x - a.x) * (d.y - c.y) - (d.x - c.x) * (b.y - a.y)
            if (denominator == 0) continue
            // 如果平行, 则直接求两条线段的纵坐标距离
            let b1 = (b.y - a.y) * a.x + (a.x - b.x) * a.y
            let b2 = (d.y - c.y) * c.x + (c.x - d.x) * c.y
            let y = (b2 * (b.y - a.y) - b1 * (d.y - c.y)) / denominator
            let distance = Math.abs(y - startY)
            distanceArr.push(distance)
          }
          if (direction == 'left' || direction == 'right') {
            // 先判断点是否在另外一条线段上的区间内, 如果再, 才去求距离
            let a,
              b,
              c,
              d = {}
            let startX = 0
            // 判断line1和line2是否平行
            let isPingxing =
              (line1.x2 - line1.x1) * (line2.y2 - line2.y1) -
              (line2.x2 - line2.x1) * (line1.y2 - line1.y1)
            // 如果两条线段平行, 则直接求任意一点到另一条线段的距离
            if (isPingxing == 0) {
              // 如果为垂直的竖线, 则直接计算横坐标的差值
              if (line1.x1 == line1.x2) {
                let distance = Math.abs(line1.x1 - line2.x1)
                distanceArr.push(distance)
                continue
              } else {
                // 计算直线斜率, 由于平行, 计算任意一条线段的斜率即可, 以line1为准
                let k = (line1.y2 - line1.y1) / (line1.x2 - line1.x1)
                // line1对应的直线则为 y - line1.y1 = k * (x - line1.x1)
                // line2对应的直线则为 y - line2.y1 = k * (x - line2.x1)
                // 化为一般式则是 -kx + y - line1.y1 + k * line1.x1 = 0和-kx + y - line2.y1 + k * line2.x1 = 0
                // 平行线之间的距离则为
                let distance =
                  Math.abs(
                    -line1.y1 + k * line1.x1 - (-line2.y1 + k * line2.x1)
                  ) / Math.sqrt(Math.pow(k, 2) + 1)
                distanceArr.push(distance)
                continue
              }
            }
            // point.x1在另一条point2内部
            let isInRange = false
            // 将两条线段的纵坐标从小到大排列
            let newLine1 = JSON.parse(JSON.stringify(line1))
            if (line1.y1 > line1.y2) {
              newLine1.y1 = line1.y2
              newLine1.y2 = line1.y1
              newLine1.x1 = line1.x2
              newLine1.x2 = line1.x1
            }
            let newLine2 = JSON.parse(JSON.stringify(line2))
            if (line2.y1 > line2.y2) {
              newLine2.y1 = line2.y2
              newLine2.y2 = line2.y1
              newLine2.x1 = line2.x2
              newLine2.x2 = line2.x1
            }
            if (newLine1.y1 > newLine2.y1 && newLine1.y1 < newLine2.y2) {
              // 由该点延伸出一条直线, 求与另一条线段的交点, 然后纵坐标相减求出距离
              // 该点为(x1, y1), 上下移动时延伸出向量, 也就是(0, y1), 和另一条线段的向量(x2 - x1, y2 - y1), 求得交点(x, y), 距离则为|y - y1|
              a = { x: newLine1.x1, y: newLine1.y1 }
              b = { x: 0, y: newLine1.y1 }
              c = { x: newLine2.x1, y: newLine2.y1 }
              d = { x: newLine2.x2, y: newLine2.y2 }
              startX = newLine1.x1
              isInRange = true
            }
            // newLine1.x2在另一条point2内部
            if (newLine1.y2 > newLine2.y1 && newLine1.y2 < newLine2.y2) {
              a = { x: newLine1.x2, y: newLine1.y2 }
              b = { x: 0, y: newLine1.y2 }
              c = { x: newLine2.x1, y: newLine2.y1 }
              d = { x: newLine2.x2, y: newLine2.y2 }
              startX = newLine1.x2
              isInRange = true
            }
            // newLine2.x1在point1内部
            if (newLine2.y1 > newLine1.y1 && newLine2.y1 < newLine1.y2) {
              a = { x: newLine2.x1, y: newLine2.y1 }
              b = { x: 0, y: newLine2.y1 }
              c = { x: newLine1.x1, y: newLine1.y1 }
              d = { x: newLine1.x2, y: newLine1.y2 }
              startX = newLine2.x1
              isInRange = true
            }
            if (newLine2.y2 > newLine1.y1 && newLine2.y2 < newLine1.y2) {
              a = { x: newLine2.x2, y: newLine2.y2 }
              b = { x: 0, y: newLine2.y2 }
              c = { x: newLine1.x1, y: newLine1.y1 }
              d = { x: newLine1.x2, y: newLine1.y2 }
              startX = newLine2.x2
              isInRange = true
            }
            if (!isInRange) continue
            let denominator =
              (b.x - a.x) * (d.y - c.y) - (d.x - c.x) * (b.y - a.y)
            if (denominator == 0) continue
            let b1 = (b.y - a.y) * a.x + (a.x - b.x) * a.y
            let b2 = (d.y - c.y) * c.x + (c.x - d.x) * c.y
            let x = (b2 * (b.x - a.x) - b1 * (d.x - c.x)) / denominator
            let distance = Math.abs(x - startX)
            distanceArr.push(distance)
          }
        }
      }
      return distanceArr
    },
    // 判断两个线段是否横坐标是否有交叉位置, 或者纵坐标有交叉位置
    checkRangeIntersect(line1, line2, direction) {
      // direction为up或者down时, 判断横坐标是否有交集
      if (direction == 'up' || direction == 'down') {
        let newLine1 = {}
        let newLine2 = {}
        if (line1.x1 > line1.x2) {
          newLine1.x1 = line1.x2
          newLine1.x2 = line1.x1
        } else {
          newLine1.x1 = line1.x1
          newLine1.x2 = line1.x2
        }
        if (line2.x1 > line2.x2) {
          newLine2.x1 = line2.x2
          newLine2.x2 = line2.x1
        } else {
          newLine2.x1 = line2.x1
          newLine2.x2 = line2.x2
        }
        if (
          Math.max(newLine1.x1, newLine2.x1) <
          Math.min(newLine1.x2, newLine2.x2)
        ) {
          return true
        } else {
          return false
        }
      } else {
        // direction为left或者right时, 判断纵坐标是否有交集
        let newLine1 = {}
        let newLine2 = {}
        if (line1.y1 > line1.y2) {
          newLine1.y1 = line1.y2
          newLine1.y2 = line1.y1
        } else {
          newLine1.y1 = line1.y1
          newLine1.y2 = line1.y2
        }
        if (line2.y1 > line2.y2) {
          newLine2.y1 = line2.y2
          newLine2.y2 = line2.y1
        } else {
          newLine2.y1 = line2.y1
          newLine2.y2 = line2.y2
        }
        if (
          Math.max(newLine1.y1, newLine2.y1) <
          Math.min(newLine1.y2, newLine2.y2)
        ) {
          return true
        } else {
          return false
        }
      }
    },
    // 键盘松开事件
    keyUpFuncs() {
      return (e) => {
        this.isScaling = false
        // webToQt / Qt WebEngine 松开 Ctrl 时 e.ctrlKey 可能仍为 true
        const isCtrlKey =
          e.key === 'Control' ||
          e.code === 'ControlLeft' ||
          e.code === 'ControlRight' ||
          e.keyCode === 17
        if (isCtrlKey || !e.ctrlKey) {
          this.isBatchActive = false
          return
        }
        this.isBatchActive = !!e.ctrlKey
      }
    },
    mouseWheelFuncs() {
      return (e) => {
        if (e.ctrlKey) {
          e.preventDefault()
        }
      }
    },
    getCurrentStoreDragPlank() {
      // 精细排版右侧面板是动态切换的，拖拽落板前必须重新读取当前激活库对应的拖拽上下文。
      if (this.plankActiveNav === 'bujian') {
        return this.$store.state.bujianStore?.currentDragBujianPlank ?? null
      }
      return this.$store.state.awaitPaibanStore.currentDragPlank
    },
    syncBujianParticipationFromDrawData() {
      const currentPaibanData = this.drawData.flatMap((item) => item.data ?? [])
      this.$store.commit(
        'bujianStore/syncParticipationBujianPlankIds',
        getBujianParticipationIdsFromPaibanData(currentPaibanData)
      )
    },
    handleStorePlankPlacedSuccess(plank) {
      if (plank?._isBujian && plank?._bujianStoreId) {
        // 补件放入精细排版后只做增量写入，整体一致性由 setPaibanData 的低频校准兜底。
        this.$store.commit(
          'bujianStore/addParticipationBujianPlank',
          plank._bujianStoreId
        )
        this.$store.commit('bujianStore/setCurrentDragBujianPlank', null)
        return
      }
      this.$store.commit(
        'awaitPaibanStore/deleteJinxiStorePlank',
        plank?.partUniqueId
      )
      this.$store.commit('awaitPaibanStore/setCurrentDragPlank', null)
    },
    /** 添加板件到暂存库 */
    async handleAddPlankToAwaitStore(activePlank, activeBigPlank) {
      if (this.isCutorigin) return
      // 清除大板上的指定小板
      const flag = clearPlankToBigPlank(activePlank, activeBigPlank)
      if (!flag) return
      if (activePlank?._isBujian && activePlank?._bujianStoreId) {
        // 精细排版删除时真实结果只存在本地 drawData 克隆里，这里必须基于当前画布快照重建补件参与集合。
        this.syncBujianParticipationFromDrawData()
        buryPointApi('layout', 'plate_staged')
        this.$emit('recordActivePlank', null)
        calcBigpartArea(activeBigPlank, this.ncSetting, this.isUnuseSurplus)
        this.judgeAbleFanban(activeBigPlank)
        this.activePlank = null
        this.activeBigpart = null
        this.renderAll()
        return
      }
      const imgUrl = getPlankImage(activePlank, false, {
        defaultScale,
        scale: 3,
        plankLineWidth: 1,
      })
      //生成本地暂存库数据并将数据添加到本地暂存库中
      const data = await genAwaitStoreData(
        activePlank,
        this.preLayoutData,
        imgUrl
      )
      this.$store.commit('awaitPaibanStore/setJinxiPlankToStore', data)
      // 进行板件处理后的固定操作
      buryPointApi('layout', 'plate_staged')
      this.$emit('recordActivePlank', null)
      calcBigpartArea(activeBigPlank, this.ncSetting, this.isUnuseSurplus)
      this.judgeAbleFanban(activeBigPlank)
      this.activePlank = null
      this.activeBigpart = null
      this.renderAll()
    },
    // 判断板件是否可以吸附，不支持锯切和有额外扩板的小板
    checkPlankAdsorption(plank) {
      return (
        this.$props.isUsePlankAdsorption &&
        !plank.isUseSaw &&
        (!plank.finalExtendDisMap ||
          Object.values(plank.finalExtendDisMap).every((item) => item === 0))
      )
    },
    // 鼠标松开事件
    mouseUpFuncs() {
      return async (e) => {
        // 是否是拖动板件
        if (this.activePlank && this.isMovingPlank) {
          if (mousePointISInElement(e, 'jinxi-paiban-await-store', 'class')) {
            if (this.plankActiveNav === 'zancun') {
              if (this.activePlank?._isBujian) {
                this.$message({
                  message: this.$translateLang('补件无法直接放入待排版库'),
                  type: 'warning',
                })
              } else {
                this.handleAddPlankToAwaitStore(this.activePlank, this.bigpart)
              }
            }
          }
        }
        if (this.isDragingPlank) {
          let pos = this.windowToCanvas(e.clientX, e.clientY)
          if (!pos) return
          const dragData = await checkCurrentDragPlankDataIsLoad(
            this.getCurrentStoreDragPlank()
          )
          if (!dragData) return
          let plank = dragData.plank
          let bigpart = this.bigpart
          const dragTarget = this.$refs['storeRef']?.getCurrentDragTarget()
          if (!dragTarget) return
          // 获取暂存区拖出图片的信息，获取偏移量并计算出板件的起始位置
          const { offsetX, offsetY } = dragTarget
          const startX = pos.x - offsetX
          const startY = pos.y - offsetY
          // 如果找到了大板则继续执行后面的逻辑, 否则弹回原位置重新绘制
          if (bigpart) {
            // 如果鼠标位置在大板上, 则继续执行后面的逻辑, 否则弹回原位置重新绘制
            if (
              startX <=
                this.bigpart.subtleStartX +
                  this.bigpart.subtleWidth +
                  2 * this.deviation &&
              startY <=
                this.bigpart.subtleStartY +
                  this.bigpart.subtleHeight +
                  this.topInfoHeight +
                  2 * this.deviation
            ) {
              if (bigpart.isLocked) {
                this.$message.error(translate('arrangedPage.plankLockErr'))
                this.changeDragingPlank(false)
                return
              }
              if (
                bigpart.matCode == plank.matCode &&
                bigpart.thick == plank.thick &&
                bigpart.texture == plank.texture
              ) {
                const realPos = {
                  x:
                    ((startX - this.bigpart.subtleStartX - this.deviation) /
                      this.scalePercent) *
                    defaultScale,
                  y:
                    ((startY -
                      this.bigpart.subtleStartY -
                      this.topInfoHeight -
                      this.deviation) /
                      this.scalePercent) *
                    defaultScale,
                }
                if (this.checkPlankAdsorption(plank)) {
                  plank.startX = realPos.x
                  plank.startY = realPos.y
                  const closeResult = calcClosePlank(plank, bigpart)
                  if (closeResult) {
                    const { x, y } = closeResult
                    plank.startX = x
                    plank.startY = y
                    realPos.x = x
                    realPos.y = y
                    // 重新处理选中板件的轮廓路径
                    dealPlankPoly(plank)
                  }
                }
                // 判断当前板件是否能够放入大板件
                const flag = judgePlankPushBigPlank(realPos, plank, bigpart)
                if (flag) {
                  this.activePlank = plank
                  plank.stockKey = bigpart.stockKey
                  plank.stockNum = bigpart.stockNum
                  bigpart.parts.push(plank)
                  this.activePlank.index = this.getPlankNextIndex()
                  calcBigpartArea(
                    this.bigpart,
                    this.ncSetting,
                    this.isUnuseSurplus
                  )
                  this.judgeAbleFanban(this.bigpart)
                  this.activePlankOff = null
                  this.isMovingPlank = false
                  // 更新蓝色余料的数据
                  this.updateBlueAreaSurplusPart(this.bigpart)
                  this.renderAll()
                  this.changeDragingPlank(false)
                  if (!isExistPriority(plank)) {
                    // 重新计算下刀点
                    this.calcCutPositionOrder(bigpart)
                  }
                  this.handleStorePlankPlacedSuccess(plank)
                  this.changeDragingPlank(false)
                } else {
                  this.$message.info('无法放置板件,留意空余空间大小')
                }
              } else {
                this.$message({
                  message: translate('arrangedPage.dragErrTip'),
                  type: 'error',
                })
                this.changeDragingPlank(false)
              }
            } else {
              this.$message({
                message: translate('arrangedPage.dragWarning'),
                type: 'info',
              })
              this.changeDragingPlank(false)
            }
          } else {
            return
          }
        }
      }
    },
    // 获取当前的index 临时处理后期需要优化(todo)
    getPlankNextIndex() {
      const exists = this.bigpart.parts.map((part) => +part.index)
      const index = getPlankMaxIndexByFinalDrawData(exists)
      return index
    },
    // 截取板件生成图片
    cuttingPlank() {
      // 计算当前激活板件的位置
      let width =
        (this.activePlank.rect.width / defaultScale) * this.scalePercent
      let height =
        (this.activePlank.rect.height / defaultScale) * this.scalePercent
      let oCanvas = document.createElement('canvas')
      oCanvas.width = width + 10
      oCanvas.height = height + 10
      let oCtx = oCanvas.getContext('2d')
      this.activePlankOff = null
      let newPlank = JSON.parse(JSON.stringify(this.activePlank))
      newPlank.startX = 0
      newPlank.startY = 0
      this.drawParts(oCtx, newPlank, 5, 5, true)
      let imgUrl = oCanvas.toDataURL()

      let title = `${this.activePlank.thick}${this.activePlank.matCode}(${this.activePlank.texture})`
      let obj = {
        imgUrl: imgUrl,
        title: title,
        data: this.activePlank,
      }
      let img = new Image()
      img.src = imgUrl
      let that = this
      img.onload = function () {
        let scaleW = Number(this.width) / 138
        let scaleH = Number(this.height) / 140
        if (this.width <= 138 && this.height <= 140) {
          if (scaleW >= scaleH) {
            obj.width = '100%'
          } else {
            obj.height = '100%'
          }
        }
        if (this.width > 138 && this.height > 140) {
          if (scaleW >= scaleH) {
            obj.width = Number(this.width) / scaleW + 'px'
            obj.height = Number(this.height) / scaleW + 'px'
          } else {
            obj.width = Number(this.width) / scaleH + 'px'
            obj.height = Number(this.height) / scaleH + 'px'
          }
        }
        if (this.width <= 138 && this.height > 140) {
          obj.width = Number(this.width) / scaleH + 'px'
          obj.height = Number(this.height) / scaleH + 'px'
        }
        if (this.width > 138 && this.height <= 140) {
          obj.width = Number(this.width) / scaleW + 'px'
          obj.height = Number(this.height) / scaleW + 'px'
        }
        // 从精细排版返回排版时如果没有保存, 在返回排版时会把暂存区板件释放出来
        that.addFinalStorage(obj)
      }
      if (document.body.contains(oCanvas)) {
        document.body.removeChild(oCanvas)
      }
    },

    // 从暂存区拖拽出来时
    dragImg(e, item, index) {
      this.changeDragingPlank(true)
      window.addEventListener('mouseup', this.mouseupEvent)
      this.$nextTick(() => {
        e.preventDefault()
        let imgDom = this.$refs[`tempImg${index}`][0]
        let imgBox = imgDom.getBoundingClientRect()
        // 计算点击的图片位置, 相对于图片的位置, 并用于后续拖动板件到大板时的位置判断
        this.imgPosition = {
          x: e.offsetX / imgBox.width,
          y: e.offsetY / imgBox.height,
        }
        this.setTempImgPos(this.imgPosition)
        // 记录现在鼠标相对于浏览器的位置
        let screenPos = {
          x: e.clientX,
          y: e.clientY,
        }
        // 点击的时候, 在鼠标位置生成原始大小的板件图片
        let img = null
        if (this.tempImg) {
          img = this.tempImg
        } else {
          img = new Image()
        }
        img.src = item.imgUrl
        new Promise((resolve) => {
          img.onload = function () {
            resolve({
              x: this.width,
              y: this.height,
            })
          }
        }).then((res) => {
          // 计算原始图片大小, 相当于从鼠标位置进行缩放
          let x = this.imgPosition.x * res.x
          let y = this.imgPosition.y * res.y
          this.imgRealSize = res
          let left = screenPos.x - x
          let top = screenPos.y - y
          // 设置其位置
          img.style.position = 'fixed'
          img.style.opacity = '0.7'
          img.style.left = left + 'px'
          img.style.top = top + 'px'
          img.style.display = 'block'
          // 挂载在页面上
          if (!this.tempImg) {
            document.body.appendChild(img)
          }
          this.tempImg = img
          this.mouseMoveEvent = this.mouseMoveFunc()
          window.addEventListener('mousemove', this.mouseMoveEvent)
          let that = this
          this.tempImg.onmouseup = function () {
            that.tempImg.style.display = 'none'
            window.removeEventListener('mousemove', that.mouseMoveEvent)
          }
        })

        this.recordBeDraggedPlank(item)
      })
    },
    mouseMoveFunc() {
      return (e) => {
        if (this.tempImg) {
          e.preventDefault()
          let x = this.imgPosition.x * this.imgRealSize.x
          let y = this.imgPosition.y * this.imgRealSize.y
          let left = e.clientX - x
          let top = e.clientY - y

          this.tempImg.style.left = left + 'px'
          this.tempImg.style.top = top + 'px'
        }
      }
    },
    handlePositionChange() {
      // 进入选择模式
      this.isBatchPosition = true
      this.batchActiveIdList = []
      this.bigpart.parts.forEach((part) => (part.checked = false))
      this.activePartCount = 0
      this.activePlank = null
      this.isCutorigin = false
      this.renderAll()
    },
    handleBatchPositionChange() {
      // 将已选中的数组中的下刀点改成defaultPositionPoint
      this.bigpart.parts.forEach((part) => {
        if (part.checked) {
          part.cutOrigin = this.defaultPositionPoint
        }
      })
      this.handleBatchPositionCancel()
      buryPointApi('layout_sub', 'batch_edit_cutOrigin')
    },
    handleBatchPositionCancel() {
      this.bigpart.parts.forEach((part) => (part.checked = false))
      this.activePartCount = 0
      this.activePlank = null
      this.renderAll()
      this.isBatchPosition = false
      this.defaultPositionPoint = 'rightBottom'
    },
    // 保存精细排版的修改
    saveSubtleChange() {
      buryPointApi('layout_sub', 'save_layout')
      this.changeDrawPlank()
      // 保存暂存区数据
      this.exitButSave()
      this.resetTempStorage()
      // 判断是否是在裁剪余料当中
      if (this.isCuttingSurplus) {
        // 恢复暂存区的余料数据
        const newBigpart = {
          ...this.bigpart,
          parts: [...this.bigpart.parts, ...this.blueAreaSurplusData],
        }
        // 需要去修改蓝色区域的rect相关属性
        this.updateBlueAreaSurplusPart(newBigpart)
        this.blueAreaSurplusData = newBigpart.parts.filter(
          (item) => item.blueAreaSurplus
        )
        this.bigpart.parts = [
          ...this.bigpart.parts,
          ...this.blueAreaSurplusData,
        ]
        this.blueAreaSurplusData = []
      }
      if (this.isPlankChange().isPartsChange) {
        // 直接清除当前大板的复用信息
        clearReuseInfo(this.bigpart, this.$store.state.paibanData)
      }

      this.$emit('savePlan')
      this.$emit('onBackAllParts')
      this.$emit('update:visible', false)
      this.$emit('onClose')
      this.setBatchTaggingList([])
    },
    changeDrawPlank() {
      let arr = []
      if (this.isSyncSortableData()) {
        this.sortDoneByDealData()
        this.recordSortBeforeStockKeyArr()
      }
      this.drawData.forEach((item) => {
        item.data.forEach((plank) => {
          if (
            plank.stockKey === this.bigpart.stockKey &&
            plank.canvasIndex === this.bigpart.canvasIndex
          ) {
            plank.isLocked = this.bigpart.isLocked
          }
        })
      })
      for (let i = 0; i < this.drawData.length; ++i) {
        arr = [...arr, ...this.drawData[i].data]
      }
      // this.setHistoryPlankEdgeOff(this.ncSetting.panelSize.plankEdgeOff)
      // this.setHistorySecondTrimValue(this.ncSetting.secondTrimValue)
      let drawDataPartsArr = []
      arr.map((item) => drawDataPartsArr.push(...item.parts))
      let layoutData = [...this.preLayoutData]
      layoutData.forEach((layout) => {
        let nowPlank = drawDataPartsArr.filter(
          (draw) => draw.oriPlankNum == layout.oriPlankNum
        )
        if (nowPlank[0]) {
          layout.plank_remarks = nowPlank[0].plank_remarks
        }
      })
      this.setPreLayoutData(layoutData)
      this.setPaibanData(arr)
      this.recordAdjustBigPlankOrder(this.finalDrawData, this.drawData)
      this.setFinalDrawData(this.drawData)
      // 将最新的顺序进行记录，因为可能存在过调整
      this.setBeforeTitleSorts(genBeforeTitleSorts(this.drawData))
      this.$props.renderAllByMain()
    },

    // 余料入库
    saveSurplus(isSaveStorage) {
      buryPointApi('layout_sub', 'sup_warehousing')
      if (!this.activePlank) {
        this.$message({
          message: translate('arrangedPage.subtlePage.saveErr'),
          type: 'info',
        })
        return
      }
      if (!this.activePlank.hasOwnProperty('specialType')) {
        this.$message({
          message: translate('arrangedPage.subtlePage.selectTip'),
          type: 'info',
        })
        return
      }
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        if (this.bigpart.parts[i].plankMerge) {
          this.$message({
            type: 'error',
            message: translate('arrangedPage.storeFailTip'),
          })
          return
        }
      }
      if (this.activePlank.hasSaved) {
        this.$message({
          message: translate('arrangedPage.repeatStoreErr'),
          type: 'error',
        })
        return
      }
      let newSurplus
      try {
        newSurplus = buildCutSurplusDepotPayloadItem(
          this.activePlank,
          this.ncSetting
        )
      } catch (e) {
        if (e instanceof SurplusPayloadBuildError) {
          this.$message.error(e.message)
        } else {
          console.error(e)
          this.$message.error(
            translate('arrangedPage.storeFailTip') || '余料入库失败'
          )
        }
        return
      }

      this.$getByToken('/get_user_plank_setting', {}, (res) => {
        if (res.status == 1) {
          newSurplus.name = res.data.next_surplus_name
          postProcessSurplusPayloadItems([newSurplus], this.ncSetting)
          if (
            this.$store.state.preferencesSetting.setting.isSecondConfirm ??
            true
          ) {
            this.isShowSecondConfirm = true
            this.surplusConfirmList = [
              {
                ...newSurplus,
                isHighPlank: newSurplus.type.includes('高光_')
                  ? this.$translateLang('高光板')
                  : this.$translateLang('非高光板'),
                position: 'systemAllocation',
              },
            ]
            return
          }
          applySpecialShapeMinZeroForUpload([newSurplus])
          this.handleCallStorageInf([newSurplus], isSaveStorage)
        }
      })
    },

    // 余料入库增加防抖处理
    debounceSaveSurplus: debounce(function () {
      this.saveSurplus()
    }, 1000),

    // 调用创建余料的接口进行入库
    handleCallStorageInf(data, isSaveStorage, isSecondConfirm) {
      this.$token(
        '/create_surplus_depot',
        {
          surplus_data: data,
          designated: isSaveStorage ? true : false,
        },
        (res) => {
          if (res.status == 1) {
            // 成功之后检查余料中是否有异形余料，有则进行埋点
            const hasSpecialShape = data.some((item) => item.shape == 2)
            if (hasSpecialShape) {
              buryPointApi('supplus_storage', 'special_shape_surplus')
            }
            this.$message({
              message: translate('arrangedPage.surplusStoreSuccess'),
              type: 'success',
            })
            if (data.length) {
              this.activePlank.hasSaved = true
            }
            this.activePlank.ggid = res.data.ggid
            this.activePlank.surplus_id = res.data.id
            if (res.data.length) {
              this.activePlank.branch_name = res.data[0].branch_name
              this.activePlank.branch_no = res.data[0].branch_no
              this.activePlank.branch_id = res.data[0].id
            }
            let arr = []
            for (let i = 0; i < this.drawData.length; ++i) {
              arr = [...arr, ...this.drawData[i].data]
            }
            this.setPaibanData(arr)
            this.setFinalDrawData(this.drawData)
            this.$emit('updatePaibanData')
            this.$refs.qrcode.innerHTML = ''
            new QRCode('subtle-qrcode', {
              width: 80,
              height: 80,
              colorDark: '#000000', //前景色
              colorLight: '#ffffff', //背景色
              typeNumber: 4,
              correctLevel: QRCode.CorrectLevel.H,
              text: 'http://eggi.cn/÷' + this.activePlank.ggid,
            })
            if (isSaveStorage) {
              this.showSurStoreTip = false
            }
            this.isShowSecondConfirm = false
          } else {
            if (!isSecondConfirm) {
              const errStrArr = Object.values(res.data.err_surplus).flat(2)
              if (errStrArr.includes('余料条码已存在')) {
                this.$message({
                  message:
                    this.$translateLang('部分余料板件已经在库中，此次操作失败'),
                  type: 'error',
                })
                return
              }
              if (res.data?.error_code == '0') {
                this.showSurStoreTip = true
                return
              }
              this.$message({
                message: res.msg,
                // message: translate('arrangedPage.surplusStoreFail'),
                type: 'error',
              })
              if (isSaveStorage) {
                this.showSurStoreTip = false
              }
            } else {
              if (data.length) {
                this.$message({
                  message: this.$translateLang(
                    '入库失败，存在余料名称重复或余料仓存放达到上限或不满足入库规则'
                  ),
                  type: 'error',
                })
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                })
              }
              if (res.data?.err_surplus) {
                let errSurplus = res.data?.err_surplus
                Object.keys(errSurplus).forEach((key) => {
                  this.surplusConfirmList.forEach((item) => {
                    if (item.name === key) {
                      if (errSurplus[key].includes('余料名称已重复')) {
                        this.$set(item, 'isNameRepeat', true)
                      }
                      if (
                        errSurplus[key].includes(
                          '余料仓容量不足或存在余料不满足入库规则，无法存入仓库'
                        )
                      ) {
                        this.$set(item, 'isPositionLimit', true)
                      }

                      if (errSurplus[key].includes('余料条码已存在')) {
                        this.$set(item, 'isSurplusExist', true)
                      }
                    }
                  })
                })
              }
            }
          }
        }
      )
    },

    // 删除 余料入库二次确认数据
    handleDelSecCon(index) {
      this.surplusConfirmList.splice(index, 1)
    },

    // 关闭入库确认弹窗
    handleCloseSecCon() {
      this.isShowSecondConfirm = false
    },

    // 入库确认
    handleOKSecCon(data) {
      this.surplusConfirmList = data.map((item) => {
        delete item.isNameRepeat
        delete item.isPositionLimit
        delete item.isSurplusExist
        return item
      })
      const surplusData = this.surplusConfirmList.map((item) => {
        let result = JSON.parse(JSON.stringify(item))
        delete result.isHighPlank
        if (
          !['systemAllocation', 'surplusMaterialList'].includes(item.position)
        ) {
          result.branch_no = item.position
          result.position = 'surplusStore'
        } else {
          result.branch_no = 0
        }
        return result
      })
      applySpecialShapeMinZeroForUpload(surplusData)
      this.handleCallStorageInf(surplusData, true, true)
    },
    /**
     * 更新蓝色区域余料板件的rect相关属性
     * @param {Object} bigpart 大板数据
     */
    updateBlueAreaSurplusPart(bigpart) {
      this.blueAreaSurplusCaches = updateBlueAreaSurplusPart(
        bigpart,
        this.ncSetting,
        this.blueAreaSurplusCaches,
        this.drawData
      )
    },

    // 进入裁剪余料状态
    cutSurplus() {
      this.isCuttingSurplus = !this.isCuttingSurplus // 是否处于预料裁剪状态
      if (!this.isCuttingSurplus) {
        buryPointApi('layout_sub', 'sup_cropping')
        const newBigpart = {
          ...this.bigpart,
          parts: [...this.bigpart.parts, ...this.blueAreaSurplusData],
        }
        // 需要去修改蓝色区域的rect相关属性
        this.updateBlueAreaSurplusPart(newBigpart)
        this.blueAreaSurplusData = newBigpart.parts.filter(
          (item) => item.blueAreaSurplus
        )
        this.bigpart.parts = [
          ...this.bigpart.parts,
          ...this.blueAreaSurplusData,
        ]
        this.blueAreaSurplusData = []
      } else {
        // 将蓝色余料区域暂存到暂存区
        this.blueAreaSurplusData = this.bigpart.parts.filter(
          (item) => item.blueAreaSurplus
        )
        // 将蓝色余料区域从bigpart.parts中删除
        this.bigpart.parts = this.bigpart.parts.filter(
          (item) => !item.blueAreaSurplus
        )
      }
      this.activePlank = null
      this.bigpart.parts.forEach((part) => (part.checked = false))
      this.activePartCount = 0
      this.ableRewriteRemarks = false
      this.renderAll()
      this.surplusPoint = [] //所有余料的点位
      this.nextPoint = null //计算后的下一个余料点位

      this.showSurplusTemp = !this.showSurplusTemp //是否显示余料模板
      if (!this.isCuttingSurplus) {
        this.lineRecode.show = false
        this.isAdsorb = false
        this.showSurplusTemp = false
      } else {
        window.addEventListener('contextmenu', this.handleRightClick)
      }
    },

    // 右键点击事件 用于阻止默认的右键菜单
    handleRightClick(e) {
      e.preventDefault()
    },

    // 计算当前点位到各个板件的距离
    calcPointDistance(pt) {
      const isUseSaw = this.bigpart.parts.every((part) => part.isUseSaw)
      // 满足使用锯切 优先使用锯切刀
      const diameter = isUseSaw
        ? cutKnifeRadius * 2
        : +getPlateKnifeDiameter(this.bigpart.stockKey, this.ncSetting)
      let plankOffset = Math.abs(diameter / 2 - this.standardPlank.plankEdgeOff)
      let point = {
        x:
          ((pt.x - this.bigpart.subtleStartX - this.deviation) /
            this.scalePercent) *
          defaultScale,
        y:
          ((pt.y -
            this.bigpart.subtleStartY -
            this.topInfoHeight -
            this.deviation) /
            this.scalePercent) *
          defaultScale,
      }
      let lineArr = []
      const nPath = toLowerCasePoint(this.bigpart.bigPlank[0])
      const bigPlank = transformPathToLine(nPath, 'ck')
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        let plank = this.bigpart.parts[i]
        // 计算大板边框线段
        if (plank.path) {
          for (let k = 0; k < plank.path[0].length; ++k) {
            let pathPoint = plank.path[0][k]
            let nextPoint =
              k == plank.path[0].length - 1
                ? plank.path[0][0]
                : plank.path[0][k + 1]
            let pathLine = {
              x1: toDecimal(pathPoint.x + plank.startX, 2),
              y1: toDecimal(pathPoint.y + plank.startY, 2),
              x2: toDecimal(nextPoint.x + plank.startX, 2),
              y2: toDecimal(nextPoint.y + plank.startY, 2),
            }
            lineArr.push(pathLine)
          }
        } else {
          let arr = [
            {
              x1: plank.startX,
              y1: plank.startY,
              x2: plank.rect.width + plank.startX,
              y2: plank.startY,
            },
            {
              x1: plank.rect.width + plank.startX,
              y1: plank.startY,
              x2: plank.rect.width + plank.startX,
              y2: plank.rect.height + plank.startY,
            },
            {
              x1: plank.rect.width + plank.startX,
              y1: plank.rect.height + plank.startY,
              x2: plank.startX,
              y2: plank.rect.height + plank.startY,
            },
            {
              x1: plank.startX,
              y1: plank.rect.height + plank.startY,
              x2: plank.startX,
              y2: plank.startY,
            },
          ]
          lineArr = [...lineArr, ...arr]
        }
      }
      let finalLineArr = [...lineArr, ...bigPlank]
      let upArr = []
      let downArr = []
      let leftArr = []
      let rightArr = []
      let surplusLine = null
      // 计算出上一条线段
      if (this.surplusPoint.length > 1) {
        let point1 = this.surplusPoint[this.surplusPoint.length - 2]
        let point2 = this.surplusPoint[this.surplusPoint.length - 1]
        surplusLine = {
          x1:
            ((point1.x - this.bigpart.subtleStartX - this.deviation) /
              this.scalePercent) *
            defaultScale,
          y1:
            ((point1.y -
              this.bigpart.subtleStartY -
              this.topInfoHeight -
              this.deviation) /
              this.scalePercent) *
            defaultScale,
          x2:
            ((point2.x - this.bigpart.subtleStartX - this.deviation) /
              this.scalePercent) *
            defaultScale,
          y2:
            ((point2.y -
              this.bigpart.subtleStartY -
              this.topInfoHeight -
              this.deviation) /
              this.scalePercent) *
            defaultScale,
        }
      }
      // 计算点到大板和小板的距离
      for (let i = 0; i < finalLineArr.length; ++i) {
        let line = finalLineArr[i]
        let b = { x: point.x, y: point.y }
        let c = { x: line.x1, y: line.y1 }
        let d = { x: line.x2, y: line.y2 }
        let upFlag = false
        // 计算竖直方向的距离
        // y坐标相等时, 线段为横线, 判断记录的点是否在线段两点的横坐标之间
        if (line.x1 < line.x2) {
          // 横线 往左走
          upFlag =
            compareTowNum(point.x, line.x1, '>=') &&
            compareTowNum(point.x, line.x2, '<=')
        } else if (line.x1 > line.x2) {
          // 横线 往右走
          upFlag =
            compareTowNum(point.x, line.x2, '>=') &&
            compareTowNum(point.x, line.x1, '<=')
        }
        if (upFlag) {
          // 判断上一条线段是否和比较的线段有交集, 如果有则求最小值
          if (surplusLine && !this.checkRangeIntersect(surplusLine, line, 'up'))
            continue
          let a = { x: point.x, y: 0 }
          let calcResult = this.calcIntersectPoint(a, b, c, d)
          if (!calcResult) continue
          let distance = point.y - calcResult.y
          // 如果小于0, 说明在该点下方, 大于0, 说明在该点上方
          if (distance < 0) {
            downArr.push(-distance)
          } else {
            upArr.push(distance)
          }
        }

        let leftFlag = false
        if (line.y1 < line.y2) {
          leftFlag =
            compareTowNum(point.y, line.y1, '>=') &&
            compareTowNum(point.y, line.y2, '<=')
        } else if (line.y2 < line.y1) {
          leftFlag =
            compareTowNum(point.y, line.y2, '>=') &&
            compareTowNum(point.y, line.y1, '<=')
        }
        if (leftFlag) {
          if (
            surplusLine &&
            !this.checkRangeIntersect(surplusLine, line, 'left')
          )
            continue
          let a = { x: 0, y: point.y }
          let calcResult = this.calcIntersectPoint(a, b, c, d)
          if (!calcResult) continue
          let distance = point.x - calcResult.x
          // 如果大于0, 说明在该点左侧
          if (distance < 0) {
            rightArr.push(-distance)
          } else {
            leftArr.push(distance)
          }
        }
      }
      // 计算各个方向的最小距离
      this.leftDistance =
        (Math.min(...leftArr) / defaultScale) * this.scalePercent
      this.rightDistance =
        (Math.min(...rightArr) / defaultScale) * this.scalePercent
      this.upDistance = (Math.min(...upArr) / defaultScale) * this.scalePercent
      this.downDistance =
        (Math.min(...downArr) / defaultScale) * this.scalePercent
      // 最后的长度都不能小于1，小于1的线段没有意义
      this.leftDistance = this.leftDistance <= 1 ? 0 : this.leftDistance - 0.001
      this.rightDistance =
        this.rightDistance <= 1 ? 0 : this.rightDistance - 0.001
      this.upDistance = this.upDistance <= 1 ? 0 : this.upDistance - 0.001
      this.downDistance = this.downDistance <= 1 ? 0 : this.downDistance - 0.001
    },

    calcIntersectPoint(a, b, c, d) {
      let denominator = (b.x - a.x) * (d.y - c.y) - (d.x - c.x) * (b.y - a.y)
      if (denominator == 0) return false
      let b1 = (b.y - a.y) * a.x + (a.x - b.x) * a.y
      let b2 = (d.y - c.y) * c.x + (c.x - d.x) * c.y
      let x = (b2 * (b.x - a.x) - b1 * (d.x - c.x)) / denominator
      let y = (b2 * (b.y - a.y) - b1 * (d.y - c.y)) / denominator
      return {
        x: x,
        y: y,
      }
    },

    // 绘制余料
    drawSurplus(e) {
      BODY.style.cursor = 'default'
      let point = {
        x: e.offsetX,
        y: e.offsetY,
      }
      if (this.surplusPoint.length == 0) {
        let bigpartPolyList = []
        for (let i = 0; i < this.bigpart.bigPlank[0].length; ++i) {
          let point2 = this.bigpart.bigPlank[0][i]
          bigpartPolyList.push({
            x:
              this.bigpart.subtleStartX +
              this.deviation +
              (point2.X / defaultScale) * this.scalePercent,
            y:
              this.bigpart.subtleStartY +
              this.deviation +
              this.topInfoHeight +
              (point2.Y / defaultScale) * this.scalePercent,
          })
        }
        let isInBigPlank = this.isInPolygon(point, bigpartPolyList)
        if (!isInBigPlank) {
          this.$message({
            message: translate('arrangedPage.subtlePage.cutErr2'),
            type: 'error',
          })
          return
        }
        if (!this.checkPointInCounter(point)) {
          this.$message({
            message: this.$translateLang('裁剪余料不能超出台面外'),
            type: 'error',
          })
          return
        }
      }
      if (this.surplusPoint.length == 0) {
        this.surplusPoint.push(point)
        this.calcPointDistance({ x: e.offsetX, y: e.offsetY })
      } else {
        /** 裁剪的最后一个点位 */
        let finalPoint = this.surplusPoint[this.surplusPoint.length - 1]
        // 如果当前点击的位置和记录的点位数组最后一个相同, 则不会记录该点
        if (
          this.nextPoint.x == finalPoint.x &&
          this.nextPoint.y == finalPoint.y
        ) {
          return
        } else {
          const clampedNext = this.clampSurplusPointToCounter(this.nextPoint)
          if (!this.checkPointInCounter(clampedNext)) {
            this.$message({
              message: this.$translateLang('裁剪余料不能超出台面外'),
              type: 'error',
            })
            return
          }
          this.nextPoint = clampedNext
          this.surplusPoint.push(this.nextPoint)
          const compPoint = this.cutPointComp(this.nextPoint)
          const firstPoint = this.surplusPoint[0]
          // 如果有自动补全的点位，则直接添加余料
          if (compPoint && this.surplusPoint.length > 6) {
            const endPoint = this.surplusPoint[this.surplusPoint.length - 1]
            const endSecondPoint =
              this.surplusPoint[this.surplusPoint.length - 2]
            const direction = endPoint.y == endSecondPoint.y
            // 是否四点一线 起始点、倒数第一、第二点、自动补全的点
            const isSameLine =
              (direction &&
                compPoint.y == firstPoint.y &&
                compPoint.y == endPoint.y &&
                compPoint.y == endSecondPoint.y) ||
              (!direction &&
                compPoint.x == firstPoint.x &&
                compPoint.x == endPoint.x &&
                compPoint.x == endSecondPoint.x)
            if (!isSameLine) {
              this.surplusPoint.push(compPoint)
              this.addNewSurplus()
              return
            }
          } else {
            if (this.surplusPoint.length > 8) {
              this.$message({
                message: this.$translateLang(
                  '裁剪点位将超出点位限制:9，请重新裁剪'
                ),
                type: 'error',
              })
              this.surplusPoint.pop()
              return
            } else {
              // 判断是否有线段相交
              const isIntersect = hasSegmentsIntersection(
                this.surplusPoint.length == 8
                  ? [...this.surplusPoint, this.surplusPoint[0]]
                  : this.surplusPoint
              )

              if (isIntersect) {
                this.$message({
                  message:
                    this.$translateLang('裁剪点位存在交叉问题，请重新裁剪'),
                  type: 'error',
                })
                this.surplusPoint.pop()
                return
              }
            }
          }

          const endPoint = this.surplusPoint[this.surplusPoint.length - 1]
          if (
            firstPoint &&
            endPoint &&
            firstPoint.x == endPoint.x &&
            firstPoint.y == endPoint.y
          ) {
            this.addNewSurplus()
            return
          }
        }
        // 当余料的点位有5个时进入判断
        // if (this.surplusPoint.length === 5) {
        //   // 判断余料板件是否自相交
        //   const isShapeIntersect = this.dealShapeIntersect()
        //   if (!isShapeIntersect) return
        //   // 判断余料生成的线段是否合大板上已存在的板件冲突
        //   const isPartConflict = this.dealLinePartConflict(e)
        //   if (!isPartConflict) return
        // }

        this.calcPointDistance(this.nextPoint)
        finalPoint = this.surplusPoint[this.surplusPoint.length - 1]

        // 如果是矩形, 则形成闭合, 退出余料裁剪状态
        // if (this.surplusPoint.length == 4) {
        //   const firstPoint = this.surplusPoint[0]

        //   if (firstPoint.x == finalPoint.x || firstPoint.y == finalPoint.y) {
        //     // 闭合之前需要检查是否可以闭合
        //     const flag = this.dealLinePartConflict(e)
        //     if (!flag) return
        //     this.addNewSurplus()
        //     return
        //   }
        // }
        // if (this.surplusPoint.length == 6) {
        //   this.addNewSurplus()
        //   return
        // }
        this.renderAll()
        this.ctx.beginPath()
        this.ctx.setLineDash([])
        this.ctx.strokeStyle = '#000'

        for (let i = 0; i < this.surplusPoint.length; ++i) {
          if (i == 0) {
            this.ctx.moveTo(this.surplusPoint[i].x, this.surplusPoint[i].y)
          } else {
            this.ctx.lineTo(this.surplusPoint[i].x, this.surplusPoint[i].y)
          }
        }
        this.ctx.stroke()
        this.ctx.closePath()
        this.calcNextPoint(e)
      }
    },

    // 添加余料
    addNewSurplus() {
      let pathArr = []
      const isUseSaw =
        this.bigpart.parts.length &&
        this.bigpart.parts.every((part) => part.isUseSaw)
      // 满足使用锯切 优先使用锯切刀
      let diameter = isUseSaw
        ? getSawKnife(this.ncSetting)
        : +getPlateKnifeDiameter(this.bigpart.stockKey, this.ncSetting)
      if (this.ncSetting.glass_setting) {
        diameter = 0
      }
      const simplifiedPath = simplifyPolygon(this.surplusPoint)
      for (let i = 0; i < simplifiedPath.length; ++i) {
        let point = simplifiedPath[i]
        let newPoint = {
          x: Number(
            (
              ((point.x - this.bigpart.subtleStartX - this.deviation) /
                this.scalePercent) *
              defaultScale
            ).toFixed(this.ncSetting.decimal)
          ),
          y: Number(
            (
              ((point.y -
                this.bigpart.subtleStartY -
                this.deviation -
                this.topInfoHeight) /
                this.scalePercent) *
              defaultScale
            ).toFixed(this.ncSetting.decimal)
          ),
        }
        pathArr.push(newPoint)
      }

      // 余料闭合路径
      if (pathArr.length === 6) {
        pathArr.push({ ...pathArr[0] })
      }

      const flag = checkPathInPlankMerge(pathArr, this.bigpart)

      if (!flag) {
        return this.$message.error(
          this.$translateLang('裁剪余料与板件轮廓冲突，请重新裁剪')
        )
      }

      // 台面宽度限制：裁剪余料整体不可超出台面有效宽度（xyReverse 时限制 Y）
      const pathMinX = Math.min(...pathArr.map((p) => p.x))
      const pathMaxX = Math.max(...pathArr.map((p) => p.x))
      const pathMinY = Math.min(...pathArr.map((p) => p.y))
      const pathMaxY = Math.max(...pathArr.map((p) => p.y))
      if (
        isBoundBoxOutsideCounter(
          { x1: pathMinX, y1: pathMinY, x2: pathMaxX, y2: pathMaxY },
          {
            plankWidth: this.bigpart.plankWidth,
            plankHeight: this.bigpart.plankHeight,
            bigpart: this.bigpart,
          },
          this.ncSetting
        )
      ) {
        return this.$message.error(
          this.$translateLang('裁剪余料不能超出台面外')
        )
      }

      pathArr = pathArr.map((point) => {
        return {
          x: toDecimal(point.x, this.ncSetting.decimal),
          y: toDecimal(point.y, this.ncSetting.decimal),
        }
      })
      let min_x = []
      let min_y = []
      for (let i = 0; i < pathArr.length; ++i) {
        min_x.push(pathArr[i].x)
        min_y.push(pathArr[i].y)
      }
      let startX = Math.min(...min_x)
      let startY = Math.min(...min_y)
      let width = Number((Math.max(...min_x) - startX).toFixed(2))
      let height = Number((Math.max(...min_y) - startY).toFixed(2))
      for (let i = 0; i < pathArr.length; ++i) {
        pathArr[i].x -= startX
        pathArr[i].y -= startY
      }

      let addressArr = []
      let idArr = []
      store.state.paibanData.forEach((e) => {
        e.parts.forEach((part) => {
          if (part.address && !addressArr.includes(part.address)) {
            addressArr.push(part.address)
          }
          if (part.orderNo && !idArr.includes(part.orderNo)) {
            idArr.push(part.orderNo)
          }
        })
      })
      let newPlank = {
        startX: startX,
        startY: startY,
        rect: {
          x: 0,
          y: 0,
          width: width,
          height: height,
        },
        realRect: {
          x: 0,
          y: 0,
          width: width - diameter - this.glassDilate,
          height: height - diameter - this.glassDilate,
        },
        oRect: {
          x: 0,
          y: 0,
          width: width - diameter - this.glassDilate,
          height: height - diameter - this.glassDilate,
        },
        fullSize: {
          x: 0,
          y: 0,
          width: width - diameter - this.glassDilate,
          height: height - diameter - this.glassDilate,
        },
        realCurve: {},
        edgeInfo: '←0↓0→0↑0',
        holes: [],
        slots: [],
        sholes: [],
        sslots: [],
        specialType: 'supplus',
        matCode: this.bigpart.matCode,
        thick: this.bigpart.thick,
        texture: this.bigpart.texture,
        oriTexture: this.bigpart.oriBigTexture,
        address: '',
        name: '余料板件',
        stockNum: this.bigpart.stockNum,
        stockKey: this.bigpart.stockKey,
        plankWidth: this.ncSetting.drawPlankWidth,
        plankHeight: this.ncSetting.drawPlankHeight,
        specWidth: width - diameter - this.glassDilate,
        specHeight: height - diameter - this.glassDilate,
        isUseSaw,
        from_address: addressArr.join('/'),
        from_order_num: idArr.join('/'),
        texDir: 'normal',
        srcTexDir: 'normal',
        brandName: this.bigpart.brandName || '',
        supplierName: this.bigpart.supplierName || '',
        colorId: this.bigpart.colorId || '',
      }

      if (this.bigpart.highlight !== '非高光') {
        const sideMap = {
          front: 1,
          back: 2,
        }
        newPlank.highlight_surface =
          sideMap[this.ncSetting.highgloss_direction] ?? 0
        newPlank.is_high_gloss_plank = true
      }

      let maxPlankId = Math.max(
        ...this.bigpart.parts.map((item) =>
          +item.plankID ? item.plankID : -999
        )
      )
      if (maxPlankId == -999 || maxPlankId == '-Infinity') maxPlankId = 0
      newPlank.plankID = maxPlankId + 1
      // 柜门跳转需要添加doorsize和siez
      const guimenKey = this.$store.state.thinkerxMaterialKeys
      guimenKey && mapGuimenToYPB(newPlank, guimenKey)
      if (pathArr.length > 4) {
        newPlank.path = [
          pathArr.map((point) => {
            return {
              x: toDecimal(point.x, 2),
              y: toDecimal(point.y, 2),
            }
          }),
        ]
        const res = expandPath(-diameter / 2, toUpperPointPath(pathArr))
        newPlank.oPath = [
          dealPathToBasePoint(
            res[0].map((point) => {
              return {
                x: toDecimal(point.x, 2),
                y: toDecimal(point.y, 2),
              }
            })
          ),
        ]
        if (!checkPathIsClosed(newPlank.path[0])) {
          closePath(newPlank.path[0])
        }
        if (!checkPathIsClosed(newPlank.oPath[0])) {
          closePath(newPlank.oPath[0])
        }
      }

      // 用于标签绘制中余料的绘制
      newPlank.surplusPath = [pathArr]

      newPlank.realCurve = [
        { x: 0, y: 0 },
        { x: newPlank.oRect.width, y: 0 },
        { x: newPlank.oRect.width, y: newPlank.oRect.height },
        { x: 0, y: newPlank.oRect.height },
      ]

      dealPlankPoly(newPlank)

      newPlank.index = this.supplusIndex
      this.setPlankLableId(this.plankLableId + 1)
      newPlank.labelId = dealNumber(this.$store.state.plankLableId)
      this.setSupplusIndex()

      newPlank.oriPlankNum = uniquePlankNum.createUniquePlankNum(newPlank, true)
      newPlank.plankNum = newPlank.oriPlankNum
      newPlank.checklistID = dealChecklistID(this.bigpart.parts)
      newPlank.partUniqueId = nanoid()

      addPropForPart(newPlank)
      generateSimplePlankNum(newPlank)
      this.bigpart.parts.push(newPlank)
      this.surplusPoint = []
      this.nextPoint = null
      this.calcCutPositionOrder(this.bigpart)
      calcBigpartArea(this.bigpart, this.ncSetting, this.isUnuseSurplus)
      this.renderAll()
    },
    // 绘制完余料后, 重新设置下刀点和下刀顺序
    async calcCutPositionOrder(bigpart, onlyCalCutPoint = false) {
      let plankWidth = this.standardPlank.plankWidth
      let plankHeight = this.standardPlank.plankHeight
      let {
        startPosition,
        xyReverse,
        cutDirection,
        movePlankSetting,
        surplusPosition,
      } = this.ncSetting
      let rectMap = {}
      const diameter = +getPlateKnifeDiameter(bigpart.stockKey, this.ncSetting)
      let cutKnifeR = diameter / 2

      const realSurplusPosition = calcSurplusPositionByStartPosition(
        startPosition,
        surplusPosition,
        xyReverse
      )

      let title = `${this.bigpart.texture}:${this.bigpart.matCode}:${this.bigpart.thick}`
      if (this.bigpart.brandName && this.bigpart.supplierName) {
        title += `:${this.bigpart.brandName}:${this.bigpart.supplierName}`
      }
      const bigPartLen = this.bigpart.parts.length
      for (let k = 0; k < bigPartLen; ++k) {
        let _set = []
        this.bigpart.parts.forEach((item) => {
          _set.push(item.index)
        })
        const maxNum = _set.sort((a, b) => a - b).pop() + 1
        filterNestedParts(this.bigpart.parts)
        let part = this.bigpart.parts[k]
        const { startX, startY } = calcSurplusPosition(
          realSurplusPosition,
          part,
          cutKnifeR,
          { plankWidth, plankHeight }
        )
        this.bigpart.parts[bigPartLen - 1].index = maxNum
        let partRectWidth = 0
        let partRectHeight = 0
        partRectWidth = part.rect.width
        partRectHeight = part.rect.height
        let partInfo = {
          width: partRectWidth,
          height: partRectHeight,
          startX: Number(startX),
          startY: Number(startY),
          isRotated: part.isRotated ? part.isRotated : false,
          partIndex: part.index,
          stockNum: part.stockNum,
          inPlankStockNum: part.inPlankStockNum,
          // priority: part.priority,
        }
        if (part.surplusInfo) {
          partInfo.surplusInfo = part.surplusInfo
        }
        if (rectMap[title]) {
          rectMap[title].push(partInfo)
        } else {
          rectMap[title] = [partInfo]
        }
      }

      let obj = {
        ncConfig: {
          plankWidth: plankWidth ?? this.ncSetting.panelSize.plankWidth,
          plankHeight: plankHeight ?? this.ncSetting.panelSize.plankHeight,
          startPosition: calcStartPositionBySurplus(realSurplusPosition),
          // xyReverse: xyReverse,
          cutDirection: cutDirection ?? '逆时针',
          new_cut_sequence: !!movePlankSetting?.strong_suction_zones.length
            ? Boolean(movePlankSetting?.newCutSequence)
            : false,
          surplus_position: realSurplusPosition,
          strong_suction_zones: movePlankSetting?.strong_suction_zones,
          safe_length: movePlankSetting?.safe_length,
          scattered_layout: movePlankSetting?.scattered_layout,
          // OnlyCalCutPoint: onlyCalCutPoint,
        },
        layoutRectMap: rectMap,
        uid: this.userInfo.id,
      }
      this.showLoading = true
      if (sessionStorage.getItem('thinkerx_material')) {
        obj['from'] = '门窗erp'
      }

      const callBack = (res) => {
        if (res.status == 1) {
          let newPointArr = res.result.data[title]
          for (let i = 0; i < newPointArr.length; ++i) {
            for (let k = 0; k < bigpart.parts.length; ++k) {
              let plank = bigpart.parts[k]
              if (plank.index === newPointArr[i].index) {
                plank.priority = newPointArr[i].priority
                plank.cutOrigin = newPointArr[i].cutOrigin
              }
            }
          }
          applyLastCutPoint([bigpart], this.ncSetting.movePlankSetting)
          this.renderAll()
          this.$message({
            type: 'success',
            message: this.$t('arrangedPage.recalcIndexSuccess'),
          })
          this.showLoading = false
        } else {
          this.$message({
            type: 'error',
            message: '计算下刀点失败!',
          })
          this.showLoading = false
        }
      }

      const isWebQT = window.webToQt && window.webToQt.calcPriority
      if (isWebQT) {
        window.webToQt.calcPriorityFinished.connect(callBack)
        window.webToQt.calcPriority(obj)
      } else {
        await this.$token('/get_cal_priority', obj, callBack)
      }
    },
    showPartSize(field, needShowField) {
      const rect = getOriginRect(this.activePlank, field)
      return (rect?.[needShowField] ?? 0).toFixed(2)
    },
    // 判断板件是否和余料线段冲突
    dealLinePartConflict() {
      const point = this.getNextPoint()
      const lastPoint = this.surplusPoint[this.surplusPoint.length - 1]
      const { x, y } = point
      let bigpartPolyList = []
      let left = this.bigpart.subtleStartX + this.deviation
      let top = this.bigpart.subtleStartY + this.deviation + this.topInfoHeight
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        const part = this.bigpart.parts[i]
        let shapePath = []
        if (part.path) {
          shapePath = part.path[0]
        } else {
          const { width, height } = part.rect
          shapePath = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width, y: height },
            { x: 0, y: height },
            { x: 0, y: 0 },
          ]
        }
        shapePath.forEach((it) => {
          bigpartPolyList.push({
            X: left + ((part.startX + it.x) / defaultScale) * this.scalePercent,
            Y: top + ((part.startY + it.y) / defaultScale) * this.scalePercent,
          })
        })
        const lineArr = [[lastPoint, { x, y }]]
        if (this.surplusPoint.length === 5) {
          lineArr[1] = [{ x, y }, this.surplusPoint[0]]
        }
        const len = bigpartPolyList.length - 1
        let flag = false
        for (let i = 0; i < len; i++) {
          const cut = bigpartPolyList[i]
          const next = bigpartPolyList[(i + 1) % len]
          const line2 = [
            { x: cut.X, y: cut.Y },
            { x: next.X, y: next.Y },
          ]
          for (let j = 0; j < lineArr.length; j++) {
            flag = dealLineSegmentIntersect(lineArr[j], line2)
            if (flag) break
          }
          if (flag) break
        }
        bigpartPolyList.length = 0
        if (flag) {
          this.surplusPoint.pop()
          this.calcPointDistance(
            this.surplusPoint[this.surplusPoint.length - 1]
          )
          this.$message.error(translate('arrangedPage.plankConfilictErr'))
          return false
        }
      }
      return true
    },
    // 获取余料的下一点位
    getNextPoint() {
      const firstPoint = this.surplusPoint[0]
      let point1 = this.surplusPoint[this.surplusPoint.length - 2]
      let point2 = this.surplusPoint[this.surplusPoint.length - 1]
      let nextDirection
      if (point1.y == point2.y) {
        nextDirection = true
      }
      if (point1.x == point2.x) {
        nextDirection = false
      }
      let point = {}
      if (nextDirection) {
        point = {
          x: point2.x,
          y: firstPoint.y,
        }
      } else {
        point = {
          x: firstPoint.x,
          y: point2.y,
        }
      }
      return point
    },
    // 判断余料是否自相交
    dealShapeIntersect() {
      const last = this.surplusPoint[this.surplusPoint.length - 1]
      // 获取余料的下一个点位
      const nextPoint = this.getNextPoint()
      /**
       * 只需要判断余料的第一条线段和最后一条线段 || 第二条线段和最后一个点位和余料的下一点位组成的线段是否冲突
       */
      const lineArr = [
        [
          [last, nextPoint],
          [this.surplusPoint[1], this.surplusPoint[2]],
        ],
        [
          [this.surplusPoint[this.surplusPoint.length - 2], last],
          [this.surplusPoint[0], this.surplusPoint[1]],
        ],
      ]
      let flag
      for (const line of lineArr) {
        flag = dealLineSegmentIntersect(line[0], line[1])
        if (flag) break
      }
      if (flag) {
        this.surplusPoint.pop()
        const lastPoint = this.surplusPoint[this.surplusPoint.length - 1]
        this.calcPointDistance(lastPoint)
        this.$message.error(translate('arrangedPage.surplusErrTip'))
        return false
      }
      return true
    },
    async downloadNC() {
      if (await this.beforeCommonCheck()) {
        return
      }
      // 板件发生了变化在下载 NC 时需要检查
      if (this.isPlankChange().isChange) {
        const confirmStr = await this.$confirm(
          this.$translateLang(
            '板件数据已发生变化，但未保存方案，请点击确定保存方案，再进行后续操作'
          ),
          translate('common.tip'),
          {
            confirmButtonText: translate('common.confirm'),
            cancelButtonText: translate('common.cancel'),
            type: 'warning',
          }
        )
        if (confirmStr !== 'confirm') return
      }
      this.recordSortBeforeStockKeyArr()
      this.changeDrawPlank()
      buryPointApi('layout_sub', 'download_nc')
      this.currentSubtleOperate = 'nc'
      this.$emit('downloadNC', this.bigpart)
      this.bigpart?.parts.forEach((part) => {
        // 任意数据不相等则标识改变 板子位置数据 下刀点 切割顺序
        if (part.oriMarkBoards) {
          // 如果没有oriMarkBoards，说明是历史数据
          // 还是用0.001来做容差比较
          if (
            Math.abs(part.startX - part.oriMarkBoards.startX) >= 0.001 ||
            Math.abs(part.startY - part.oriMarkBoards.startY) >= 0.001 ||
            part.cutOrigin !== part.oriMarkBoards.cutOrigin ||
            part.priority !== part.oriMarkBoards.priority ||
            part.mark_notcare ||
            part.mark_rotation ||
            part.reverePlank
          ) {
            part.modified = true
          } else {
            part.modified = false
          }
        }
      })
      this.recordBigpart = cloneDeep(this.bigpart)
      this.renderAll()
    },
    // 部分公用的预检查预检查
    async beforeCommonCheck() {
      const ok = await this.checkAwaitLocalStore()
      return !ok
    },
    // 加载loading按钮
    changeLoading(flag) {
      this.isLoadDownLoadNc = flag
    },
    async printTag() {
      if (await this.beforeCommonCheck()) {
        return
      }
      this.setIsPrintTag(true)
      buryPointApi('layout_sub', 'print_tag')
      this.currentSubtleOperate = 'tag'
      this.$emit('printTag', this.bigpart)
    },
    // 绘制更多排版方案缩略图
    drawMorePlan(way) {
      const startX = 120
      const startY = 120
      const [minX, minY, maxX, maxY] = getPathMinMaxPoint(way.path)
      const width = maxX - minX
      const height = maxY - minY
      way.el.height = height + 240
      way.el.width = width + 240
      const ctx = way.ctx
      ctx.strokeStyle = '#fff'
      ctx.lineWidth = 15
      ctx.fillStyle = 'rgb(234, 234, 234)'
      ctx.beginPath()
      way.path.forEach((v, index) => {
        if (!index) {
          ctx.moveTo(v.x + startX, v.y + startY)
        } else {
          ctx.lineTo(v.x + startX, v.y + startY)
        }
      })
      ctx.closePath()
      ctx.fill()
      ctx.stroke()
      // 绘制台面外区域
      this.drawMorePlanOverSizeArea(ctx, way, startX, startY)
      // 绘制小板
      way.parts.forEach((part) => {
        this.drawPartsParmas(way.ctx, part, startX, startY, way)
      })
    },
    /**
     * @description 更多排版方案缩略图绘制台面外区域
     */
    drawMorePlanOverSizeArea(ctx, way, startX, startY) {
      const { counter_limit_able, counter_width, startPosition, xyReverse } =
        this.ncSetting
      if (!counter_limit_able || !counter_width) return
      const plankWidth = Number(way.plankWidth) || 0
      const plankHeight = Number(way.plankHeight) || 0
      const limitSize = xyReverse ? plankHeight : plankWidth
      if (!limitSize || counter_width >= limitSize) return

      const pathArr = way.path.map((v) => ({
        x: v.x + startX,
        y: v.y + startY,
      }))
      const pathMinX = Math.min(...pathArr.map((p) => p.x))
      const pathMaxX = Math.max(...pathArr.map((p) => p.x))
      const pathMinY = Math.min(...pathArr.map((p) => p.y))
      const pathMaxY = Math.max(...pathArr.map((p) => p.y))
      const drawPlankWidth = pathMaxX - pathMinX
      const drawPlankHeight = pathMaxY - pathMinY

      let overSizePaths = []
      if (xyReverse) {
        // 与 drawOverSizeArea 一致：左下角/右下角台面在下，台面外取反
        const isBottom = ['左下角', '右下角'].includes(startPosition)
        const splitY = isBottom
          ? pathMinY + drawPlankHeight - counter_width
          : pathMinY + counter_width
        overSizePaths = getPathBySplitYWithClipper(pathArr, splitY, !isBottom)
      } else {
        // 含「右」台面在右，台面外取反
        const isRight = String(startPosition || '').includes('右')
        const splitX = isRight
          ? pathMinX + drawPlankWidth - counter_width
          : pathMinX + counter_width

        overSizePaths = getPathBySplitXWithClipper(pathArr, splitX, !isRight)
      }
      if (!overSizePaths.length) return

      ctx.save()
      ctx.fillStyle = '#e698a3'
      const fontSize = 48
      ctx.font = `bold ${fontSize}px 'PingFangSC-Regular, PingFang SC'`
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      const text = '台面外'
      const charWidth = ctx.measureText(text[0]).width
      const textWidth = ctx.measureText(text).width
      const charGap = 4
      overSizePaths.forEach((path) => {
        ctx.beginPath()
        path.forEach(({ x: px, y: py }, idx) => {
          if (idx === 0) {
            ctx.moveTo(px, py)
          } else {
            ctx.lineTo(px, py)
          }
        })
        ctx.closePath()
        ctx.fill()
        drawOverSizeAreaLabel(ctx, path, {
          text,
          fontSize,
          charWidth,
          textWidth,
          charGap,
        })
      })
      ctx.restore()
    },
    /**
     * 绘制更多排版方案的小板
     *孔位 | 拉槽 | 下刀点 | 下刀顺序 | 异形孔位
     * */
    drawPartsParmas(ctx, part, startX, startY, bigpart) {
      if (part.holeSlotMerge) {
        ctx.fillStyle = '#F808'
      } else {
        ctx.fillStyle = 'rgba(238, 238, 161, 0.8)'
      }
      ctx.strokeStyle = '#0008'
      ctx.lineWidth = 15
      if (part.plankMerge) {
        ctx.fillStyle = '#f008'
      }
      if (part.specialType) {
        ctx.fillStyle = 'rgba(255, 200, 200, 0.8)'
      }
      let rect = {
        x: startX + part.startX,
        y: startY + part.startY,
        width: part.rect.width,
        height: part.rect.height,
      }
      if (part.path) {
        ctx.beginPath()
        let pArr = []
        if (part.curveHoles) {
          part.curveHoles.forEach((item) => {
            let p = item.path
            p.kkey = item.deep ? item.deep : item.depth
            p.kkey = Math.abs(p.kkey)
            pArr.push(p)
          })
        }
        let newArr = part.curveHoles ? [...part.path, ...pArr] : part.path
        for (let i = 0; i < newArr.length; ++i) {
          let current = newArr[i]
          if (i == 0) {
            if (part.holeSlotMerge) {
              ctx.fillStyle = '#F808'
            } else {
              ctx.fillStyle = 'rgba(238, 238, 161, 0.8)'
            }
            if (part.plankMerge) {
              ctx.fillStyle = '#f008'
            }
            if (part.specialType) {
              ctx.fillStyle = 'rgba(255, 200, 200, 0.8)'
            }
          }
          for (let k = 0; k < current.length; ++k) {
            let x = rect.x + current[k].x
            let y = rect.y + current[k].y
            if (k == 0) {
              ctx.moveTo(x, y)
            } else {
              ctx.lineTo(x, y)
            }
          }
          ctx.closePath()
          if (!current.kkey || current.kkey >= bigpart.thick) {
            ctx.stroke()
          }
          if (current.kkey) {
            Reflect.deleteProperty(current, 'kkey')
          }
        }
        ctx.fill('evenodd')
      } else {
        ctx.fillRect(rect.x, rect.y, rect.width, rect.height)
        ctx.strokeRect(rect.x, rect.y, rect.width, rect.height)
      }
      this.drawAllHoles(ctx, part, rect, true)
      this.drawAllSlots(ctx, part, rect, true)
      this.drawAllCurveHole(ctx, part, rect, bigpart, true)
    },
    /** 精细排版重新排版：生成 layoutRectMap 单条（仅孔槽扩板，rect 规则同排版页） */
    buildSubtlePlankParamForPaiban(part, layoutCtx, options = {}) {
      const { sawToLayout, sawCutOnlyWeld, realSurNotLayout, plankNames } =
        layoutCtx
      const expandedX = part.finalExtendDisMap
        ? part.finalExtendDisMap.left + part.finalExtendDisMap.right
        : 0
      const expandedY = part.finalExtendDisMap
        ? part.finalExtendDisMap.top + part.finalExtendDisMap.bottom
        : 0
      let rect
      if (
        sawToLayout &&
        ((sawCutOnlyWeld && part.isWeldingPlank) || !sawCutOnlyWeld)
      ) {
        rect = {
          x1: part.rect.x,
          y1: part.rect.y,
          x2: part.realRect.width + expandedX,
          y2: part.realRect.height + expandedY,
        }
      } else {
        rect = {
          x1: part.rect.x,
          y1: part.rect.y,
          x2: part.rect.width + expandedX,
          y2: part.rect.height + expandedY,
        }
      }
      let obj = {
        id: part.partUniqueId,
        rect,
        needRoll: part.needRoll,
        rotate: sawToLayout ? false : part.texDir == 'notcare' ? true : false,
        isWeldingPlank: part.isWeldingPlank,
        pathEdge: part.pathEdge,
      }
      const partName = part.partName || part.name || ''
      if (
        realSurNotLayout &&
        plankNames.some((name) => partName.includes(name))
      ) {
        obj.isSurNotLayoutMat = true
      }
      if (sawToLayout) {
        obj.rotate = false
      }
      if (isVirtualCompositePlank(part)) {
        obj.rotate = false
        obj.needRoll = false
      }
      // 合并骨骼门即使无纹理也不允许旋转
      if (judgeIsMergeFrameDoor(part)) {
        obj.rotate = false
      }
      if (this.isSpecialShape && part.path) {
        const curveHolesArr = part.curveHoles
          ?.filter((it) => compareNumbers(it.deep, part.thick))
          .map((it) => it.path)
        let paths = part.path
        if (part.slots?.length) {
          paths = dealUnionPathSlots(paths, part.slots, this.ncSetting)
        }
        obj.cutCurve = [...paths]
        if (curveHolesArr?.length && !!curveHolesArr[0]) {
          obj.cutCurve.push(...curveHolesArr)
        }
      }
      forEachTextureChild(part, (child) => {
        const targetPoint = part._virtualCompositePlanksPos?.find(
          (it) => it.partUniqueId === child.partUniqueId
        )
        const childParam = this.buildSubtlePlankParamForPaiban(
          child,
          layoutCtx,
          {
            rotate: false,
            needRoll: false,
            startX: targetPoint?.x ?? 0,
            startY: targetPoint?.y ?? 0,
          }
        )
        if (!obj.children) {
          obj.children = []
        }
        obj.children.push(childParam)
      })
      return Object.assign(obj, options)
    },
    // 改变排版方案
    handleChangePaibanWay(data) {
      // 同步轮廓
      this.bigpart.path = data.path
      const { width, height } = this.resetSubtleSize(this.bigpart)
      this.bigpart.plankWidth = width
      this.bigpart.plankHeight = height
      dealBigPlank(this.bigpart)
      this.replaceRectData(data.parts)
      genLabelTextureGroups(this.bigpart.parts)
      this.renderAll()
      const hasSurplus = this.bigpart.parts.some(
        (item) => item.surplusPath && item.surplusPath.length
      )
      // 有余料时需要进行余料裁剪
      if (hasSurplus) {
        this.bigpart.parts = this.bigpart.parts.filter(
          (item) => !item.surplusPath
        )
        this.tailorSurplus(this.bigpart)
      }
      const paibanWay = this.activePaibanWay[0]
        ? this.activePaibanWay[0].replace('_roll', '')
        : 'paiban_v2'
      if (
        this.ncSetting.sawSetting.firstCutSurplus &&
        this.ncSetting.sawSetting.surplusStoreAndLabeling &&
        paibanWay == 'paiban' &&
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      ) {
        cutBlueSurplus(this.drawData, this.ncSetting)
      }
      this.hasReformatFlag = true
      this.isBatchPosition = false
      this.$message.success(translate('arrangedPage.changeArrageSuccess'))
    },
    // 将rect和rectind相匹配的值, 将他们的startX和startY进行替换
    replaceRectData(data) {
      const title = `${this.bigpart.texture}:${this.bigpart.matCode}:${this.bigpart.thick}`

      for (let i = 0; i < data.length; ++i) {
        let dstpart = data[i]

        for (let k = 0; k < this.bigpart.parts.length; ++k) {
          let srcpart = this.bigpart.parts[k]
          if (srcpart.partUniqueId == dstpart.partUniqueId) {
            let recordIndex = srcpart.index
            const stock_num = srcpart.stockNum
            // dstpart 可能来自 paibanWays 缓存（方案缩略图）或重新排版结果，
            // 直接 Object.assign 会让当前小板与缓存共享 holes/_transformLog 等可变引用，
            // 后续旋转/翻面原地修改孔位时会把缓存一起改坏，再次应用该方案就会出现框与孔不一致。
            // 这里先深拷贝，保证当前小板独占自己的数据。
            Object.assign(srcpart, cloneDeep(dstpart))
            srcpart.index = recordIndex
            srcpart.stockNum = stock_num
            // 保持原有的stockKey
            srcpart.stockKey = this.subtleData.stockKey
            // 重新处理边框点位
            dealPlankPoly(this.bigpart.parts[k])
            break
          }
        }
      }
      if (
        this.ncSetting.sawSetting.firstCutSurplus &&
        this.ncSetting.sawSetting.surplusStoreAndLabeling &&
        this.activePaibanWay[0] == 'paiban' &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      ) {
        this.updateBlueAreaSurplusPart(this.bigpart)
      }
    },
    // 处理更多排版方案数据
    async dealMorePlan(preData) {
      const allSubPaibanData =
        this.$store.state.paibanStore.allSubPaibanDataCollectList
      const plankSizeArr = [this.bigpart.plankWidth, this.bigpart.plankHeight]
      if (this.ncSetting.xyReverse) {
        plankSizeArr.reverse()
      }
      for (let index = 0; index < allSubPaibanData.length; index++) {
        const subPaibanData = allSubPaibanData[index]
        const res = await paibanDataToView(
          preData,
          cloneDeep(subPaibanData.data),
          false,
          false,
          {
            plankWidth: plankSizeArr[0],
            plankHeight: plankSizeArr[1],
          }
        )
        if (res.length == 1) {
          this.paibanWays.push(res[0])
          this.tailorSurplus(res[0], true)
          this.paibanWays.forEach((way, index) => {
            way.canvasIndex = this.bigpart.canvasIndex
            this.$nextTick(() => {
              let el = this.$refs[`planCanvasRef${way.canvasIndex}-${index}`][0]

              let ctx = el.getContext('2d')
              way.el = el
              way.ctx = ctx
              this.drawMorePlan(way)
            })
          })
        }
      }
    },
    // 添加大板锁定icon的信息
    setLockInfo() {
      let lockStartX = (this.bigpart.subLockStartX =
        this.bigpart.subtleStartX +
        this.deviation +
        this.bigpart.subtleWidth +
        20 * this.scalePercent)
      let lockStartY = (this.bigpart.subLockStartY =
        this.bigpart.subtleStartY + this.topInfoHeight - 30 * this.scalePercent)
      let lockWidthHeight = (this.bigpart.subLockWH = 24 * this.scalePercent)
      let lockEndY = lockStartY + this.bigpart.subLockWH
      let lockEndX = lockStartX + this.bigpart.subLockWH
      const lockPath = [
        { X: lockStartX, Y: lockEndY },
        { X: lockEndX, Y: lockEndY },
        { X: lockEndX, Y: lockStartY },
        { X: lockStartX, Y: lockStartY },
      ]
      return { lockStartX, lockStartY, lockWidthHeight, lockPath }
    },
    // 判断位置
    jundgeLocation(mousePoint, path) {
      let point = new ClipperLib.IntPoint(mousePoint.x, mousePoint.y)
      const result = ClipperLib.Clipper.PointInPolygon(point, path)
      return result
    },
    // 初始化锁 todo
    // initPlankLock(ctx) {
    //   this.UnLockedImgInstance = new Image()
    //   this.UnLockedImgInstance.src = UnLockedImg
    //   this.UnLockedImgInstance.onload = () => {
    //     ctx.drawImage(this.UnLockedImgInstance, 0, 0, 1, 1)
    //   }
    //   this.LockedImgInstance = new Image()
    //   this.LockedImgInstance.src = LockedImg
    //   this.LockedImgInstance.onload = () => {
    //     ctx.drawImage(this.LockedImgInstance, 0, 0, 1, 1)
    //   }
    // },
    // 获取大板path
    getPlankPath() {
      const plankStartX = this.bigpart.subtleStartX
      const plankStartY = this.bigpart.subtleStartY
      const plankEndX =
        this.bigpart.subtleStartX +
        this.bigpart.subtleWidth +
        2 * this.deviation
      const plankEndY =
        this.bigpart.subtleStartY +
        this.bigpart.subtleHeight +
        2 * this.deviation +
        this.topInfoHeight

      const path = [
        { X: plankStartX, Y: plankEndY },
        { X: plankEndX, Y: plankEndY },
        { X: plankEndX, Y: plankStartY },
        { X: plankStartX, Y: plankStartY },
      ]
      return path
    },
    // 存入余料清单
    handleSaveSurStorage() {
      this.saveSurplus(true)
    },
    /** 记录进入精细排版时待排版库当前板件所拥有或正在显示的id, 可用于退出恢复之前的数据 */
    recordAwaitStoreIds() {
      const { localPlankStore, servePlankStore, participationPaibanPlank } =
        this.$store.state.awaitPaibanStore
      this.awaitLocalPlankStoreIds = localPlankStore.map((it) => ({
        id: it.partUniqueId,
        isShow: it.isShow,
      }))
      this.awaitServePlankStoreIds = servePlankStore.map((it) => ({
        id: it.partUniqueId,
        isShow: it.isShow,
      }))
      this.awaitParticipationPaibanPlank = [...participationPaibanPlank]
    },
    /** 退出但未保存的情况下需要重新恢复待排版库的数据 */
    recoverAwaitStoreData() {
      const { localPlankStore, servePlankStore } =
        this.$store.state.awaitPaibanStore
      const loaclIds = this.awaitLocalPlankStoreIds
      const serveIds = this.awaitServePlankStoreIds
      const newLocalPlankStore = localPlankStore.filter((item) => {
        const target = loaclIds.find((it) => it.id === item.partUniqueId)
        if (target) {
          item.isShow = target.isShow
        }
        return target?.isShow
      })
      servePlankStore.forEach((item) => {
        const target = serveIds.find((it) => it.id === item.partUniqueId)
        if (target) {
          item.isShow = target.isShow
        }
      })
      this.$store.commit(
        'awaitPaibanStore/reSetLocalPlankStore',
        newLocalPlankStore
      )
      this.$store.commit('awaitPaibanStore/setServePlankStore', servePlankStore)
      this.$store.commit('awaitPaibanStore/setParticipationPaibanPlank', [
        ...this.awaitParticipationPaibanPlank,
      ])
    },
    /** 退出但是保存 */
    exitButSave() {
      const { localPlankStore } = this.$store.state.awaitPaibanStore
      const newLocalPlankStore = localPlankStore.filter((it) => it.isShow)
      this.$store.commit(
        'awaitPaibanStore/reSetLocalPlankStore',
        newLocalPlankStore
      )
    },
    /** 待排版入库完成 */
    handleAwaitStoreDone() {
      // 删除本地数据中的板件数据
      this.changeDrawPlank()
      this.$emit('savePlan')
    },
    /** 检查进行下载或标签相关操作前需要先检查待排版库是否存在板件 */
    async checkAwaitLocalStore() {
      if (this.plankActiveNav !== 'zancun') return true
      const result = this.$refs['storeRef']?.checkLocalPlankStore?.()
      if (result == null) return true
      return await Promise.resolve(result)
    },
    /** 设置上一个/下一个切换当前激活的板件 */
    setSubtleActivePlank(subtleIndex, errorList) {
      // 如果当前存在选中板件
      if (this.activePlank) {
        // 清空当前选中板件
        this.activePlank = null
        // 重新绘制当前大版
        this.renderAll()
      }
      // 将当前激活大板设置成目标板件
      let targetPart = errorList[subtleIndex]
      for (let i = 0; i < this.bigpart.parts.length; i++) {
        let part = this.bigpart.parts[i]
        // 需要对比到两块相同的板子
        if (part.partUniqueId == targetPart.partUniqueId) {
          this.activePlank = part
          this.$set(part, 'checked', true)
          this.renderAll()
        }
      }
    },
    /** 切割顺序-自动调整 */
    async handleSubtleAutoAdjust() {
      // 调用父组件的自动计算下刀点的方法
      await this.calcCutPositionOrder(this.bigpart)
      //关闭弹窗
      this.$emit('update:isShowSubtleInspectCutOrder', false)
      this.$nextTick(() => {
        if (this.currentSubtleOperate == 'nc') {
          // 此处下载 NC 暂时都是自动触发，需要跳过数据变化检查才行，不然影响体验，后面需求变动请注意
          this.downloadNC()
        }
      })
    },
    /** 切割顺序-查看详情 */
    handleSubtleShowConflictDetail(type) {
      this.$emit('update:isShowSubtleInspectCutOrder', false)
      if (type.cancelType == 'button') {
        // 打开冲突的板件详情弹窗
        this.isShowSubtleConflictDetail = true
        // 打开详情默认展示第一个数据
        this.setSubtleActivePlank(
          this.currentSubtleCutOrderIndex - 1,
          this.errorCutOrders
        )
      }
    },
    /** 切割顺序详情-上一个/下一个 */
    async handleSubtleOperate(operate) {
      // 这里需要用await等待数据更新完毕
      // 虽然$emit是同步操作，但是它触发的数据更新和dom渲染是异步，在某些情况下更新数据后立马判断会拿不到最新的值
      if (operate === 'last') {
        this.$emit(
          'update:currentSubtleCutOrderIndex',
          this.currentSubtleCutOrderIndex - 1
        )
        await this.$nextTick()
        if (this.currentSubtleCutOrderIndex <= 0) {
          this.$emit(
            'update:currentSubtleCutOrderIndex',
            this.errorCutOrders.length
          )
          await this.$nextTick()
        }
      } else {
        this.$emit(
          'update:currentSubtleCutOrderIndex',
          this.currentSubtleCutOrderIndex + 1
        )
        await this.$nextTick()
        if (this.currentSubtleCutOrderIndex >= this.errorCutOrders.length + 1) {
          this.$emit('update:currentSubtleCutOrderIndex', 1)
          await this.$nextTick()
        }
      }
      // 需要兼容余料板的名字
      this.$emit(
        'update:currentSubtleCutOrderName',
        this.errorCutOrders[this.currentSubtleCutOrderIndex - 1]?.partName ??
          this.errorCutOrders[this.currentSubtleCutOrderIndex - 1]?.name
      )
      await this.$nextTick()
      // 设置激活板件
      this.setSubtleActivePlank(
        this.currentSubtleCutOrderIndex - 1,
        this.errorCutOrders
      )
    },
    /** 切割顺序详情-返回 */
    handleSubtleGoBack() {
      // 关闭详情弹窗
      this.isShowSubtleConflictDetail = false
      // this.isShowSubtleInspectCutOrder = true
      this.$emit('update:isShowSubtleInspectCutOrder', true)
    },
    /**
     * @description 判断小板当前是否开启分层切割
     * @param {Object} part - 小板
     * @returns {boolean}
     */
    isPartLayerCut(part) {
      return !!part?.curve_layered_cutting
    },
    // 异形板件选择分层切割（复选逻辑与外部排版 drawAllParts 一致）
    handleLayerCut(e) {
      const checked = e?.target ? e.target.checked : !this.layerCutChecked
      // 复选（Ctrl 多选）选中多块小板时，分层切割同样应用到全部选中小板
      if (this.batchActiveIdList.length) {
        // 半选状态点击时按「全部开启分层切割」处理
        const nextChecked =
          checked === undefined ? !this.layerCutChecked : checked
        return this.batchLayerCut(nextChecked)
      }
      this.isLayerCut = checked
      // 开启分层切割，需要打开分层切割深度弹窗
      if (checked) {
        this.isShowLayerCutDepthModal = true
      }
      this.activePlank.curve_layered_cutting = checked
    },
    // 深度输入限制
    handleLayerCutDepthInput() {
      this.layerCutDepth = regReplaceCuttingParamsInputDepth(this.layerCutDepth)
    },
    // 确定修改分层切割深度
    handleConfirmLayerCutDepth() {
      // 只能输入数字且支持小数
      if (!/^\d*\.?\d*$/.test(this.layerCutDepth) || this.layerCutDepth < 0) {
        this.$message.warning(
          this.$translateLang('分层切割深度只能输入大于0的数字')
        )
        return
      }
      const deep = Number(this.layerCutDepth)
      // 复选时按选中的全部小板中最薄的板件校验
      const curThick = this.batchActiveIdList.length
        ? Math.min(...this.getBatchActiveParts().map((part) => part.thick))
        : this.activePlank.thick

      if (deep >= curThick) {
        this.$message.warning(
          this.$translateLang('分层切割深度必须小于板件厚度')
        )
        return
      }

      this.isShowLayerCutDepthModal = false
      if (this.batchActiveIdList.length) {
        return this.batchLayerCutDepth(deep)
      }
      this.activePlank.curve_layered_cutting_deep = deep
    },
    /**
     * @description 复选（Ctrl 多选）批量设置分层切割，与单板设置分层切割保持一致
     * @param {boolean} checked - 是否开启分层切割
     * @returns {void}
     */
    batchLayerCut(checked) {
      const targets = this.getBatchActivePartsForAction()
      if (!targets.length) return
      // 开启分层切割，需要打开分层切割深度弹窗
      if (checked) {
        this.isShowLayerCutDepthModal = true
      }
      targets.forEach((part) => {
        part.curve_layered_cutting = checked
      })
      // 同步单板回显标记，退出复选后状态一致
      this.isLayerCut = checked
    },
    /**
     * @description 复选（Ctrl 多选）批量设置分层切割深度
     * @param {number} deep - 分层切割深度
     * @returns {void}
     */
    batchLayerCutDepth(deep) {
      this.getBatchActiveParts().forEach((part) => {
        part.curve_layered_cutting_deep = deep
      })
    },
    // 取消修改分层切割深度
    handleCancelLayerCutDepth() {
      this.isShowLayerCutDepthModal = false
      // 复选时取消全部选中小板的分层切割
      if (this.batchActiveIdList.length) {
        this.getBatchActiveParts().forEach((part) => {
          part.curve_layered_cutting = false
        })
      } else if (this.activePlank) {
        this.activePlank.curve_layered_cutting = false
      }
      this.isLayerCut = false
    },
    /** 根据大板轮廓重置  subtleWidth 和 subtleHeight */
    resetSubtleSize(bigpart) {
      const [minX, minY, maxX, maxY] = getPathMinMaxPoint(bigpart.path)
      const width = maxX - minX
      const height = maxY - minY
      const recordHeight = (Number(height) / defaultScale) * this.scalePercent
      const recordWidth = (Number(width) / defaultScale) * this.scalePercent
      bigpart.subtleWidth = recordWidth
      bigpart.subtleHeight = recordHeight
      return { width, height }
    },

    /** @description 设置 drawData 的统一入口 */
    setDrawData(drawData) {
      this.drawData = drawData
    },
    /** @description 是否需要进行拖动排序后的同步数据 */
    isSyncSortableData() {
      return (
        JSON.stringify(sortableOrderKeys) !==
        JSON.stringify(this.getSortKeyBySortEl())
      )
    },
    /** @description 页面 drawData 同步 sortable 排序后的数据顺序 */
    syncSortableOrder() {
      // 排序方法
      const sortByKey = (arr, strs, getkey) =>
        sortBy(arr, (v) => strs.indexOf(getkey(v)))
      // 同步单个目录的顺序
      const stockKeyArr = sortableElement.stockElArr[0]?.toArray?.() ?? []
      this.setDrawData(sortByKey(this.drawData, stockKeyArr, (v) => v.title))

      const plankElMap = sortableElement.plankElArr.reduce((map, el) => {
        const { stock } = el.el.dataset
        if (stock) {
          map.set(stock, el?.toArray?.() ?? [])
        }
        return map
      }, new Map())
      // 同步每个大板的顺序
      this.drawData.forEach((item) => {
        const plankSortKeyArr = plankElMap.get(item.title)
        if (plankSortKeyArr) {
          item.data = sortByKey(
            item.data,
            plankSortKeyArr,
            (v) => `${v.stockKey}:${v._sortNum}`
          )
        }
      })
    },
    /** @description 添加拖动事件监听 */
    addSortDragEvent() {
      this.removeSortDragEvent()
      sortableElement.stockElArr[0] = new Sortable(
        this.$refs['sortableStockRef'],
        {
          animation: 200,
          ghostClass: 'drag-ghost',
          dragClass: 'drag-active',
          chosenClass: 'drag-chosen',
          handle: '.anticon-menu',
          onUpdate: () => {
            this.syncSortableOrder()
            this.sortDoneByDealDrawData()
          },
        }
      )
      this.$nextTick(() => {
        this.$refs['sortableStockRef']
          .querySelectorAll('.sortable-plank')
          .forEach((el, idx) => {
            sortableElement.plankElArr[idx] = new Sortable(el, {
              animation: 200,
              ghostClass: 'drag-ghost',
              dragClass: 'drag-active',
              chosenClass: 'drag-chosen',
              handle: '.anticon-menu',
              onUpdate: () => {
                this.$nextTick(() => {
                  this.syncSortableOrder()
                  this.sortDoneByDealDrawData()
                })
              },
            })
          })
        this.$nextTick(() => this.recordSortBeforeStockKeyArr())
      })
    },
    /** @description 记录排序之前的key 用于后续对比是否排序发生改变 */
    recordSortBeforeStockKeyArr() {
      sortableOrderKeys = this.getSortKeyBySortEl()
    },
    /** @description 获取根据使用的元素来记录其排序顺序 */
    getSortKeyBySortEl() {
      const keys = []
      Object.values(sortableElement).forEach((arr) => {
        arr.forEach((el) => {
          keys.push(el?.toArray?.() ?? [])
        })
      })
      return keys.flat(1)
    },
    /** @description 移除拖动事件监听 */
    removeSortDragEvent() {
      Object.values(sortableElement).forEach((arr) => {
        arr.forEach((el) => {
          el?.destroy()
        })
        arr.length = 0
      })
      sortableOrderKeys = []
    },
    /**
     * @description 打开调整弹窗
     * @param arr
     * @param item
     * @param currentIdx
     * @param type
     */
    handleOpenAdjustBigPlankOrderModal(arr, item, currentIdx, type) {
      this.adjustBigPlankOrderData.targetIndex = currentIdx + 1
      this.adjustBigPlankOrderData.beforeIndex = currentIdx
      this.adjustBigPlankOrderData.type = type
      this.adjustBigPlankOrderData.target = item
      this.adjustBigPlankOrderData.range = [1, arr.length]
      switch (type) {
        case 'category':
          this.adjustBigPlankOrderData.categorys = arr
          break
        case 'plank':
          this.adjustBigPlankOrderData.planks = arr
          break
      }
      this.adjustBigPlankOrderData.isShowAdjustBigPlankOrderModal = true
    },
    /**
     * @description 确认调整顺序
     */
    handleConfirmAdjustBigPlankOrder() {
      const {
        targetIndex,
        type,
        target,
        range,
        categorys,
        planks,
        beforeIndex,
      } = this.adjustBigPlankOrderData
      if (targetIndex < range[0] || targetIndex > range[1]) {
        this.$message.warning('输入的顺序不在范围内')
        this.adjustBigPlankOrderData.isShowAdjustBigPlankOrderModal = false
        return
      }
      if (targetIndex - 1 === beforeIndex) {
        this.adjustBigPlankOrderData.isShowAdjustBigPlankOrderModal = false
        return
      }
      const targetArr = type === 'category' ? categorys : planks
      // 删除
      targetArr.splice(beforeIndex, 1)
      // 插入
      targetArr.splice(targetIndex - 1, 0, target)
      this.adjustBigPlankOrderData.isShowAdjustBigPlankOrderModal = false
      this.sortDoneByDealDrawData()
    },
    /**
     * @description 大板顺序调整保存后记录操作
     */
    recordAdjustBigPlankOrder(beforeData, currentData) {
      const diff = (data) => {
        return data.map((item) => ({
          key: item.title,
          planks: item.data.map((v) => v.canvasIndex),
        }))
      }
      const beforeSort = JSON.stringify(diff(beforeData))
      const currentSort = JSON.stringify(diff(currentData))
      if (beforeSort === currentSort) return
      this.$emit('onAddDataToOperateArr', {
        key: `板件分类/大板顺序改变`,
        dataArr: [
          {
            type: 'form',
            current: { order: currentSort },
            ori: { order: beforeSort },
            compareMsg: [{ title: '', keys: ['order'] }],
            formTextObj: { order: '手动调整顺序' },
            formValueObj: {},
          },
        ],
      })
    },
    /**
     * @description 排序完成后处理需要重置的数据
     */
    sortDoneByDealData() {
      this.drawData.forEach((category) => {
        category.data.forEach((plank, partIndex) => {
          const { texture, matCode, thick } = plank
          plank.stockNum = partIndex + 1
          plank.stockKey = `${texture}:${matCode}:${thick}:${plank.stockNum}`
          plank.parts.forEach((part) => {
            part.stockNum = plank.stockNum
            part.stockKey = plank.stockKey
          })
        })
      })
    },
    /**
     * @description 处理排序完成后绘制数据的重置
     */
    sortDoneByDealDrawData() {
      this.drawData.forEach((category, index) => {
        category.data.forEach((plank, partIndex) => {
          plank.canvasIndex = this.clacplankIndex(index) + partIndex + 1
        })
      })
      this.renderAll()
    },
    calcActivePartCount(bigpart) {
      return bigpart.parts?.filter((e) => e.checked).length
    },
    dealHighlightMatCode(matcode) {
      return dealHighlightMatCode(matcode)
    },
    computedRealRectFopEdge() {
      const appliedSides = this.activePlank.edgePreMillingInfo
        ?.appliedSides || {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }
      let widthNum = 0
      let heightNum = 0
      widthNum = Number(appliedSides.right) + Number(appliedSides.left)
      heightNum = Number(appliedSides.top) + Number(appliedSides.bottom)
      return {
        width: widthNum,
        height: heightNum,
      }
    },
    /** 大板是否旋转过 */
    isRotateBigPlank(bigPlank) {
      bigPlank = bigPlank || this.bigpart
      return this.$props.checkBigPlankIsRotate([bigPlank])
    },

    // 获取补件数据
    /**
     * @description 获取补件数据
     * @param {string} 订单号
     */
    async handleGetBujianStoreData(oid = '') {
      try {
        this.bujianKeyword = oid
        const params = {
          colorTextureThickStr: this.currentBujianColorTextureThickStr,
          filterWord: oid,
        }
        if (!params.colorTextureThickStr) return
        await this.$store.dispatch('bujianStore/fetchBujianListByQuery', {
          queryKey: buildBujianQueryKey({
            ...params,
            pageScope: 'jinxi',
          }),
          pageScope: 'jinxi',
          params,
        })
      } catch (error) {
        console.error(error)
      }
    },
    updateCurrentBujianColorTextureThickStr() {
      const {
        allColors = [],
        matCode = '',
        thick = '',
        texture = '',
      } = this.bigpart || {}
      const keys = allColors.flatMap((color) => `${color}*${matCode}*${thick}`)
      const nextColorTextureThickStr = Array.from(
        new Set([...keys, `${texture}*${matCode}*${thick}`])
      ).join(',')
      if (nextColorTextureThickStr === this.currentBujianColorTextureThickStr) {
        return false
      }
      this.currentBujianColorTextureThickStr = nextColorTextureThickStr
      return true
    },
  },
  created() {
    // 第一次进入时计算canvas宽度, 220为左侧宽度, 316位右侧宽度, 48位topInfoHeight
    this.canvasWidth = document.body.offsetWidth - 220 - 316 - 48
    this.changeTempStorage()
  },
  async mounted() {
    EventBus.$on(EventBusKey.TRANSLATE, this.renderAll)
    this.resizeEvent = this.calcCanvasWidth()
    window.addEventListener('resize', this.resizeEvent)
    this.plankActiveNav =
      this.$store.state.preferencesSetting?.setting?.layoutStoreType ===
      'bujianStore'
        ? 'bujian'
        : 'zancun'
    this.drawData = JSON.parse(JSON.stringify(this.finalDrawData))
    for (let i = 0; i < this.drawData.length; ++i) {
      for (let k = 0; k < this.drawData[i].data.length; ++k) {
        this.drawData[i].data[k].orderIndex = this.clacplankIndex(i) + k + 1
        if (
          this.subtleData.stockKey == this.drawData[i].data[k].stockKey &&
          this.subtleData.canvasIndex == this.drawData[i].data[k].canvasIndex
        ) {
          Object.assign(this.drawData[i].data[k], {
            isActive: false,
          })
          this.bigpart = this.drawData[i].data[k]
        }
      }
    }
    this.bigpart.subtleStartX = 500
    this.bigpart.subtleStartY = 100
    this.dealCategory()
    this.startDraw()

    this.keyDownEvent = this.keyDownFuncs()
    window.addEventListener('keydown', this.keyDownEvent)
    // 监听键盘按键松开事件
    this.keyUpEvent = this.keyUpFuncs()
    window.addEventListener('keyup', this.keyUpEvent)
    // 监听鼠标滚轮事件
    this.mouseWheelEvent = this.mouseWheelFuncs()
    window.addEventListener('mousewheel', this.mouseWheelEvent, {
      passive: false,
    })
    this.mouseupEvent = this.mouseUpFuncs()
    // 监听鼠标松开事件
    window.addEventListener('mouseup', this.mouseupEvent)
    this.initBigPlanDeal()
    if (
      this.ncSetting.glass_setting &&
      this.ncSetting.glass_setting.contour_size_recoup
    ) {
      this.glassDilate = this.ncSetting.glass_setting.contour_size_recoup * 2
    }
    // 记录暂存区的id用于后续恢复
    this.recordAwaitStoreIds()
    // todo 功能存在问题代码暂停执行
    // this.trimSide = this.isHistoryStatus
    //   ? window.sessionStorage.getItem('trimSide')
    //   : this.ncSetting.trimSide
    // const newNC = await GetProductionNcSetting({
    //   setting_id: this.ncSetting.process_setting_id,
    // })
    // if (newNC.data.trimSide != this.trimSide) {
    //   this.isChangeTrimSide = true
    // } else {
    //   this.isChangeTrimSide = false
    // }
    this.$nextTick(() => this.addSortDragEvent())
  },
  watch: {
    subtleData: {
      deep: true,
      handler(val) {
        this.zoomNum = val.zoomNum ? val.zoomNum : 1
      },
    },
    bigpart: {
      handler(val) {
        if (val.zoomNum) {
          this.scale = this.oriScale * val.zoomNum
          this.zoomNum = val.zoomNum
        } else {
          this.scale = this.oriScale
          this.zoomNum = 1
        }
        this.scaleComputed()
        const isQueryConditionChanged =
          this.updateCurrentBujianColorTextureThickStr()
        if (isQueryConditionChanged && this.bigpart?.stockKey) {
          this.handleGetBujianStoreData(this.bujianKeyword)
        }
      },
      immediate: true,
    },
    activePlank: {
      immediate: true,
      handler(val) {
        this.$emit('subtle-active-plank-change', Boolean(val))
      },
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEvent)
    window.removeEventListener('keydown', this.keyDownEvent)
    window.removeEventListener('keyup', this.keyUpEvent)
    window.removeEventListener('mousewheel', this.mouseWheelEvent)
    window.removeEventListener('contextmenu', this.handleRightClick)
    EventBus.$off(EventBusKey.TRANSLATE, this.renderAll)
    this.setChangePaiban(false)
    this.removeSortDragEvent()
  },
}
</script>

<style scoped lang="less">
.subtle-page {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 16px;
  background: #eeeeee;
  .cutorigin-disable {
    color: rgba(0, 0, 0, 0.25) !important;
    cursor: not-allowed !important;
  }
  .left-category {
    flex-shrink: 0;
    width: 220px;
    height: calc(100vh - 90px);
    overflow: auto;
    background: #fff;
    padding: 5px 8px;
    /* 改造滚动条样式 */
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.05);
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.4);
    }
    &::-webkit-scrollbar-track {
      background-color: #eee;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-track:hover {
      background-color: #eee;
    }
    .category-title {
      cursor: pointer;
      padding: 6px 3px 0 3px;
    }
    .overflow-text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .big-part-info {
      height: 40px;
      padding: 0 3px 0 25px;
      line-height: 40px;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        color: #18a8c7;
      }
      &.active {
        color: #fff;
        background: rgba(24, 168, 199, 1);
      }
    }
    .big-part-disable {
      cursor: not-allowed;
    }
    .active-bigpart {
      background: #18a8c7;
      color: #fff !important;
      &:hover {
        background: #18a8c7;
      }
    }
  }
  .center-canvas {
    position: relative;
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0 24px;
    padding: 16px;
    overflow-x: scroll;
    background: #fff;
    /* 改造滚动条样式 */
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.05);
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.4);
    }
    &::-webkit-scrollbar-track {
      background-color: #eee;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-track:hover {
      background-color: #eee;
    }
    .surplus-menu {
      top: 80px;
      z-index: 999;
      .menu-box {
        width: 120px;
        .menu-title {
          border-bottom: 1px solid #ccc;
          background-color: #18a8c736;
        }
      }
      .active {
        color: #18a8c7;
      }
    }
    .top-operation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      .surplus-adsorb {
        margin: 0 15px 0 8px;
      }
    }
    .top-left-operation {
      display: flex;
      align-items: center;
      .ant-btn {
        margin-right: 8px;
      }
    }
    .top-right-operation {
      color: #fff;
      background: #18a8c7;
    }
    .batch-position {
      background: #e7e7e7;
    }
    .canvas-box {
      position: relative;
      #line_box {
        position: absolute;
        display: flex;
        align-items: center;
        height: 30px;
        user-select: none;
        .el-input {
          width: 80px;
          opacity: 0.5;
        }
        span {
          font-size: 12px;
        }
      }
    }
    .user-info {
      color: rgba(0, 0, 0, 0.2);
      font-weight: bold;
    }
  }
  .right-operation {
    width: 331px;
    background: #fff;
    overflow-y: auto;
    height: 100%;
    flex-shrink: 0;
    .tag-btn-box {
      padding: 16px;
      background: #fff;
      .tag {
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        height: 190px;
        margin-bottom: 16px;
        text-align: center;
        border: 1px dashed #999999;
        .no-active {
          span {
            display: block;
            color: #999999;
            font-size: 14px;
          }
        }
      }
      .stacking-method-box {
        .title {
          color: #999999;
          font-size: 14px;
        }
        .ant-radio-group {
          margin-top: 12px;
        }
        margin-bottom: 16px;
      }
      .plank-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 250px;
        margin-bottom: 16px;
        padding: 10px 8px;
        border: 1px solid #d9d9d9;
        position: relative;
        .left-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          span {
            display: block;
            width: 180px;
            overflow: hidden;
            color: #333;
            font-size: 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .right-qrcode {
          position: absolute;
          right: 10px;
          bottom: 15px;
        }
      }
      .btn {
        .title {
          color: #999999;
          font-size: 14px;
        }
        .operation-btn {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 12px;
          .ant-btn {
            width: 138px;
            height: 32px;
            margin: 4px 0;
          }
          .cutorigin {
            width: 138px;
            height: 32px;
            margin: 4px 0;
            border: 1px solid #dcdcdc;
            border-radius: 4px;
          }
          .cutorigin:hover {
            border: 1px solid #3bbdd4;
            color: #3bbdd4;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          }
          .cutorigin-active {
            color: #3bbdd4;
            background-color: #fff;
            border-color: #3bbdd4;
          }
          .cursor-not-allowed {
            cursor: not-allowed !important;
          }
          .cutorigin-disable {
            color: rgba(0, 0, 0, 0.25) !important;
            background-color: #f5f5f5;
            border-color: #dcdcdc;
          }
        }
      }
    }
    .modify-plank {
      width: 316px;
      background: #fff;
      .nav {
        display: flex;
        width: 100%;
        height: 40px;
        span {
          display: inline-block;
          width: 50%;
          color: #333;
          font-size: 14px;
          line-height: 40px;
          text-align: center;
          cursor: pointer;
          &.active {
            position: relative;
            color: #18a8c7;
            &::after {
              position: absolute;
              bottom: 0;
              left: 50%;
              width: 56px;
              height: 2px;
              background: #18a8c7;
              transform: translateX(-50%);
              content: '';
            }
          }
        }
      }
      .content-zancun {
        box-sizing: border-box;
        width: 100%;
        padding: 8px;
        overflow-y: scroll;
        background: #fff;
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.05);
        }
        &:hover::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.2);
          border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0, 0, 0, 0.4);
        }
        &::-webkit-scrollbar-track {
          background-color: #fff;
          border-radius: 10px;
        }
        &::-webkit-scrollbar-track:hover {
          background-color: #fff;
        }
        .plank-item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          float: left;
          box-sizing: border-box;
          width: 50%;
          height: 180px;
          padding: 8px 0;
          text-align: center;
          border: 1px solid rgba(229, 229, 229, 1);
          border-top: none;
          // border-right: 1px solid rgba(229, 229, 229, 1);
          &:first-child {
            border-top: 1px solid rgba(229, 229, 229, 1);
          }
          &:nth-child(2) {
            border-top: 1px solid rgba(229, 229, 229, 1);
          }
          &:nth-child(2n) {
            border-left: none;
          }
          img {
            display: block;
            margin: 0 auto;
          }
          .plank-title {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: default;
          }
        }
      }
      .plan-group {
        display: flex;
        flex-wrap: wrap;
        // justify-content: center;
        box-sizing: border-box;
        width: 100%;
        height: calc(100vh - 32px - 60px - 346px);
        max-height: calc(100vh - 32px - 60px - 346px - 70px);
        padding: 16px;
        overflow-y: scroll;
        background: #fff;
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.05);
        }
        &:hover::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.2);
          border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0, 0, 0, 0.4);
        }
        &::-webkit-scrollbar-track {
          background-color: #fff;
          border-radius: 10px;
        }
        &::-webkit-scrollbar-track:hover {
          background-color: #fff;
        }
        .plan-item {
          border-bottom: 1px solid #ccc;
        }
      }
    }
  }
  .origin-dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: #0008;
  }
  .origin-dialog {
    position: fixed;
    top: 135px;
    right: 75px;
    width: 333px;
    height: 228px;
    margin: auto;
    background: #fff;
    .origin-dialog-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 100%;
      height: 56px;
      padding: 0 24px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      span {
        color: #333;
        font-size: 16px;
        cursor: default;
      }
      .icon-close {
        cursor: pointer;
      }
    }
    .origin-btn {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 100%;
      padding: 24px 24px 16px 24px;
      color: #333;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      .ant-btn {
        width: 138px;
        height: 32px;
        margin-bottom: 8px;
        border-radius: 2px;
      }
      .ant-btn.active {
        color: #18a8c7;
        border-color: #18a8c7;
      }
    }
    .origin-dialog-btns {
      display: flex;
      justify-content: flex-end;
      box-sizing: border-box;
      padding: 10px;
      > div {
        .ant-btn {
          width: 65px;
          height: 32px;
          &:last-child {
            color: #fff;
            background: #18a8c7;
            border: none;
          }
        }
      }
    }
  }
  .loading-box {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000000000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
    background: #0008;
  }
}
.locked-btn {
  background-color: #ccc !important;
  color: #fff !important;
}

.is-end {
  color: #f00 !important;
  border-color: #f00 !important;
}
.warning {
  color: #f00;
}
/* 拖动时占位的幽灵元素样式 */
.drag-ghost {
  opacity: 1 !important;
  background-color: rgba(64, 158, 255, 0.15) !important;
  border: 2px dashed #409eff !important;
  border-radius: 4px !important;
  position: relative !important;
}

/* 隐藏幽灵元素内部的所有子元素，只显示占位框 */
.drag-ghost * {
  opacity: 0 !important;
  visibility: hidden !important;
}

/* 在幽灵元素中央显示插入提示 */
.drag-ghost::after {
  content: '插入到此位置' !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  color: #409eff !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  white-space: nowrap !important;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: none !important;
}

/* 被选中准备拖动的元素样式 */
.drag-chosen {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  border: 1px solid #409eff;
  border-radius: 4px;
  transition: all 0.2s ease;
}

/* 正在拖动的元素样式 */
.drag-active {
  transform: scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  opacity: 0.9;
  z-index: 9999;
  transition: none;
  cursor: grabbing;
}

/* fallback模式下跟随鼠标的元素样式（备用） */
.drag-fallback {
  opacity: 0.9 !important;
  transform: scale(1.05) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25) !important;
  border: 2px solid #409eff !important;
  border-radius: 4px !important;
  cursor: grabbing !important;
  z-index: 10000 !important;
}

/* 拖动手柄样式 */
.anticon-menu {
  cursor: grab !important;
  transition: color 0.2s ease !important;
}

.anticon-menu:hover {
  color: #409eff !important;
  cursor: grab !important;
}

.anticon-menu:active {
  cursor: grabbing !important;
}
</style>

<style lang="less">
.sur-store-modal {
  .ant-modal-header {
    border-bottom: none;
  }
  .ant-modal-footer {
    border-top: none;
    .ant-btn:first-child {
      display: none;
    }
  }
}
</style>
